import React from "react";
import { AI_STAR_VIEWBOX, GOOGLE_MATERIAL_VIEWBOX, svgIcon } from "./icons";

export const IconAccessibilitySimplified = svgIcon({
	default: {
		element: (
			<path d="M479.75-696q-34.75 0-59.25-24.75t-24.5-59.5q0-34.75 24.75-59.25t59.5-24.5q34.75 0 59.25 24.75t24.5 59.5q0 34.75-24.75 59.25t-59.5 24.5ZM360-108v-463q-55-4-108.5-16T144-613l18-67q78 21 157.5 32.5T480-636q81 0 160.5-11.5T798-680l18 67q-54 14-107.5 26T600-570.55V-108h-72l-9-222h-77l-10 222h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAccessibilitySimulator = svgIcon({
	default: {
		element: (
			<>
				<path
					d="M20.159 1.48116C19.7686 1.24736 19.3195 1.12969 18.8646 1.14193C17.5006 1.14193 15.671 1.98361 13.6201 3.59174C12.6876 4.32129 11.9864 4.84077 11.0439 5.81303C12.9118 7.3871 13.3461 7.89522 14.4802 9.00658C16.7086 9.22516 18.6985 9.75316 20.5579 10.3493C20.7745 9.67383 20.9551 8.98731 21.0987 8.29264C21.858 4.81522 21.5159 2.33277 20.159 1.48116Z"
					fill="url(#paint0_linear_13464_2385)"
				/>
				<path
					d="M18.562 14.9863C19.1553 13.7188 19.7769 12.4712 20.1971 11.2648C18.6599 10.7737 16.951 10.5097 15.1328 10.2868C16.3779 11.7763 17.5234 13.3462 18.562 14.9863Z"
					fill="url(#paint1_linear_13464_2385)"
				/>
				<path
					d="M8.19043 9.2649C9.2592 9.18826 10.1775 9.22658 11.2946 9.24645C11.8557 9.25497 12.4111 9.27673 12.9609 9.31174C12.3122 8.63187 12.2384 8.41613 11.5231 7.80723C11.2761 7.59858 10.7027 7.04219 10.4628 6.8591C9.73185 7.64968 8.90295 8.36219 8.19043 9.2649Z"
					fill="url(#paint2_linear_13464_2385)"
				/>
				<path
					d="M10.6205 10.2372C8.67598 10.2939 8.67314 10.2584 7.56179 10.3961C6.73856 11.3897 5.78617 12.721 5.02114 13.8182C4.73727 14.2156 4.4903 14.6301 4.2334 15.0275C5.56759 17.6874 7.18708 20.2323 10.348 22.9361C12.873 21.4501 15.9161 18.7561 17.7017 15.8606C16.3916 13.9871 15.1255 11.9858 13.5231 10.3564"
					fill="url(#paint3_radial_13464_2385)"
				/>
				<path
					d="M3.6774 13.7983C3.80656 13.5868 3.93572 13.4463 4.06772 13.2306C4.69224 12.237 5.34514 11.2719 6.01224 10.3493C5.01869 10.4799 4.10605 10.7325 3.13379 10.9667C3.17069 11.235 3.21327 11.5103 3.26437 11.7914C3.38927 12.4854 3.48153 13.0645 3.6774 13.7983Z"
					fill="url(#paint4_linear_13464_2385)"
				/>
				<path
					d="M4.4565 5.02955C3.30825 5.68387 2.83134 7.30194 3.05276 9.88942C4.28739 9.5642 5.5426 9.32283 6.80979 9.16697C7.67757 8.11095 8.62008 7.11863 9.63005 6.19768C8.16528 5.18993 6.69057 4.73432 5.64308 4.73432C5.22839 4.72592 4.81891 4.8278 4.4565 5.02955Z"
					fill="url(#paint5_linear_13464_2385)"
				/>
				<path
					d="M13.1028 13.2831C13.1028 13.2831 11.4123 13.4449 10.6899 13.4449C9.96741 13.4449 8.3536 13.2831 8.3536 13.2831C8.1639 13.2745 8.00312 13.4213 7.9945 13.611C7.98588 13.8007 8.13267 13.9614 8.32237 13.9701H8.3536C8.3536 13.9701 9.8127 14.0254 9.96882 14.2184C10.125 14.4115 10.0653 15.6563 9.96882 15.9217C9.87231 16.1871 8.80921 18.6866 8.80921 18.6866C8.76118 18.7775 8.75125 18.8837 8.78159 18.982C8.81194 19.0802 8.88008 19.1624 8.97102 19.2103C9.16082 19.3096 9.39518 19.2374 9.49618 19.0485C9.49618 19.0485 10.4102 16.9734 10.6828 16.7321C10.7071 16.7152 10.7393 16.7152 10.7637 16.7321C10.7931 16.7603 10.8193 16.7918 10.8417 16.8258C11.1795 17.3013 11.9488 19.0443 11.9488 19.0443C12.0488 19.2335 12.2828 19.3064 12.4726 19.2075C12.6612 19.107 12.7339 18.8736 12.6358 18.6837C12.6358 18.6837 11.5713 16.18 11.4748 15.9174C11.3782 15.6548 11.3328 14.3944 11.4748 14.2142C11.6167 14.0339 13.0957 13.9644 13.0957 13.9644C13.2065 13.9692 13.3129 13.9203 13.3816 13.8331C13.4502 13.7459 13.4727 13.631 13.442 13.5244C13.4278 13.4708 13.4 13.4219 13.3611 13.3824C13.2912 13.3118 13.1949 13.2737 13.0957 13.2774L13.1028 13.2831Z"
					fill="white"
				/>
				<path
					d="M10.7275 13.238C11.2798 13.238 11.7275 12.7903 11.7275 12.238C11.7275 11.6857 11.2798 11.238 10.7275 11.238C10.1753 11.238 9.72754 11.6857 9.72754 12.238C9.72754 12.7903 10.1753 13.238 10.7275 13.238Z"
					fill="white"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_13464_2385"
						x1="19.164"
						y1="3.6911"
						x2="1.39196"
						y2="30.0243"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#DA4140" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_13464_2385"
						x1="12.6021"
						y1="3.48377"
						x2="18.8352"
						y2="14.2779"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#479982" />
						<stop offset="0.4" stopColor="#499A83" />
						<stop offset="0.54" stopColor="#509E88" />
						<stop offset="0.64" stopColor="#5BA490" />
						<stop offset="0.73" stopColor="#6CAE9B" />
						<stop offset="0.8" stopColor="#82BAAA" />
						<stop offset="0.86" stopColor="#9EC9BD" />
						<stop offset="0.92" stopColor="#BEDBD3" />
						<stop offset="0.97" stopColor="#E2EFEB" />
						<stop offset="1" stopColor="white" />
					</linearGradient>
					<linearGradient
						id="paint2_linear_13464_2385"
						x1="10.5849"
						y1="11.0163"
						x2="10.5819"
						y2="7.90644"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="0.1" stopColor="#FAFAFA" />
						<stop offset="0.23" stopColor="#EBEBEB" />
						<stop offset="0.36" stopColor="#D2D2D2" />
						<stop offset="0.5" stopColor="#B0B0B0" />
						<stop offset="0.65" stopColor="#848484" />
						<stop offset="0.81" stopColor="#4D4D4D" />
						<stop offset="0.97" stopColor="#0F0F0F" />
						<stop offset="1" />
					</linearGradient>
					<radialGradient
						id="paint3_radial_13464_2385"
						cx="0"
						cy="0"
						r="1"
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(10.78 16.8443) scale(6.54034 6.54035)"
					>
						<stop stopColor="#01039B" />
						<stop offset="1" stopColor="#010368" />
					</radialGradient>
					<linearGradient
						id="paint4_linear_13464_2385"
						x1="8.48486"
						y1="9.85252"
						x2="3.58671"
						y2="11.681"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="1" stopColor="#B8860B" />
					</linearGradient>
					<linearGradient
						id="paint5_linear_13464_2385"
						x1="4.05908"
						y1="9.22224"
						x2="6.35182"
						y2="5.25194"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="white" />
						<stop offset="1" stopColor="#6E266B" />
					</linearGradient>
				</defs>
			</>
		),
	},
});

export const IconAccessibility = svgIcon({
	default: {
		element: (
			<path d="M479.75-696q-34.75 0-59.25-24.75t-24.5-59.5q0-34.75 24.75-59.25t59.5-24.5q34.75 0 59.25 24.75t24.5 59.5q0 34.75-24.75 59.25t-59.5 24.5ZM360-108v-463q-55-4-108.5-16T144-613l18-67q78 21 157.5 32.5T480-636q81 0 160.5-11.5T798-680l18 67q-54 14-107.5 26T600-570.55V-108h-72l-9-222h-77l-10 222h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAdd = svgIcon({
	default: {
		element: <path d="M444-444H240v-72h204v-204h72v204h204v72H516v204h-72v-204Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAddComment = svgIcon({
	default: {
		element: (
			<path d="M444-384h72v-132h132v-72H516v-132h-72v132H312v72h132v132ZM96-96v-696q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H240L96-96Zm114-216h582v-480H168v522l42-42Zm-42 0v-480 480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAddKeyword = svgIcon({
	default: {
		element: (
			<>
				<path d="M9.2 16.6C10.7 16.6 11.975 16.075 13.025 15.025C14.075 13.975 14.6 12.7 14.6 11.2C14.6 9.7 14.075 8.425 13.025 7.375C11.975 6.325 10.7 5.8 9.2 5.8C7.7 5.8 6.425 6.325 5.375 7.375C4.325 8.425 3.8 9.7 3.8 11.2C3.8 12.7 4.325 13.975 5.375 15.025C6.425 16.075 7.7 16.6 9.2 16.6ZM6.05 10.3V8.5H12.35V10.3H6.05ZM18.74 22L13.6325 16.8925C13.0175 17.3725 12.335 17.7437 11.585 18.0062C10.835 18.2687 10.04 18.4 9.2 18.4C7.19 18.4 5.4875 17.7025 4.0925 16.3075C2.6975 14.9125 2 13.21 2 11.2C2 9.19 2.6975 7.4875 4.0925 6.0925C5.4875 4.6975 7.19 4 9.2 4C11.21 4 12.9125 4.6975 14.3075 6.0925C15.7025 7.4875 16.4 9.19 16.4 11.2C16.4 12.04 16.2687 12.835 16.0062 13.585C15.7437 14.335 15.3725 15.0175 14.8925 15.6325L20 20.74L18.74 22Z" />
				<path d="M6.05 11.65V13.45H9.65V11.65H6.05Z" />
				<path d="M18 6V8H20V6H22V4H20V2H18V4H16V6H18Z" />
			</>
		),
	},
});
export const IconAddDocument = svgIcon({
	default: {
		element: (
			<>
				<path d="M20 8V12H18V9H13V4H6V20H13V22H6C5.45 22 4.97956 21.8038 4.58789 21.4121C4.19622 21.0204 4 20.55 4 20V4C4 3.45 4.19622 2.97956 4.58789 2.58789C4.97956 2.19622 5.45 2 6 2H14L20 8Z" />
				<path d="M17 19V21H19V19H21V17H19V15H17V17H15V19H17Z" />
			</>
		),
	},
});
export const IconAdGroup = svgIcon({
	default: {
		element: (
			<path d="M312-312h480v-408H312v408Zm0 72q-29.7 0-50.85-21.15Q240-282.3 240-312v-480q0-29.7 21.15-50.85Q282.3-864 312-864h480q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H312ZM168-96q-29.7 0-50.85-21.15Q96-138.3 96-168v-552h72v552h552v72H168Zm144-696v480-480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconAnalyticsServices = svgIcon({
	default: {
		element: (
			<path d="m147-209-51-51 281-281 152 152 212-211H624v-72h240v240h-72v-117L529-287 377-439 147-209Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAnalysis = svgIcon({
	default: {
		element: (
			<path d="M407.74-240Q378-240 357-261.15 336-282.3 336-312v-67q-57-37.3-88.5-95.65Q216-533 216-600q0-110.31 76.78-187.16 76.78-76.84 187-76.84T667-787.16q77 76.85 77 187.16 0 66.82-31.5 125.41T624-379v67q0 29.7-21.18 50.85Q581.65-240 551.91-240H407.74Zm.26-72h144v-106l33-21q41-26 64-69.18 23-43.18 23-91.82 0-79.68-56.23-135.84-56.22-56.16-136-56.16Q400-792 344-735.84 288-679.68 288-600q0 48.64 23 91.82Q334-465 375-439l33 21v106Zm0 216q-20.4 0-34.2-13.8Q360-123.6 360-144v-24h240v24q0 20.4-13.8 34.2Q572.4-96 552-96H408Zm72-504Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconAppAnalytics = svgIcon({
	default: {
		element: (
			<>
				<path d="M7 23C6.45 23 5.97917 22.8042 5.5875 22.4125C5.19583 22.0208 5 21.55 5 21V3C5 2.45 5.19583 1.97917 5.5875 1.5875C5.97917 1.19583 6.45 1 7 1H17C17.55 1 18.0208 1.19583 18.4125 1.5875C18.8042 1.97917 19 2.45 19 3V8H17V3H7V21H17V19H19V21C19 21.55 18.8042 22.0208 18.4125 22.4125C18.0208 22.8042 17.55 23 17 23H7ZM12 6C12.2833 6 12.5208 5.90417 12.7125 5.7125C12.9042 5.52083 13 5.28333 13 5C13 4.71667 12.9042 4.47917 12.7125 4.2875C12.5208 4.09583 12.2833 4 12 4C11.7167 4 11.4792 4.09583 11.2875 4.2875C11.0958 4.47917 11 4.71667 11 5C11 5.28333 11.0958 5.52083 11.2875 5.7125C11.4792 5.90417 11.7167 6 12 6Z" />
				<path d="M9 16.1L10.4 17.5L13.425 14.5L15.425 16.5L20.5 11.4L19.1 10L15.425 13.675L13.425 11.675L9 16.1Z" />
			</>
		),
	},
});

export const IconApprove = svgIcon({
	default: {
		element: (
			<path d="M720-144H264v-480l288-288 32 22q17 12 26 30.5t5 38.5l-1 5-38 192h264q30 0 51 21t21 51v57q0 8-1.5 14.5T906-467L786.93-187.8Q778-168 760-156t-40 12Zm-384-72h384l120-279v-57H488l49-243-201 201v378Zm0-378v378-378Zm-72-30v72H120v336h144v72H48v-480h216Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconApproveFilled = svgIcon({
	default: {
		element: (
			<path d="M720-120H320v-520l280-280 50 50q7 7 11.5 19t4.5 23v14l-44 174h218q32 0 56 24t24 56v80q0 7-1.5 15t-4.5 15L794-168q-9 20-30 34t-44 14ZM240-640v520H80v-520h160Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAreaChart = svgIcon({
	default: {
		element: (
			<path d="M144-192v-480l144 96 192-240 192 144h144v480H144Zm192-120 144-197 264 211v-302h-96L492-717 303-480l-87-58v136l120 90Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconArrow = svgIcon({
	default: {
		element: <path d="M444-768v438L243-531l-51 51 288 288 288-288-51-51-201 201v-438h-72Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconArrowUp = svgIcon({
	default: {
		element: <path d="M444-192v-438L243-429l-51-51 288-288 288 288-51 51-201-201v438h-72Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconArrowLeft = svgIcon({
	default: {
		element: <path d="m330-444 201 201-51 51-288-288 288-288 51 51-201 201h438v72H330Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconArrowRight = svgIcon({
	default: {
		element: <path d="M630-444H192v-72h438L429-717l51-51 288 288-288 288-51-51 201-201Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconArrowDownLeft = svgIcon({
	default: {
		element: <path d="M384-192 168-408l216-216 51 51-129 129h342v-372h72v444H306l129 129-51 51Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconArrowDownRight = svgIcon({
	default: {
		element: <path d="m576-192-51-51 129-129H240v-444h72v372h342L525-573l51-51 216 216-216 216Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconArrowUpLeft = svgIcon({
	default: {
		element: (
			<path d="M648-192v-372H306l129 129-51 51-216-216 216-216 51 51-129 129h414v444h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconArrowUpRight = svgIcon({
	default: {
		element: (
			<path d="M240-192v-444h414L525-765l51-51 216 216-216 216-51-51 129-129H312v372h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconAssignment = svgIcon({
	default: {
		element: (
			<path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h171q8-31 33.5-51.5T480-888q34 0 59.5 20.5T573-816h171q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm0-72h528v-528H216v528Zm72-72h288v-72H288v72Zm0-156h384v-72H288v72Zm0-156h384v-72H288v72Zm192-168q10.4 0 17.2-6.8 6.8-6.8 6.8-17.2 0-10.4-6.8-17.2-6.8-6.8-17.2-6.8-10.4 0-17.2 6.8-6.8 6.8-6.8 17.2 0 10.4 6.8 17.2 6.8 6.8 17.2 6.8ZM216-216v-528 528Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconAssistiveTechnology = svgIcon({
	default: {
		element: (
			<path d="M12 3C12.3521 3 12.6644 3.22534 12.7758 3.5593L14.6918 9.30735L20.4407 11.2242C20.7747 11.3356 21 11.6479 21 12C21 12.3521 20.7747 12.6644 20.4407 12.7758L14.6918 14.6918L12.7758 20.4407C12.6644 20.7747 12.3521 21 12 21C11.6479 21 11.3356 20.7747 11.2242 20.4407L9.30735 14.6918L3.5593 12.7758C3.22534 12.6644 3 12.3521 3 12C3 11.6479 3.22534 11.3356 3.5593 11.2242L9.30735 9.30735L11.2242 3.5593L11.2745 3.43945C11.4138 3.17247 11.6918 3 12 3ZM10.7304 10.2134C10.6489 10.4575 10.4575 10.6489 10.2134 10.7304L6.40456 12L10.2134 13.2696L10.3021 13.3048C10.5036 13.3993 10.6591 13.5728 10.7304 13.7866L12 17.5954L13.2696 13.7866L13.3048 13.6979C13.3993 13.4964 13.5728 13.3409 13.7866 13.2696L17.5954 12L13.7866 10.7304C13.5728 10.6591 13.3993 10.5036 13.3048 10.3021L13.2696 10.2134L12 6.40456L10.7304 10.2134Z" />
		),
	},
});

export const IconAudio = svgIcon({
	default: {
		element: (
			<path d="M408-144q-60 0-102-42t-42-102q0-60 42-102t102-42q20 0 38 5.5t34 14.5v-404h216v144H552v384q0 60-42 102t-102 42Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconBackgroundColor = svgIcon({
	default: {
		element: (
			<path d="m216-909 51-51 338 338q20 20 19.5 47T605-529L431-355q-20 20-47 20t-47-20L163-530q-19-19-20-46t20-47l170-169-117-117Zm168 168L219-576h1-1 330L384-741Zm348 453q-35 0-59.5-24.5T648-372q0-20 10.5-42.5T692-469q8-11 18.5-24t21.5-26q10 13 20.5 25.5T772-469q16 23 30 47t14 50q0 35-24.5 59.5T732-288ZM96 0v-192h768V0H96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconBacklink = svgIcon({
	default: {
		element: (
			<path d="M336-192 192-336l144-144 51 51-57 57h150v72H330l57 57-51 51Zm252.21-108q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Zm144 0q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5ZM672-480l-51-51 57-57H528v-72h150l-57-57 51-51 144 144-144 144ZM276.21-588q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Zm144 0q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconBacklog = svgIcon({
	default: {
		element: (
			<path d="M2.8498 16.075C2.63314 15.5917 2.45814 15.0917 2.3248 14.575C2.19147 14.0583 2.0998 13.5333 2.0498 13H4.0748C4.1248 13.35 4.19564 13.7 4.2873 14.05C4.37897 14.4 4.49147 14.7417 4.6248 15.075L2.8498 16.075ZM2.0498 11C2.0998 10.4667 2.19147 9.9375 2.3248 9.4125C2.45814 8.8875 2.64147 8.38334 2.8748 7.9L4.6248 8.9C4.49147 9.23334 4.37897 9.575 4.2873 9.925C4.19564 10.275 4.1248 10.6333 4.0748 11H2.0498ZM6.1748 20.15C5.7248 19.8167 5.30814 19.4542 4.9248 19.0625C4.54147 18.6708 4.18314 18.25 3.8498 17.8L5.5998 16.8C5.83314 17.1 6.07897 17.3792 6.3373 17.6375C6.59564 17.8958 6.8748 18.1417 7.1748 18.375L6.1748 20.15ZM5.6248 7.175L3.8498 6.175C4.18314 5.725 4.54147 5.30834 4.9248 4.925C5.30814 4.54167 5.7248 4.18334 6.1748 3.85L7.1748 5.625C6.89147 5.85834 6.62064 6.10417 6.3623 6.3625C6.10397 6.62084 5.85814 6.89167 5.6248 7.175ZM10.9998 21.95C10.4665 21.9 9.9373 21.8083 9.4123 21.675C8.8873 21.5417 8.38314 21.3583 7.8998 21.125L8.8998 19.375C9.23314 19.5083 9.5748 19.6208 9.9248 19.7125C10.2748 19.8042 10.6331 19.875 10.9998 19.925V21.95ZM8.8998 4.625L7.8998 2.875C8.38314 2.64167 8.8873 2.45834 9.4123 2.325C9.9373 2.19167 10.4665 2.1 10.9998 2.05V4.075C10.6331 4.125 10.2748 4.19584 9.9248 4.2875C9.5748 4.37917 9.23314 4.49167 8.8998 4.625ZM12.9998 21.95V19.925C13.3665 19.875 13.7248 19.8042 14.0748 19.7125C14.4248 19.6208 14.7665 19.5083 15.0998 19.375L16.0998 21.125C15.6165 21.3583 15.1123 21.5417 14.5873 21.675C14.0623 21.8083 13.5331 21.9 12.9998 21.95ZM15.0998 4.625C14.7665 4.49167 14.4248 4.37917 14.0748 4.2875C13.7248 4.19584 13.3665 4.125 12.9998 4.075V2.05C13.5331 2.1 14.0623 2.19167 14.5873 2.325C15.1123 2.45834 15.6165 2.64167 16.0998 2.875L15.0998 4.625ZM17.8248 20.15L16.8248 18.375C17.1081 18.1417 17.379 17.8958 17.6373 17.6375C17.8956 17.3792 18.1415 17.1083 18.3748 16.825L20.1498 17.825C19.8165 18.275 19.4581 18.6958 19.0748 19.0875C18.6915 19.4792 18.2748 19.8333 17.8248 20.15ZM18.3748 7.175C18.1415 6.89167 17.8956 6.62084 17.6373 6.3625C17.379 6.10417 17.1081 5.85834 16.8248 5.625L17.8248 3.85C18.2748 4.16667 18.6915 4.51667 19.0748 4.9C19.4581 5.28334 19.8081 5.7 20.1248 6.15L18.3748 7.175ZM19.9248 11C19.8748 10.6333 19.804 10.275 19.7123 9.925C19.6206 9.575 19.5081 9.23334 19.3748 8.9L21.1248 7.875C21.3415 8.375 21.5206 8.8875 21.6623 9.4125C21.804 9.9375 21.8998 10.4667 21.9498 11H19.9248ZM21.1248 16.1L19.3748 15.1C19.5081 14.7667 19.6206 14.425 19.7123 14.075C19.804 13.725 19.8748 13.3667 19.9248 13H21.9498C21.8998 13.5333 21.8081 14.0625 21.6748 14.5875C21.5415 15.1125 21.3581 15.6167 21.1248 16.1Z" />
		),
	},
});
export const IconBarChart = svgIcon({
	default: {
		element: <path d="M4 16H11V20H4V16ZM4 10H20V14H4V10ZM4 4H15V8H4V4Z" />,
	},
});

export const IconBlock = svgIcon({
	default: {
		element: (
			<path d="M480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q55 0 104-18t89-50L236-673q-32 40-50 89t-18 104q0 130 91 221t221 91Zm244-119q32-40 50-89t18-104q0-130-91-221t-221-91q-55 0-104 18t-89 50l437 437Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconBorderColor = svgIcon({
	default: {
		element: (
			<path d="M96 0v-192h768V0H96Zm168-360h51l279-279-26-27-25-24-279 279v51Zm-72 72v-152.92L594-843q11-11 23.84-16 12.83-5 27-5 14.16 0 27.16 5t24.1 15.94L747-792q11 11 16 24t5 27.4q0 13.49-4.95 26.54-4.95 13.05-15.75 23.85L345-288H192Zm503-455-51-49 51 49ZM594-639l-26-27-25-24 51 51Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconBubbleChart = svgIcon({
	default: {
		element: (
			<path d="M588-144q-45 0-76.5-31.5T480-252q0-45 31.5-76.5T588-360q45 0 76.5 31.5T696-252q0 45-31.5 76.5T588-144Zm-.21-72q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm72.43-192Q575-408 515.5-467.28T456-611.78q0-85.22 59.28-144.72t144.5-59.5q85.22 0 144.72 59.28t59.5 144.5q0 85.22-59.28 144.72T660.22-408Zm-.22-72q55 0 93.5-38.5T792-612q0-55-38.5-93.5T660-744q-55 0-93.5 38.5T528-612q0 55 38.5 93.5T660-480ZM289.13-240q-59.86 0-102.5-42Q144-324 144-384t42-102q42-42 102-42t102 42q42 42 42 102t-41.5 102q-41.5 42-101.37 42Zm-.92-72Q318-312 339-333.21t21-51Q360-414 338.79-435t-51-21Q258-456 237-434.79t-21 51Q216-354 237.21-333t51 21ZM588-252Zm72-360ZM288-384Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconCampaign = svgIcon({
	default: {
		element: (
			<path d="M720-444v-72h144v72H720Zm41 276-118-82 42-59 118 82-42 59Zm-77-483-41-59 118-82 41 59-118 82ZM192-192v-192h-24q-29.7 0-50.85-21.15Q96-426.3 96-456v-48q0-29.7 21.15-50.85Q138.3-576 168-576h139l221-132v456L313-384h-25v192h-96Zm264-189v-200l-129 77H168v48h166l122 75Zm120 18v-234q23 22 35.5 53t12.5 64q0 33-12.5 64T576-363ZM312-481Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCancel = svgIcon({
	default: {
		element: (
			<path d="m339-288 141-141 141 141 51-51-141-141 141-141-51-51-141 141-141-141-51 51 141 141-141 141 51 51ZM480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconCalendarArrowUp = svgIcon({
	default: {
		element: (
			<>
				<path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V12H19V10H5V20H15V22H5ZM5 8H19V6H5V8Z" />
				<path d="M18.5 22V17.8L17.4 18.9L16 17.5L19.5 14L23 17.5L21.575 18.9L20.5 17.825V22H18.5Z" />
			</>
		),
	},
});
export const IconCalendarArrowDown = svgIcon({
	default: {
		element: (
			<>
				<path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V12H19V10H5V20H15V22H5ZM5 8H19V6H5V8Z" />
				<path d="M18.5 14V18.2L17.4 17.1L16 18.5L19.5 22L23 18.5L21.575 17.1L20.5 18.175V14H18.5Z" />
			</>
		),
	},
});
export const IconCaret = svgIcon({
	default: {
		element: <path d="M480-384 288-576h384L480-384Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCaretUp = svgIcon({
	default: {
		element: <path d="m288-384 192-192 192 192H288Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCaretLeft = svgIcon({
	default: {
		element: <path d="M576-288 384-480l192-192v384Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCaretRight = svgIcon({
	default: {
		element: <path d="M384-288v-384l192 192-192 192Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconChatBubble = svgIcon({
	default: {
		element: (
			<path d="M96-96v-696q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H240L96-96Zm114-216h582v-480H168v522l42-42Zm-42 0v-480 480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconClearConversation = svgIcon({
	default: {
		element: (
			<path d="M9.4 14L12 11.4L14.6 14L16 12.6L13.4 10L16 7.4L14.6 6L12 8.6L9.4 6L8 7.4L10.6 10L8 12.6L9.4 14ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z" />
		),
	},
});
export const IconChevron = svgIcon({
	default: {
		element: <path d="M480-333 240-573l51-51 189 189 189-189 51 51-240 240Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconChevronUp = svgIcon({
	default: {
		element: <path d="M480-525 291-336l-51-51 240-240 240 240-51 51-189-189Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconChevronLeft = svgIcon({
	default: {
		element: <path d="M576-240 336-480l240-240 51 51-189 189 189 189-51 51Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconChevronRight = svgIcon({
	default: {
		element: <path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconChevronWithLine = svgIcon({
	default: {
		element: (
			<path d="M288-288v-384h72v384h-72Zm384 0L480-480l192-192 51 51-141 141 141 141-51 51Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconChevronWithLineRight = svgIcon({
	default: {
		element: (
			<path d="m336-288-51-51 141-141-141-141 51-51 192 192-192 192Zm312 0v-384h72v384h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconClickMap = svgIcon({
	default: {
		element: (
			<path d="M464-96q-24 0-45-10t-37-28L155-397l29-29q15-15 36-20t41 3l75 30v-319q0-15.3 10.29-25.65Q356.58-768 371.79-768t25.71 10.35q10.5 10.36 10.5 25.67V-307l-121-48 150 175q5.23 5.6 12.19 8.8 6.97 3.2 14.81 3.2h160q29.7 0 50.85-21.15Q696-210.3 696-240v-170q0-10-7.47-16-7.48-6-18.53-6H480v-72h190q40 0 69 27t29 67v170q0 60-42 102T624-96H464ZM195-606q-13-23-20-48.5t-7-53.24q0-85.26 59.74-144.76 59.74-59.5 144.5-59.5 84.76 0 144.26 59.67Q576-792.66 576-708q0 28-7 53.5T549-606l-63-36q8-14 13-31t5-35q0-55-38.5-93.5T372-840q-55 0-93.5 38.5T240-708q0 18 5 35t13 31l-63 36Zm297 270Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconClockArrowUp = svgIcon({
	default: {
		element: (
			<path d="M360-216q-110 0-187-77T96-480q0-110 77-187t187-77q110 0 187 77t77 187q0 110-77 187t-187 77Zm372 24v-437l-33 33-51-51 120-120 119 119-50 52-33-33v437h-72Zm-372.21-96Q440-288 496-343.79q56-55.8 56-136Q552-560 496.21-616q-55.8-56-136-56Q280-672 224-616.21q-56 55.8-56 136Q168-400 223.79-344q55.8 56 136 56ZM420-372l51-51-75-75v-126h-72v156l96 96Zm-60-108Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconClockArrowDown = svgIcon({
	default: {
		element: (
			<path d="M360-216q-110 0-187-77T96-480q0-110 77-187t187-77q110 0 187 77t77 187q0 110-77 187t-187 77Zm407 24L648-311l50-52 33 34v-438h72v437l33-33 51 51-120 120Zm-407.21-96Q440-288 496-343.79q56-55.8 56-136Q552-560 496.21-616q-55.8-56-136-56Q280-672 224-616.21q-56 55.8-56 136Q168-400 223.79-344q55.8 56 136 56ZM420-372l51-51-75-75v-126h-72v156l96 96Zm-60-108Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconClose = svgIcon({
	default: {
		element: (
			<path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconCms = svgIcon({
	default: {
		element: (
			<path d="M6.40310078,16.6356589 C6.13436558,16.8630502 5.77519605,17.0284233 5.3255814,17.1317829 C4.87596674,17.2351426 4.42894279,17.2868217 3.98449612,17.2868217 C3.4263538,17.2868217 2.90697915,17.1912154 2.42635659,17 C1.94573403,16.8087846 1.52454961,16.4909583 1.1627907,16.0465116 C0.801031783,15.602065 0.516795866,15.0180915 0.310077519,14.2945736 C0.10335814,13.5710558 0,12.6821758 0,11.627907 C0,10.5322943 0.116277907,9.62274264 0.348837209,8.89922481 C0.581396512,8.17570698 0.886303023,7.59948535 1.26356589,7.17054264 C1.64082876,6.74159992 2.07234899,6.43927736 2.55813953,6.26356589 C3.04393008,6.08785442 3.53488124,6 4.03100775,6 C4.53747023,6 4.97932628,6.04134326 5.35658915,6.12403101 C5.73385202,6.20671876 6.04134248,6.29974109 6.27906977,6.40310078 L5.89147287,8.12403101 C5.69508946,8.02067132 5.4651176,7.94056876 5.20155039,7.88372093 C4.93798318,7.8268731 4.62532481,7.79844961 4.26356589,7.79844961 C3.55038403,7.79844961 3.00258589,8.10852403 2.62015504,8.72868217 C2.23772419,9.34884031 2.04651163,10.3204068 2.04651163,11.6434109 C2.04651163,12.2118891 2.09043884,12.7312638 2.17829457,13.2015504 C2.26615031,13.671837 2.4056838,14.0775177 2.59689922,14.4186047 C2.78811465,14.7596916 3.03100628,15.0232549 3.3255814,15.2093023 C3.62015651,15.3953498 3.97415814,15.4883721 4.3875969,15.4883721 C4.74935581,15.4883721 5.05943023,15.439277 5.31782946,15.3410853 C5.57622868,15.2428936 5.8087845,15.1266157 6.01550388,14.9922481 L6.40310078,16.6356589 Z M14.5891473,11.4728682 L14.8062016,9.39534884 L14.7286822,9.39534884 L14.1550388,11.255814 L12.3875969,15.0697674 L11.7364341,15.0697674 L9.86046512,11.2403101 L9.28682171,9.36434109 L9.19379845,9.36434109 L9.48837209,11.4573643 L9.48837209,17.0697674 L7.64341085,17.0697674 L7.64341085,6.21705426 L9.51937984,6.21705426 L11.7829457,10.9147287 L12.1550388,12.2635659 L12.2170543,12.2635659 L12.5736434,10.8837209 L14.6976744,6.21705426 L16.5426357,6.21705426 L16.5426357,17.0697674 L14.5891473,17.0697674 L14.5891473,11.4728682 Z M22.0465116,14.2790698 C22.0465116,13.9483188 21.9483214,13.6666678 21.751938,13.4341085 C21.5555546,13.2015492 21.310079,12.9819132 21.0155039,12.7751938 C20.7209288,12.5684744 20.4005185,12.3565902 20.0542636,12.1395349 C19.7080086,11.9224795 19.3875984,11.6692521 19.0930233,11.379845 C18.7984481,11.0904378 18.5529726,10.749356 18.3565891,10.3565891 C18.1602057,9.96382233 18.0620155,9.48320698 18.0620155,8.91472868 C18.0620155,8.38759426 18.1421181,7.94057031 18.3023256,7.57364341 C18.4625331,7.20671651 18.6821691,6.90697791 18.9612403,6.6744186 C19.2403115,6.4418593 19.5710575,6.27131837 19.9534884,6.1627907 C20.3359192,6.05426302 20.7441839,6 21.1782946,6 C21.705429,6 22.1963802,6.05167907 22.6511628,6.15503876 C23.1059454,6.25839845 23.4832026,6.39793194 23.7829457,6.57364341 L23.1782946,8.29457364 C23.0025831,8.17054202 22.7416038,8.05684806 22.3953488,7.95348837 C22.0490939,7.85012868 21.6744206,7.79844961 21.2713178,7.79844961 C20.868215,7.79844961 20.5581406,7.88113612 20.3410853,8.04651163 C20.1240299,8.21188713 20.0155039,8.45477876 20.0155039,8.7751938 C20.0155039,9.06460093 20.1136941,9.32041233 20.3100775,9.54263566 C20.5064609,9.76485899 20.7519365,9.97932713 21.0465116,10.1860465 C21.3410867,10.3927659 21.661497,10.607234 22.0077519,10.8294574 C22.3540069,11.0516807 22.6744171,11.310076 22.9689922,11.6046512 C23.2635674,11.8992263 23.5090429,12.245476 23.7054264,12.6434109 C23.9018098,13.0413457 24,13.5142091 24,14.0620155 C24,14.6098219 23.9198974,15.0852693 23.7596899,15.4883721 C23.5994824,15.8914749 23.3720945,16.2248049 23.0775194,16.4883721 C22.7829443,16.7519393 22.4289426,16.9509037 22.0155039,17.0852713 C21.6020651,17.2196389 21.1421214,17.2868217 20.6356589,17.2868217 C19.9948288,17.2868217 19.4341109,17.2248068 18.9534884,17.1007752 C18.4728658,16.9767436 18.1033605,16.8372101 17.8449612,16.6821705 L18.4806202,14.9302326 C18.6873395,15.0542642 18.9715744,15.178294 19.3333333,15.3023256 C19.6950922,15.4263572 20.0826853,15.4883721 20.496124,15.4883721 C21.5297209,15.4883721 22.0465116,15.0852753 22.0465116,14.2790698 Z" />
		),
	},
});
export const IconCode = svgIcon({
	default: {
		element: (
			<path d="M336-240 96-480l240-240 51 51-189 189 189 189-51 51Zm288 0-51-51 189-189-189-189 51-51 240 240-240 240Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCodeCheck = svgIcon({
	default: {
		element: (
			<>
				<path d="M14 20V18H17C17.2833 18 17.5208 17.9042 17.7125 17.7125C17.9042 17.5208 18 17.2833 18 17V15C18 14.3667 18.1833 13.7917 18.55 13.275C18.9167 12.7583 19.4 12.3917 20 12.175V11.825C19.4 11.6083 18.9167 11.2417 18.55 10.725C18.1833 10.2083 18 9.63333 18 9V7C18 6.71667 17.9042 6.47917 17.7125 6.2875C17.5208 6.09583 17.2833 6 17 6H14V4H17C17.8333 4 18.5417 4.29167 19.125 4.875C19.7083 5.45833 20 6.16667 20 7V9C20 9.28333 20.0958 9.52083 20.2875 9.7125C20.4792 9.90417 20.7167 10 21 10H22V14H21C20.7167 14 20.4792 14.0958 20.2875 14.2875C20.0958 14.4792 20 14.7167 20 15V17C20 17.8333 19.7083 18.5417 19.125 19.125C18.5417 19.7083 17.8333 20 17 20H14ZM7 20C6.16667 20 5.45833 19.7083 4.875 19.125C4.29167 18.5417 4 17.8333 4 17V15C4 14.7167 3.90417 14.4792 3.7125 14.2875C3.52083 14.0958 3.28333 14 3 14H2V10H3C3.28333 10 3.52083 9.90417 3.7125 9.7125C3.90417 9.52083 4 9.28333 4 9V7C4 6.16667 4.29167 5.45833 4.875 4.875C5.45833 4.29167 6.16667 4 7 4H10V6H7C6.71667 6 6.47917 6.09583 6.2875 6.2875C6.09583 6.47917 6 6.71667 6 7V9C6 9.63333 5.81667 10.2083 5.45 10.725C5.08333 11.2417 4.6 11.6083 4 11.825V12.175C4.6 12.3917 5.08333 12.7583 5.45 13.275C5.81667 13.7917 6 14.3667 6 15V17C6 17.2833 6.09583 17.5208 6.2875 17.7125C6.47917 17.9042 6.71667 18 7 18H10V20H7Z" />
				<path d="M8 12.55L10.825 15.375L15.775 10.425L14.35 9L10.825 12.55L9.4 11.125L8 12.55Z" />
			</>
		),
	},
});
export const IconCognition = svgIcon({
	default: {
		element: (
			<path d="M492-337q69 0 118.5-45T660-489.94q0-56.06-36.5-95.56T535.95-625q-46.14 0-78.04 30Q426-565 426-523q0 20 7.24 36.94Q440.48-469.12 454-455l51-51q-3.5-3-5.25-7.5t-1.75-9.03Q498-535 509-544q11-9 27-9 21 0 36.5 18.56T588-490q0 33-28.5 57t-67.26 24q-49.24 0-84.74-41.5Q372-492 372-549q0-30.77 11.5-58.88Q395-636 417-658l-51-50q-32 32-49 73t-17 86q0 88 56 150t136 62ZM264-96v-175q-57-48-88.5-115.57T144-529q0-139.58 98.29-237.29Q340.58-864 481-864q109 0 196 58.5T792-653l66 223q5 17.48-5.5 31.74Q842-384 824-384h-56v120q0 29.7-21.15 50.85Q725.7-192 696-192h-96v96h-72v-168h168v-192h80l-52-173q-22-72-89.5-117.5T481-792q-111 0-188 76.63T216-529q0 58.93 25 111.96Q266-364 311-326l25 22v208h-72Zm232-348Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconColor = svgIcon({
	default: {
		element: (
			<path d="M480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30.5-149.5t84-122Q264-804 335.5-834T488-864q78 0 146.5 27T754-763q51 47 80.5 110T864-518q0 96-67 163t-163 67h-68q-8 0-14 5t-6 13q0 15 15 25t15 53q0 37-27 66.5T480-96Zm0-384Zm-216 36q25 0 42.5-17.5T324-504q0-25-17.5-42.5T264-564q-25 0-42.5 17.5T204-504q0 25 17.5 42.5T264-444Zm120-144q25 0 42.5-17.5T444-648q0-25-17.5-42.5T384-708q-25 0-42.5 17.5T324-648q0 25 17.5 42.5T384-588Zm192 0q25 0 42.5-17.5T636-648q0-25-17.5-42.5T576-708q-25 0-42.5 17.5T516-648q0 25 17.5 42.5T576-588Zm120 144q25 0 42.5-17.5T756-504q0-25-17.5-42.5T696-564q-25 0-42.5 17.5T636-504q0 25 17.5 42.5T696-444ZM480-168q11 0 17.5-8.5T504-192q0-16-15-28t-15-50q0-38 26.5-64t64.5-26h69q66 0 112-46t46-112q0-115-88.5-194.5T488-792q-134 0-227 91t-93 221q0 130 91 221t221 91Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconColumn = svgIcon({
	default: {
		element: (
			<path d="M144-312v-336q0-29 21.15-50.5T216-720h528q29.7 0 50.85 21.5Q816-677 816-648v336q0 29-21.15 50.5T744-240H216q-29.7 0-50.85-21.5Q144-283 144-312Zm72 0h128v-336H216v336Zm200 0h128v-336H416v336Zm200 0h128v-336H616v336Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconColumnChart = svgIcon({
	default: {
		element: (
			<path d="M624-192v-288h144v288H624Zm-216 0v-576h144v576H408Zm-216 0v-384h144v384H192Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconContactSupport = svgIcon({
	default: {
		element: (
			<path d="m480-80-10-120h-10q-142 0-241-99t-99-241q0-142 99-241t241-99q71 0 132.5 26.5t108 73q46.5 46.5 73 108T800-540q0 75-24.5 144t-67 128q-42.5 59-101 107T480-80Zm80-146q71-60 115.5-140.5T720-540q0-109-75.5-184.5T460-800q-109 0-184.5 75.5T200-540q0 109 75.5 184.5T460-280h100v54Zm-101-95q17 0 29-12t12-29q0-17-12-29t-29-12q-17 0-29 12t-12 29q0 17 12 29t29 12Zm-29-127h60q0-30 6-42t38-44q18-18 30-39t12-45q0-51-34.5-76.5T460-720q-44 0-74 24.5T344-636l56 22q5-17 19-33.5t41-16.5q27 0 40.5 15t13.5 33q0 17-10 30.5T480-558q-35 30-42.5 47.5T430-448Zm30-65Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconContentBrief = svgIcon({
	default: {
		element: (
			<path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h456l144 144v200q-17.1-5.54-35.55-7.27Q762-481 744-476v-166L642-744H216v528h240v72H216Zm0-600v528-528ZM528-72v-113l210-209q7.26-7.41 16.13-10.71Q763-408 771.76-408q9.55 0 18.31 3.5Q798.83-401 806-394l44 45q6.59 7.26 10.29 16.13Q864-324 864-315.24t-3.29 17.92q-3.3 9.15-10.71 16.32L641-72H528Zm288-243-45-45 45 45ZM576-120h45l115-115-22-23-22-22-116 115v45Zm138-138-22-22 44 45-22-23ZM264-552h336v-144H264v144Zm216 300h7q3 0 7-1l93-92q1-4 1-7.5v-7.5q0-45-31.5-76.5T480-468q-45 0-76.5 31.5T372-360q0 45 31.5 76.5T480-252Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconContentPlan = svgIcon({
	default: {
		element: (
			<>
				<path d="M21 11H19V5H17V8H7V5H5V19H10V21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.175C9.35833 2.41667 9.71667 1.9375 10.25 1.5625C10.7833 1.1875 11.3667 1 12 1C12.6667 1 13.2625 1.1875 13.7875 1.5625C14.3125 1.9375 14.6667 2.41667 14.85 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V11ZM12 5C12.2833 5 12.5208 4.90417 12.7125 4.7125C12.9042 4.52083 13 4.28333 13 4C13 3.71667 12.9042 3.47917 12.7125 3.2875C12.5208 3.09583 12.2833 3 12 3C11.7167 3 11.4792 3.09583 11.2875 3.2875C11.0958 3.47917 11 3.71667 11 4C11 4.28333 11.0958 4.52083 11.2875 4.7125C11.4792 4.90417 11.7167 5 12 5Z" />
				<path d="M21 13.25L14.1372 20.1128L10 15.9757L11.3628 14.6128L14.1372 17.3872L19.6372 11.8872L21 13.25Z" />
			</>
		),
	},
});
export const IconContentServices = svgIcon({
	default: {
		element: (
			<path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm0-72h528v-456H216v456Zm72-265v-72h384v72H288Zm0 145v-72h240v72H288Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconContrast = svgIcon({
	default: {
		element: (
			<path d="M480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM516-170q117-14 196.5-101.72T792-480q0-120.56-79.5-208.28T516-790v620Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});

export const IconContentPriority = svgIcon({
	default: {
		element: (
			<>
				<path d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z" />
				<path d="M9 16H7V12H9V16Z" />
				<path d="M17 16H15V10H17V16Z" />
				<path d="M13 16H11V7H13V16Z" />
			</>
		),
	},
});
export const IconContentStrategy = svgIcon({
	default: {
		element: (
			<path d="M263.79-192Q234-192 213-213.21t-21-51Q192-294 213.21-315t51-21Q294-336 315-314.79t21 51Q336-234 314.79-213t-51 21Zm0-216Q234-408 213-429.21t-21-51Q192-510 213.21-531t51-21Q294-552 315-530.79t21 51Q336-450 314.79-429t-51 21Zm0-216Q234-624 213-645.21t-21-51Q192-726 213.21-747t51-21Q294-768 315-746.79t21 51Q336-666 314.79-645t-51 21Zm216 0Q450-624 429-645.21t-21-51Q408-726 429.21-747t51-21Q510-768 531-746.79t21 51Q552-666 530.79-645t-51 21Zm216 0Q666-624 645-645.21t-21-51Q624-726 645.21-747t51-21Q726-768 747-746.79t21 51Q768-666 746.79-645t-51 21Zm-216 216Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21ZM528-192v-113l210-209q7.26-7.41 16.13-10.71Q763-528 771.76-528q9.55 0 18.31 3.5Q798.83-521 806-514l44 45q6.59 7.26 10.29 16.13Q864-444 864-435.24t-3.29 17.92q-3.3 9.15-10.71 16.32L641-192H528Zm288-243-45-45 45 45ZM576-240h45l115-115-22-23-22-22-116 115v45Zm138-138-22-22 44 45-22-23Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconConversionRate = svgIcon({
	default: {
		element: (
			<>
				<path d="M9 13L3.225 5.625C3.14167 5.525 3.08333 5.42083 3.05 5.3125C3.01667 5.20417 3 5.1 3 5C3 4.73333 3.09583 4.5 3.2875 4.3C3.47917 4.1 3.71667 4 4 4H18C18.2833 4 18.5208 4.1 18.7125 4.3C18.9042 4.5 19 4.73333 19 5C19 5.1 18.9833 5.20417 18.95 5.3125C18.9167 5.42083 18.8583 5.525 18.775 5.625L13 13V19C13 19.2833 12.9042 19.5208 12.7125 19.7125C12.5208 19.9042 12.2833 20 12 20H10C9.71667 20 9.47917 19.9042 9.2875 19.7125C9.09583 19.5208 9 19.2833 9 19V13ZM11 12.3L15.95 6H6.05L11 12.3Z" />
				<path d="M15 16.15L17.825 18.975L22.4 14.4L21 13L17.825 16.175L16.4 14.75L15 16.15Z" />
			</>
		),
	},
});
export const IconCopy = svgIcon({
	default: {
		element: (
			<path d="M360-240q-29.7 0-50.85-21.15Q288-282.3 288-312v-480q0-29.7 21.15-50.85Q330.3-864 360-864h384q29.7 0 50.85 21.15Q816-821.7 816-792v480q0 29.7-21.15 50.85Q773.7-240 744-240H360Zm0-72h384v-480H360v480ZM216-96q-29.7 0-50.85-21.15Q144-138.3 144-168v-552h72v552h456v72H216Zm144-216v-480 480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCsv = svgIcon({
	default: {
		element: (
			<path d="M288-384h72v-48h-72v-96h72v-48h-72q-20.4 0-34.2 13.8Q240-548.4 240-528v96q0 20.4 13.8 34.2Q267.6-384 288-384Zm120 0h96q10.2 0 17.1-6.9 6.9-6.9 6.9-17.1v-72q0-10-6.9-17t-17.1-7h-48v-24h72v-48h-96q-10.2 0-17.1 6.9-6.9 6.9-6.9 17.1v72q0 10 6.9 17t17.1 7h48v24h-72v48Zm208 0h48l56-192h-50l-30 103-30-103h-50l56 192ZM168-192q-29.7 0-50.85-21.16Q96-234.32 96-264.04v-432.24Q96-726 117.15-747T168-768h624q29.7 0 50.85 21.16Q864-725.68 864-695.96v432.24Q864-234 842.85-213T792-192H168Zm0-72h624v-432H168v432Zm0 0v-432 432Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCoreWins = svgIcon({
	default: {
		element: (
			<path d="M407.74-240Q378-240 357-261.15 336-282.3 336-312v-67q-57-37.3-88.5-95.65Q216-533 216-600q0-110.31 76.78-187.16 76.78-76.84 187-76.84T667-787.16q77 76.85 77 187.16 0 66.82-31.5 125.41T624-379v67q0 29.7-21.18 50.85Q581.65-240 551.91-240H407.74Zm.26-72h144v-106l33-21q41-26 64-69.18 23-43.18 23-91.82 0-79.68-56.23-135.84-56.22-56.16-136-56.16Q400-792 344-735.84 288-679.68 288-600q0 48.64 23 91.82Q334-465 375-439l33 21v106Zm0 216q-20.4 0-34.2-13.8Q360-123.6 360-144v-24h240v24q0 20.4-13.8 34.2Q572.4-96 552-96H408Zm72-504Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconCustomize = svgIcon({
	default: {
		element: (
			<path d="M456-144v-240h72v84h288v72H528v84h-72Zm-312-84v-72h240v72H144Zm144-132v-84H144v-72h144v-84h72v240h-72Zm144-84v-72h384v72H432Zm144-132v-240h72v84h168v72H648v84h-72Zm-432-84v-72h384v72H144Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDashboard = svgIcon({
	default: {
		element: (
			<path d="M528-624v-192h288v192H528ZM144-432v-384h288v384H144Zm384 288v-384h288v384H528Zm-384 0v-192h288v192H144Zm72-360h144v-240H216v240Zm384 288h144v-240H600v240Zm0-479h144v-49H600v49ZM216-216h144v-48H216v48Zm144-288Zm240-191Zm0 239ZM360-264Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDate = svgIcon({
	default: {
		element: (
			<path d="M216-96q-29.7 0-50.85-21.5Q144-139 144-168v-528q0-29 21.15-50.5T216-768h72v-96h72v96h240v-96h72v96h72q29.7 0 50.85 21.5Q816-725 816-696v528q0 29-21.15 50.5T744-96H216Zm0-72h528v-360H216v360Zm0-432h528v-96H216v96Zm0 0v-96 96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDelete = svgIcon({
	default: {
		element: (
			<path d="M312-144q-29.7 0-50.85-21.15Q240-186.3 240-216v-480h-48v-72h192v-48h192v48h192v72h-48v479.57Q720-186 698.85-165T648-144H312Zm336-552H312v480h336v-480ZM384-288h72v-336h-72v336Zm120 0h72v-336h-72v336ZM312-696v480-480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDesktop = svgIcon({
	default: {
		element: (
			<path d="M336-145v-72h72v-72H168q-29.7 0-50.85-21.15Q96-331.3 96-361v-384q0-29.7 21.15-50.85Q138.3-817 168-817h624q29.7 0 50.85 21.15Q864-774.7 864-745v384q0 29.7-21.15 50.85Q821.7-289 792-289H552v72h72v72H336ZM168-361h624v-384H168v384Zm0 0v-384 384Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDevices = svgIcon({
	default: {
		element: (
			<path d="M504-540ZM96-192v-72h408v72H96Zm120-120q-33 0-52.5-19.5T144-384v-312q0-33 19.5-52.5T216-768h528q33 0 52.5 19.5T816-696H216v312h288v72H216Zm576 48v-288H648v288h144Zm-162 72q-25 0-39.5-14.5T576-246v-324q0-25 14.5-39.5T630-624h180q25 0 39.5 14.5T864-570v324q0 25-14.5 39.5T810-192H630Zm89.72-288q10.28 0 17.28-7.12 7-7.11 7-16.6 0-10.28-6.88-17.28-6.88-7-17.41-7-9.71 0-16.71 6.88t-7 17.41q0 9.71 7.12 16.71 7.11 7 16.6 7Zm.28 72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDiamondShine = svgIcon({
	default: {
		element: (
			<path d="M480-96 144-441l192-231h288l192 231L480-96ZM213-672l-85-85 51-51 85 85-51 51Zm231-72v-120h72v120h-72Zm302 72-51-51 85-85 51 51-85 85ZM480-199l204-209H276l204 209ZM370-600 270-480h419l-99-120H370Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDocument = svgIcon({
	default: {
		element: (
			<path d="M263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72ZM528-624v-168H264v624h432v-456H528ZM264-792v189-189 624-624Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDone = svgIcon({
	default: {
		element: (
			<path d="m429-336 238-237-51-51-187 186-85-84-51 51 136 135Zm51 240q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDonutChart = svgIcon({
	default: {
		element: (
			<path d="M444-98q-149-14-248.5-123.5T96-480q0-149 99.5-258.5T444-862v96q-109 14-180.5 95.5T192-480q0 109 71.5 190.5T444-194v96Zm72 0v-96q99-12 168.5-81.5T766-444h96q-13 139-110 236T516-98Zm250-418q-12-99-81.5-168.5T516-766v-96q139 13 236 110t110 236h-96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDoubleChevron = svgIcon({
	default: {
		element: (
			<path d="M432-240 192-480l240-240 51 51-189 189 189 189-51 51Zm285 0L477-480l240-240 51 51-189 189 189 189-51 51Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDoubleChevronRight = svgIcon({
	default: {
		element: (
			<path d="M381-480 192-669l51-51 240 240-240 240-51-51 189-189Zm285 0L477-669l51-51 240 240-240 240-51-51 189-189Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDownload = svgIcon({
	default: {
		element: (
			<path d="M480-336 288-528l51-51 105 105v-342h72v342l105-105 51 51-192 192ZM263.72-192Q234-192 213-213.15T192-264v-72h72v72h432v-72h72v72q0 29.7-21.16 50.85Q725.68-192 695.96-192H263.72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconDuplicatePage = svgIcon({
	default: {
		element: (
			<>
				<path d="M4 23C3.45 23 2.97917 22.8042 2.5875 22.4125C2.19583 22.0208 2 21.55 2 21V7H4V21H15V23H4Z" />
				<path d="M19 3H8V17H19V3ZM21 17C21 18.1046 20.1046 19 19 19H8C6.89543 19 6 18.1046 6 17V3C6 1.89543 6.89543 1 8 1H19C20.1046 1 21 1.89543 21 3V17Z" />
				<path d="M10 7H17V5H10V7ZM10 11H17V9H10V11ZM10 15H15V13H10V15Z" />
			</>
		),
	},
});
export const IconDrag = svgIcon({
	default: {
		element: (
			<path d="M359.79-192Q330-192 309-213.21t-21-51Q288-294 309.21-315t51-21Q390-336 411-314.79t21 51Q432-234 410.79-213t-51 21Zm240 0Q570-192 549-213.21t-21-51Q528-294 549.21-315t51-21Q630-336 651-314.79t21 51Q672-234 650.79-213t-51 21Zm-240-216Q330-408 309-429.21t-21-51Q288-510 309.21-531t51-21Q390-552 411-530.79t21 51Q432-450 410.79-429t-51 21Zm240 0Q570-408 549-429.21t-21-51Q528-510 549.21-531t51-21Q630-552 651-530.79t21 51Q672-450 650.79-429t-51 21Zm-240-216Q330-624 309-645.21t-21-51Q288-726 309.21-747t51-21Q390-768 411-746.79t21 51Q432-666 410.79-645t-51 21Zm240 0Q570-624 549-645.21t-21-51Q528-726 549.21-747t51-21Q630-768 651-746.79t21 51Q672-666 650.79-645t-51 21Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconEdit = svgIcon({
	default: {
		element: (
			<path d="M216-216h51l375-375-51-51-375 375v51Zm-72 72v-153l498-498q11-11 23.84-16 12.83-5 27-5 14.16 0 27.16 5t24 16l51 51q11 11 16 24t5 26.54q0 14.45-5.02 27.54T795-642L297-144H144Zm600-549-51-51 51 51Zm-127.95 76.95L591-642l51 51-25.95-25.05Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconEmail = svgIcon({
	default: {
		element: (
			<path d="M168-192q-29.7 0-50.85-21.16Q96-234.32 96-264.04v-432.24Q96-726 117.15-747T168-768h624q29.7 0 50.85 21.16Q864-725.68 864-695.96v432.24Q864-234 842.85-213T792-192H168Zm312-240L168-611v347h624v-347L480-432Zm0-85 312-179H168l312 179Zm-312-94v-85 432-347Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconEntry = svgIcon({
	default: {
		element: (
			<path d="M480-144v-72h264v-528H480v-72h264q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H480Zm-72-168-51-51 81-81H144v-72h294l-81-81 51-51 168 168-168 168Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconError = svgIcon({
	default: {
		element: (
			<path d="M479.79-288q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-432h72v-240h-72v240Zm36.28 336Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconErrorOutline = svgIcon({
	default: {
		element: (
			<path d="M479.79-288q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-432h72v-240h-72v240Zm36.28 336Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFastBroadband = svgIcon({
	default: {
		element: (
			<path d="M480-120 0-600q95-97 219.5-148.5T480-800q136 0 260.5 51.5T960-600L480-120Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFeatureFlag = svgIcon({
	default: {
		element: (
			<path d="M192-144v-672h336l24 96h216v384H528l-24-96H264v288h-72Zm300-431Zm92 167h112v-240H496l-24-96H264v240h296l24 96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFeedback = svgIcon({
	default: {
		element: (
			<path d="M479.79-360q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-480h72v-264h-72v264ZM96-96v-696q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H240L96-96Zm114-216h582v-480H168v522l42-42Zm-42 0v-480 480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFileCopy = svgIcon({
	default: {
		element: (
			<path d="M744-192H312q-29 0-50.5-21.5T240-264v-576q0-29 21.5-50.5T312-912h312l192 192v456q0 29-21.5 50.5T744-192ZM576-672v-168H312v576h432v-408H576ZM168-48q-29 0-50.5-21.5T96-120v-552h72v552h456v72H168Zm144-792v195-195 576-576Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFillColor = svgIcon({
	default: {
		element: (
			<path d="M346-160 112-393q-8-8-12.5-17.5T95-431q0-11 4.5-21.5T112-471l221-221-121-121 51-51 393 393q8 8 12 18t4 21q0 11-4 21t-12 18L423-160q-8 8-18 12.5t-21 4.5q-11-1-20.5-5T346-160Zm38-481L175-432v-1 1h418v-1 1L384-641Zm393 497q-37 0-62.5-25T689-231q0-24 11-46.5t26-42.5l51-64 50 64q14 20 25.5 42.5T864-231q0 37-25.5 62T777-144Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFilter = svgIcon({
	default: {
		element: (
			<path d="M456.18-192Q446-192 439-198.9t-7-17.1v-227L197-729q-9-12-2.74-25.5Q200.51-768 216-768h528q15.49 0 21.74 13.5Q772-741 763-729L528-443v227q0 10.2-6.88 17.1-6.89 6.9-17.06 6.9h-47.88ZM480-498l162-198H317l163 198Zm0 0Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFinish = svgIcon({
	default: {
		element: <path d="M389-267 195-460l51-52 143 143 325-324 51 51-376 375Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFullscreen = svgIcon({
	default: {
		element: (
			<path d="M144-144v-192h72v120h120v72H144Zm480 0v-72h120v-120h72v192H624ZM144-624v-192h192v72H216v120h-72Zm600 0v-120H624v-72h192v192h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconFunnel = svgIcon({
	default: {
		element: <path d="M384-264v-72h192v72H384ZM240-444v-72h480v72H240Zm-96-180v-72h672v72H144Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconGoalTarget = svgIcon({
	default: {
		element: (
			<path d="M440-42v-80q-125-14-214.5-103.5T122-440H42v-80h80q14-125 103.5-214.5T440-838v-80h80v80q125 14 214.5 103.5T838-520h80v80h-80q-14 125-103.5 214.5T520-122v80h-80Zm40-158q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-120q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconGoogle = svgIcon({
	default: {
		element: (
			<path d="M21.5895 10.18H12.1995V13.89H17.7095C17.5995 14.81 16.9995 16.2 15.6645 17.135C14.8195 17.725 13.6845 18.135 12.1995 18.135C9.55445 18.135 7.30945 16.39 6.50945 13.98C6.29945 13.36 6.17445 12.69 6.17445 12C6.17445 11.31 6.29445 10.645 6.49445 10.02C7.30445 7.61 9.54945 5.865 12.1945 5.865C14.0745 5.865 15.3395 6.675 16.0595 7.355L18.8795 4.6C17.1445 2.99 14.8895 2 12.1895 2C8.27945 2 4.89945 4.245 3.25445 7.51C2.57445 8.865 2.18945 10.39 2.18945 12C2.18945 13.61 2.57945 15.135 3.25445 16.49C4.89945 19.755 8.27445 22 12.1895 22C14.8895 22 17.1545 21.11 18.8095 19.58C20.6995 17.835 21.7895 15.27 21.7895 12.225C21.7895 11.405 21.7245 10.805 21.5795 10.18H21.5895Z" />
		),
	},
});
export const IconGreyScale = svgIcon({
	default: {
		element: (
			<path d="M336-336h288v-288H336v288ZM216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm0-72h528v-528H216v528Zm0-528v528-528Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconGroup = svgIcon({
	default: {
		element: (
			<path d="M9.8775 10H5V21H13.0428V13L9.8775 10ZM11 8L15.0674 11.9931V18H16.0674V9.9931L13.0674 7H8.001L8 8H11ZM18.0674 14.9931H19.0674V6.9931L16.0674 4H11.001L11 5H14L18.0674 8.9931V14.9931ZM17.994 18.5C17.994 19.2765 17.3961 19.9201 16.6379 19.9931L16.494 20H15V21.5C15 22.2765 14.4021 22.9201 13.6439 22.9931L13.5 23H4.4925C3.6675 23 3 22.325 3 21.5L3.0075 9.5C3.0075 8.675 3.675 8 4.5 8H6L6.0015 6.5C6.0015 5.72353 6.59278 5.07993 7.35015 5.0069L7.494 5H9L9.0015 3.5C9.0015 2.72353 9.59278 2.07993 10.3502 2.0069L10.494 2H17.0674L20.994 6V15.5C20.994 16.2765 20.3961 16.9201 19.6379 16.9931L19.494 17H17.993L17.994 18.5Z" />
		),
	},
});
export const IconHearing = svgIcon({
	default: {
		element: (
			<path d="M286-96q66 0 100.5-41t51.5-96q14-46 30.5-77t64.5-57q66-35 102.5-98T672-601q0-110-77-186.5T408-864q-110 0-187 77t-77 187h72q0-80 56-136t136-56q80 0 136 55.5T600-601q0 53-27 99t-73 70q-62 32-84.5 69.5T370-255q-16 48-37 67.5T286-168q-29 0-49.5-21.5T216-240h-72q0 59 41.5 101.5T286-96Zm410-216q57-58 88.5-132.5T816-600q0-81-31.5-156T696-889l-50 51q46 48 72 109.5T744-600q0 67-26 128.5T646-362l50 50ZM408-504q40 0 68-28t28-68q0-40-28-68t-68-28q-40 0-68 28t-28 68q0 40 28 68t68 28Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHeatMap = svgIcon({
	default: {
		element: (
			<path d="M264-384q0 46 19.5 87.5T338-223q-1-5-1.5-10t-.5-10q0-27 10-50.5t27-42.5l107-120 107 120q17 20 27 43.5t10 49.5q0 5-.5 10.5T622-222q35-29 54.5-71.5T696-384q0-51-17.5-100.5T628-576q-17 11-35.5 17t-40.5 6q-52 0-91.5-32T411-668q-36 33-63 67.5T302-530q-19 36-28.5 73t-9.5 73Zm216 36-53 60q-9 11-14 22.5t-5 25.5q0 30 21 51t51 21q30 0 51-21t21-51q0-14-5-26t-14-22l-53-60Zm0-468v119q0 30 21 51t51 21q17 0 31.5-7t24.5-20l16-20q64 38 104 118.5T768-384q0 120-84 204T480-96q-120 0-204-84t-84-204q0-112 76-226.5T480-816Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHeader = svgIcon({
	default: {
		element: (
			<path d="M192-288v-384h72v156h168v-156h72v384h-72v-156H264v156h-72Zm504 0v-312h-96v-72h168v384h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHelp = svgIcon({
	default: {
		element: (
			<path d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHelpOutline = svgIcon({
	default: {
		element: (
			<path d="M480-240q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-36-153h73q0-37 6.5-52.5T555-485q35-34 48.5-58t13.5-53q0-55-37.5-89.5T484-720q-51 0-88.5 27T343-620l65 27q9-28 28.5-43.5T482-652q28 0 46 16t18 42q0 23-15.5 41T496-518q-35 32-43.5 52.5T444-393Zm36 297q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHide = svgIcon({
	default: {
		element: (
			<path d="m637-425-62-62q4-38-23-65.5T487-576l-62-62q13-5 27-7.5t28-2.5q70 0 119 49t49 119q0 14-2.5 28t-8.5 27Zm133 133-52-52q36-28 65.5-61.5T833-480q-49-101-144.5-158.5T480-696q-26 0-51 3t-49 10l-58-58q38-15 77.5-21t80.5-6q143 0 261.5 77.5T912-480q-22 57-58.5 103.5T770-292Zm-2 202L638-220q-38 14-77.5 21t-80.5 7q-143 0-261.5-77.5T48-480q22-57 58-104t84-85L90-769l51-51 678 679-51 51ZM241-617q-35 28-65 61.5T127-480q49 101 144.5 158.5T480-264q26 0 51-3.5t50-9.5l-45-45q-14 5-28 7.5t-28 2.5q-70 0-119-49t-49-119q0-14 3.5-28t6.5-28l-81-81Zm287 89Zm-96 96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHierarchy = svgIcon({
	default: {
		element: (
			<path d="M144-96v-240h108v-180h192v-108H336v-240h288v240H516v108h192v180h108v240H528v-240h108v-108H324v108h108v240H144Zm264-600h144v-96H408v96ZM216-168h144v-96H216v96Zm384 0h144v-96H600v96ZM480-691ZM360-264Zm240 0Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHighConnection = svgIcon({
	default: {
		element: <path d="m80-80 800-800v800H80Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHistory = svgIcon({
	default: {
		element: (
			<path d="M12 21C9.7 21 7.69583 20.2375 5.9875 18.7125C4.27917 17.1875 3.3 15.2833 3.05 13H5.1C5.33333 14.7333 6.10417 16.1667 7.4125 17.3C8.72083 18.4333 10.25 19 12 19C13.95 19 15.6042 18.3208 16.9625 16.9625C18.3208 15.6042 19 13.95 19 12C19 10.05 18.3208 8.39583 16.9625 7.0375C15.6042 5.67917 13.95 5 12 5C10.85 5 9.775 5.26667 8.775 5.8C7.775 6.33333 6.93333 7.06667 6.25 8H9V10H3V4H5V6.35C5.85 5.28333 6.8875 4.45833 8.1125 3.875C9.3375 3.29167 10.6333 3 12 3C13.25 3 14.4208 3.2375 15.5125 3.7125C16.6042 4.1875 17.5542 4.82917 18.3625 5.6375C19.1708 6.44583 19.8125 7.39583 20.2875 8.4875C20.7625 9.57917 21 10.75 21 12C21 13.25 20.7625 14.4208 20.2875 15.5125C19.8125 16.6042 19.1708 17.5542 18.3625 18.3625C17.5542 19.1708 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21ZM14.8 16.2L11 12.4V7H13V11.6L16.2 14.8L14.8 16.2Z" />
		),
	},
});
export const IconHome = svgIcon({
	default: {
		element: (
			<path d="M264-216h96v-240h240v240h96v-348L480-726 264-564v348Zm-72 72v-456l288-216 288 216v456H528v-240h-96v240H192Zm288-327Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHourglassBottom = svgIcon({
	default: {
		element: (
			<path d="M480-516q65 0 110.5-45.5T636-672v-120H324v120q0 65 45.5 110.5T480-516ZM192-96v-72h60v-120q0-59 28-109.5t78-82.5q-49-32-77.5-82.5T252-672v-120h-60v-72h576v72h-60v120q0 59-28.5 109.5T602-480q50 32 78 82.5T708-288v120h60v72H192Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconHourglassTop = svgIcon({
	default: {
		element: (
			<path d="M324-168h312v-120q0-65-45.5-110.5T480-444q-65 0-110.5 45.5T324-288v120ZM192-96v-72h60v-120q0-59 28-109.5t78-82.5q-49-32-77.5-82.5T252-672v-120h-60v-72h576v72h-60v120q0 59-28.5 109.5T602-480q50 32 78 82.5T708-288v120h60v72H192Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconImage = svgIcon({
	default: {
		element: (
			<path d="M216-144q-29.7 0-50.85-21.5Q144-187 144-216v-528q0-29 21.15-50.5T216-816h528q29.7 0 50.85 21.5Q816-773 816-744v528q0 29-21.15 50.5T744-144H216Zm0-72h528v-528H216v528Zm48-72h432L552-480 444-336l-72-96-108 144Zm-48 72v-528 528Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconIndeterminate = svgIcon({
	default: {
		element: <path d="M232-444v-72h496v72H232Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconInfo = svgIcon({
	default: {
		element: (
			<path d="M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconInfoOutline = svgIcon({
	default: {
		element: (
			<path d="M444-288h72v-240h-72v240Zm35.79-312q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm.49 504Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconIssue = svgIcon({
	default: {
		element: (
			<path d="M479.79-288q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-432h72v-240h-72v240Zm36.28 336Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconKeyMetric = svgIcon({
	default: {
		element: (
			<path d="M21 12V21H18V12H21ZM16 12V21H13V12H16ZM11 12V21H8V12H11ZM6 15V21H3V15H6ZM2 11V9H22V11H2ZM21 3V8H18V3H21ZM16 6V8H13V6H16Z" />
		),
	},
});
export const IconKeywordDecrease = svgIcon({
	default: {
		element: (
			<>
				<path d="M5.5 20L2 16.5L3.425 15.1L4.5 16.175V4H6.5V16.2L7.6 15.1L9 16.5L5.5 20Z" />
				<rect x="11" y="3" width="11" height="2" />
				<rect x="13" y="7" width="9" height="2" />
				<rect x="15" y="11" width="7" height="2" />
				<rect x="17" y="15" width="5" height="2" />
				<rect x="19" y="19" width="3" height="2" />
			</>
		),
	},
});
export const IconKeywordIncrease = svgIcon({
	default: {
		element: (
			<>
				<path d="M5.5 4L2 7.5L3.425 8.9L4.5 7.825V20H6.5V7.8L7.6 8.9L9 7.5L5.5 4Z" />
				<rect x="11" y="3" width="11" height="2" />
				<rect x="13" y="7" width="9" height="2" />
				<rect x="15" y="11" width="7" height="2" />
				<rect x="17" y="15" width="5" height="2" />
				<rect x="19" y="19" width="3" height="2" />
			</>
		),
	},
});
export const IconKeywordResearch = svgIcon({
	default: {
		element: (
			<>
				<path d="M10 16C11.6667 16 13.0833 15.4167 14.25 14.25C15.4167 13.0833 16 11.6667 16 10C16 8.33333 15.4167 6.91667 14.25 5.75C13.0833 4.58333 11.6667 4 10 4C8.33333 4 6.91667 4.58333 5.75 5.75C4.58333 6.91667 4 8.33333 4 10C4 11.6667 4.58333 13.0833 5.75 14.25C6.91667 15.4167 8.33333 16 10 16ZM6.5 9V7H13.5V9H6.5ZM20.6 22L14.925 16.325C14.2417 16.8583 13.4833 17.2708 12.65 17.5625C11.8167 17.8542 10.9333 18 10 18C7.76667 18 5.875 17.225 4.325 15.675C2.775 14.125 2 12.2333 2 10C2 7.76667 2.775 5.875 4.325 4.325C5.875 2.775 7.76667 2 10 2C12.2333 2 14.125 2.775 15.675 4.325C17.225 5.875 18 7.76667 18 10C18 10.9333 17.8542 11.8167 17.5625 12.65C17.2708 13.4833 16.8583 14.2417 16.325 14.925L22 20.6L20.6 22Z" />
				<path d="M6.5 10.5V12.5H10.5V10.5H6.5Z" />
			</>
		),
	},
});
export const IconLaptop = svgIcon({
	default: {
		element: (
			<path d="M48-144v-72h864v72H48Zm120-120q-29.7 0-50.85-21.15Q96-306.3 96-336v-408q0-29.7 21.15-50.85Q138.3-816 168-816h624q29.7 0 50.85 21.15Q864-773.7 864-744v408q0 29.7-21.15 50.85Q821.7-264 792-264H168Zm0-72h624v-408H168v408Zm0 0v-408 408Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLearn = svgIcon({
	default: {
		element: (
			<path d="M480-144 216-276v-240L48-600l432-216 432 216v312h-72v-276l-96 48v240L480-144Zm0-321 271-135-271-135-271 135 271 135Zm0 240 192-96v-159l-192 96-192-96v159l192 96Zm0-240Zm0 81Zm0 0Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLineChart = svgIcon({
	default: {
		element: <path d="m147-237-51-51 288-288 157 156 269-302 54 48-320 360-160-160-237 237Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLink = svgIcon({
	default: {
		element: (
			<path d="M432-288H288q-79.68 0-135.84-56.23Q96-400.45 96-480.23 96-560 152.16-616q56.16-56 135.84-56h144v72H288q-50 0-85 35t-35 85q0 50 35 85t85 35h144v72Zm-96-156v-72h288v72H336Zm192 156v-72h144q50 0 85-35t35-85q0-50-35-85t-85-35H528v-72h144q79.68 0 135.84 56.23 56.16 56.22 56.16 136Q864-400 807.84-344 751.68-288 672-288H528Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLinkIndicator = svgIcon({
	default: {
		element: <path d="m696-312-51-51 81-81H144v-72h582l-81-81 51-51 168 168-168 168Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconListAltCheck = svgIcon({
	default: {
		element: (
			<path d="M216-216v-528 444-85 169Zm0 72q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v312h-72v-312H216v528h264v72H216Zm475 48L556-232l51-51 84 85 170-170 51 51L691-96ZM323.79-444q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Zm0-156q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM432-444h240v-72H432v72Zm0-156h240v-72H432v72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLocation = svgIcon({
	default: {
		element: (
			<path d="M480.21-480Q510-480 531-501.21t21-51Q552-582 530.79-603t-51-21Q450-624 429-602.79t-21 51Q408-522 429.21-501t51 21ZM480-191q119-107 179.5-197T720-549q0-105-68.5-174T480-792q-103 0-171.5 69T240-549q0 71 60.5 161T480-191Zm0 95Q323.03-227.11 245.51-339.55 168-452 168-549q0-134 89-224.5T479.5-864q133.5 0 223 90.5T792-549q0 97-77 209T480-96Zm0-456Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLock = svgIcon({
	default: {
		element: (
			<path d="M263.72-96Q234-96 213-117.15T192-168v-384q0-29.7 21.15-50.85Q234.3-624 264-624h24v-96q0-79.68 56.23-135.84 56.22-56.16 136-56.16Q560-912 616-855.84q56 56.16 56 135.84v96h24q29.7 0 50.85 21.15Q768-581.7 768-552v384q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72Zm.28-72h432v-384H264v384Zm216.21-120Q510-288 531-309.21t21-51Q552-390 530.79-411t-51-21Q450-432 429-410.79t-21 51Q408-330 429.21-309t51 21ZM360-624h240v-96q0-50-35-85t-85-35q-50 0-85 35t-35 85v96Zm-96 456v-384 384Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconManage = svgIcon({
	default: {
		element: (
			<path d="M666-163 475-354q-20 8-43.5 12.5T384-337q-99 0-169.5-70T144-576q0-37.78 9.5-71.89T182-711l144 144 70-70-144-144q29-17 62.5-26t69.5-9q100 0 170 71t70 170.19q0 22.81-4.5 42.31Q615-513 607-493l195 194q14 14.35 14 34.67Q816-244 802-230l-68 67q-14.09 14-34.04 14Q680-149 666-163Zm34-68 35-34-215-213q20-24 26-52.5t6-44.5q0-66.85-47.5-116.42Q457-741 390-744l82 81q11 11.18 11 26.09t-11.29 26.12L351.29-491.21Q340-480 325.82-480T301-491l-85-85q0 69 49.5 118T384-409q17 0 47-7t56-28l213 213ZM476-488Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMarkEmailRead = svgIcon({
	default: {
		element: (
			<path d="M674-96 539-232l50-51 85 85 187-186 51 50L674-96ZM480-517l312-179H168l312 179Zm0 85L168-611v347h237l72 72H168q-29.7 0-50.85-21.16Q96-234.32 96-264.04v-432.24q0-29.72 21-51.22t51-20.5h624q30 1 51 21.86 21 20.85 21 50.14v208l-72 71v-194L480-432Zm0 0Zm0-85Zm0 84Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMap = svgIcon({
	default: {
		element: (
			<path d="m600-144-240-72-153 51q-23 8-43-6t-20-40v-498q0-16 9.5-28.5T177-755l183-61 240 72 153-51q23-10 43 5t20 41v498q0 16-9 29t-24 17l-183 61Zm-36-86v-450l-168-50v450l168 50Zm72-2 108-36v-448l-108 36v448Zm-420-12 108-36v-448l-108 36v448Zm420-436v448-448Zm-312-48v448-448Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMtassReporting = svgIcon({
	default: {
		element: (
			<>
				<path d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.42936 18.6167 8.2377 18.5C8.04603 18.3833 7.85853 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4458 4.5002 12.3375V11.6625C4.5002 11.5542 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.571 5.38333 15.7627 5.5C15.9544 5.61667 16.1419 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L20.2002 10.775C19.8335 10.5917 19.4585 10.4375 19.0752 10.3125C18.6919 10.1875 18.2835 10.1 17.8502 10.05L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2044 7.49583 14.7627 7.2375C14.321 6.97917 13.8419 6.78333 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67936 6.97917 9.2377 7.2375C8.79603 7.49583 8.39186 7.80833 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.7252 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.7252 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.30853 16.0833 8.6127 16.3375 8.9377 16.5625C9.2627 16.7875 9.61686 16.975 10.0002 17.125C10.0169 18.075 10.2127 18.9667 10.5877 19.8C10.9627 20.6333 11.4669 21.3667 12.1002 22H9.2502ZM10.2752 15.025C10.3752 14.6917 10.496 14.3708 10.6377 14.0625C10.7794 13.7542 10.9419 13.4583 11.1252 13.175C10.9419 13.0417 10.8002 12.8708 10.7002 12.6625C10.6002 12.4542 10.5502 12.2333 10.5502 12C10.5502 11.5833 10.696 11.2292 10.9877 10.9375C11.2794 10.6458 11.6335 10.5 12.0502 10.5C12.2835 10.5 12.5085 10.5542 12.7252 10.6625C12.9419 10.7708 13.1169 10.9167 13.2502 11.1C13.5335 10.9167 13.8252 10.7542 14.1252 10.6125C14.4252 10.4708 14.7419 10.3583 15.0752 10.275C14.7752 9.74167 14.3585 9.3125 13.8252 8.9875C13.2919 8.6625 12.7002 8.5 12.0502 8.5C11.0669 8.5 10.2377 8.84167 9.5627 9.525C8.8877 10.2083 8.5502 11.0333 8.5502 12C8.5502 12.6333 8.70436 13.2208 9.0127 13.7625C9.32103 14.3042 9.74186 14.725 10.2752 15.025Z" />
				<path d="M16.275 19.25L19.75 15.8L18.7 14.75L16.275 17.125L15.3 16.15L14.25 17.225L16.275 19.25ZM17 22C15.6167 22 14.4375 21.5125 13.4625 20.5375C12.4875 19.5625 12 18.3833 12 17C12 15.6167 12.4875 14.4375 13.4625 13.4625C14.4375 12.4875 15.6167 12 17 12C18.3833 12 19.5625 12.4875 20.5375 13.4625C21.5125 14.4375 22 15.6167 22 17C22 18.3833 21.5125 19.5625 20.5375 20.5375C19.5625 21.5125 18.3833 22 17 22Z" />
			</>
		),
	},
});
export const IconMatrix = svgIcon({
	default: {
		element: (
			<path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM10.325 19H13.675V15.675H10.325V19ZM15.675 19H19V15.675H15.675V19ZM5 13.675H8.325V10.325H5V13.675ZM15.675 13.675H19V10.325H15.675V13.675ZM5 8.325H8.325V5H5V8.325ZM10.325 8.325H13.675V5H10.325V8.325ZM15.675 8.325H19V5H15.675V8.325Z" />
		),
	},
});
export const IconMediumConnection = svgIcon({
	default: {
		element: <path d="m80-80 800-800v800H80Zm440-80h280v-526L520-406v246Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMenu = svgIcon({
	default: {
		element: <path d="M144-264v-72h672v72H144Zm0-180v-72h672v72H144Zm0-180v-72h672v72H144Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMessage = svgIcon({
	default: {
		element: (
			<path d="M240-384h336v-72H240v72Zm0-132h480v-72H240v72Zm0-132h480v-72H240v72ZM96-96v-696q0-29.7 21.15-50.85Q138.3-864 168-864h624q29.7 0 50.85 21.15Q864-821.7 864-792v480q0 29.7-21.15 50.85Q821.7-240 792-240H240L96-96Zm114-216h582v-480H168v522l42-42Zm-42 0v-480 480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMobile = svgIcon({
	default: {
		element: (
			<path d="M20,7 L20,17 L4,17 L4,7 L20,7 M20,5 L4,5 C2.9,5 2.01,5.9 2.01,7 L2,17 C2,18.1 2.9,19 4,19 L20,19 C21.1,19 22,18.1 22,17 L22,7 C22,5.9 21.1,5 20,5 Z M11,8 L13,8 L13,10 L11,10 L11,8 Z M11,11 L13,11 L13,13 L11,13 L11,11 Z M8,8 L10,8 L10,10 L8,10 L8,8 Z M8,11 L10,11 L10,13 L8,13 L8,11 Z M5,11 L7,11 L7,13 L5,13 L5,11 Z M5,8 L7,8 L7,10 L5,10 L5,8 Z M8,14 L16,14 L16,16 L8,16 L8,14 Z M14,11 L16,11 L16,13 L14,13 L14,11 Z M14,8 L16,8 L16,10 L14,10 L14,8 Z M17,11 L19,11 L19,13 L17,13 L17,11 Z M17,8 L19,8 L19,10 L17,10 L17,8 Z" />
		),
	},
});
export const IconMotoric = svgIcon({
	default: {
		element: (
			<path d="M160-200q-33 0-56.5-23.5T80-280v-400q0-33 23.5-56.5T160-760h640q33 0 56.5 23.5T880-680v400q0 33-23.5 56.5T800-200H160Zm0-80h640v-400H160v400Zm160-40h320v-80H320v80ZM200-440h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80ZM200-560h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80Zm120 0h80v-80h-80v80ZM160-280v-400 400Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMouseCursor = svgIcon({
	default: {
		element: (
			<path d="M524-99q-11 2-22 2.5t-22 .5q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 11-.5 22t-1.5 22l-70-22v-22q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91q5 0 11-.5t11-.5l22 70Zm296 27L654-239 600-96 480-480l384 120-143 53 167 167-68 68Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMove = svgIcon({
	default: {
		element: (
			<path d="M480-96 312-264l51-51 81 81v-174h72v174l81-81 51 51L480-96ZM264-312 96-480l168-168 51 51-81 81h174v72H234l81 81-51 51Zm432 0-51-51 81-81H552v-72h174l-81-81 51-51 168 168-168 168ZM444-552v-174l-81 81-51-51 168-168 168 168-51 51-81-81v174h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconMyProfile = svgIcon({
	default: {
		element: (
			<path d="M237-285q54-38 115.5-56.5T480-360q66 0 127.5 18.5T723-285q35-41 52-91t17-104q0-129.67-91.23-220.84-91.23-91.16-221-91.16Q350-792 259-700.84 168-609.67 168-480q0 54 17 104t52 91Zm243-123q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm.28 312Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q52 0 100-16.5t90-48.5q-43-27-91-41t-99-14q-51 0-99.5 13.5T290-233q42 32 90 48.5T480-168Zm0-312q30 0 51-21t21-51q0-30-21-51t-51-21q-30 0-51 21t-21 51q0 30 21 51t51 21Zm0-72Zm0 319Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconNoServices = svgIcon({
	default: {
		element: (
			<path d="M9.175 14.825C9.95833 15.6083 10.9 16 12 16C13.1 16 14.0417 15.6083 14.825 14.825C15.6083 14.0417 16 13.1 16 12C16 10.9 15.6083 9.95833 14.825 9.175C14.0417 8.39167 13.1 8 12 8C10.9 8 9.95833 8.39167 9.175 9.175C8.39167 9.95833 8 10.9 8 12C8 13.1 8.39167 14.0417 9.175 14.825Z" />
		),
	},
});
export const IconOpenNew = svgIcon({
	default: {
		element: (
			<path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h264v72H216v528h528v-264h72v264q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm171-192-51-51 357-357H576v-72h240v240h-72v-117L387-336Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconOptions = svgIcon({
	default: {
		element: (
			<path d="M263.79-408Q234-408 213-429.21t-21-51Q192-510 213.21-531t51-21Q294-552 315-530.79t21 51Q336-450 314.79-429t-51 21Zm216 0Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21Zm216 0Q666-408 645-429.21t-21-51Q624-510 645.21-531t51-21Q726-552 747-530.79t21 51Q768-450 746.79-429t-51 21Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPage = svgIcon({
	default: {
		element: (
			<path d="M263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72ZM528-624v-168H264v624h432v-456H528ZM264-792v189-189 624-624Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPageAlert = svgIcon({
	default: {
		element: (
			<>
				<path d="M20 8V11H18V9H13V4H6V20H10V22H6C5.45 22 4.97956 21.8038 4.58789 21.4121C4.19622 21.0204 4 20.55 4 20V4C4 3.45 4.19622 2.97956 4.58789 2.58789C4.97956 2.19622 5.45 2 6 2H14L20 8Z" />
				<path d="M17 23C15.6167 23 14.4375 22.5125 13.4625 21.5375C12.4875 20.5625 12 19.3833 12 18C12 16.6167 12.4875 15.4375 13.4625 14.4625C14.4375 13.4875 15.6167 13 17 13C18.3833 13 19.5625 13.4875 20.5375 14.4625C21.5125 15.4375 22 16.6167 22 18C22 19.3833 21.5125 20.5625 20.5375 21.5375C19.5625 22.5125 18.3833 23 17 23ZM16.5 19H17.5V15H16.5V19ZM17 21C17.1333 21 17.25 20.95 17.35 20.85C17.45 20.75 17.5 20.6333 17.5 20.5C17.5 20.3667 17.45 20.25 17.35 20.15C17.25 20.05 17.1333 20 17 20C16.8667 20 16.75 20.05 16.65 20.15C16.55 20.25 16.5 20.3667 16.5 20.5C16.5 20.6333 16.55 20.75 16.65 20.85C16.75 20.95 16.8667 21 17 21Z" />
			</>
		),
	},
});
export const IconPageAnalytics = svgIcon({
	default: {
		element: (
			<path d="M120-120v-80l80-80v160h-80Zm160 0v-240l80-80v320h-80Zm160 0v-320l80 81v239h-80Zm160 0v-239l80-80v319h-80Zm160 0v-400l80-80v480h-80ZM120-327v-113l280-280 160 160 280-280v113L560-447 400-607 120-327Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPageInspector = svgIcon({
	default: {
		element: (
			<path d="m592-168 72 72H264q-29.7 0-50.85-21.15Q192-138.3 192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v476q0 36-5.5 54T746-116L553-309q-15 10-34 14.5t-39 4.5q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 20-5 39.5T604-360l92 92v-374L546-792H264v624h328ZM480.21-362Q510-362 531-383.21t21-51Q552-464 530.79-485t-51-21Q450-506 429-484.79t-21 51Q408-404 429.21-383t51 21Zm-.21-82Zm0 0Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPageReport = svgIcon({
	default: {
		element: (
			<path d="M340-460h280v-64H340v64Zm0 120h280v-64H340v64Zm0 120h174v-64H340v64ZM263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72ZM528-624v-168H264v624h432v-456H528ZM264-792v168-168 624-624Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPause = svgIcon({
	default: {
		element: (
			<path d="M528-192v-576h240v576H528Zm-336 0v-576h240v576H192Zm408-72h96v-432h-96v432Zm-336 0h96v-432h-96v432Zm0-432v432-432Zm336 0v432-432Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPdf = svgIcon({
	default: {
		element: (
			<>
				<path d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z" />
				<path d="M11.8319 9C11.282 9 10.8701 9.37344 10.7891 10.0234C10.7092 10.6724 11.0308 11.8073 11.5918 12.8613C11.3508 13.5913 11.1101 14.2397 10.7891 14.8887C9.74631 15.2127 8.78422 15.6985 8.38328 16.1855C7.74239 16.9145 8.06318 17.4015 8.22315 17.6445C8.38413 17.8875 8.62475 18 8.94569 18C9.10667 18 9.26706 17.9677 9.42804 17.8867C10.0699 17.6437 10.7097 16.6702 11.3516 15.5352C11.9125 15.3732 12.474 15.2119 13.0349 15.1309C13.5958 15.7789 14.1592 16.1857 14.6401 16.3477C15.201 16.5097 15.6821 16.2653 15.9231 15.6973C16.0831 15.2103 16.0018 14.8065 15.6009 14.5625C15.1189 14.2385 14.317 14.2374 13.3551 14.3184C13.0342 13.8324 12.7154 13.3464 12.4744 12.8594C12.8754 11.6434 13.0347 10.5904 12.8747 9.94141C12.7138 9.37341 12.3819 9 11.8319 9Z" />
			</>
		),
	},
});
export const IconPeriod = svgIcon({
	default: {
		element: (
			<path d="m614-310 51-51-149-149v-210h-72v240l170 170ZM480-96q-79.38 0-149.19-30T208.5-208.5Q156-261 126-330.96t-30-149.5Q96-560 126-630q30-70 82.5-122t122.46-82q69.96-30 149.5-30t149.55 30.24q70 30.24 121.79 82.08 51.78 51.84 81.99 121.92Q864-559.68 864-480q0 79.38-30 149.19T752-208.5Q700-156 629.87-126T480-96Zm0-384Zm.48 312q129.47 0 220.5-91.5Q792-351 792-480.48q0-129.47-91.02-220.5Q609.95-792 480.48-792 351-792 259.5-700.98 168-609.95 168-480.48 168-351 259.5-259.5T480.48-168Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPieChart = svgIcon({
	default: {
		element: (
			<path d="M516-516h274q-12-109-88.5-185.5T516-790v274Zm-72 346v-620q-118 14-197 102t-79 207.5q0 119.5 79 208T444-170Zm72 0q108-13 185-90t89-184H516v274Zm-36-310Zm.46 384q-79.54 0-149.5-30T208.5-208.5Q156-261 126-330.96t-30-149.5Q96-560 126-630q30-70 82.5-122t122.46-82q69.96-30 149.5-30t149.07 30.24q69.52 30.24 121.79 82.56 52.26 52.32 82.47 121.92T864-480q0 78.72-30.21 148.8-30.21 70.08-81.99 122.4-51.79 52.32-121.79 82.56Q560-96 480.46-96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPin = svgIcon({
	default: {
		element: (
			<path d="m624-480 96 96v72H516v228l-36 36-36-36v-228H240v-72l96-96v-264h-48v-72h384v72h-48v264Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPinLocation = svgIcon({
	default: {
		element: (
			<path d="M480-307q96-79 144-151.5t48-135.1q0-86.68-53.5-142.54Q565-792 480-792t-138.5 56Q288-680 288-594.06 288-532 336-460t144 153Zm0 91Q346-317 281-410.61q-65-93.6-65-183.39 0-118.01 73.56-194 73.56-76 190.5-76t190.44 76Q744-712.01 744-594q0 89.79-65 183.39Q614-317 480-216Zm.21-312Q510-528 531-549.21t21-51Q552-630 530.79-651t-51-21Q450-672 429-650.79t-21 51Q408-570 429.21-549t51 21ZM216-96v-72h528v72H216Zm264-504Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPotentialIssue = svgIcon({
	default: {
		element: (
			<>
				<path d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />
				<path d="M17 16H7L12 7L17 16ZM10.3994 14H13.6006L12 11.1182L10.3994 14Z" />
			</>
		),
	},
});
export const IconIndustryBenchmark = svgIcon({
	default: {
		element: (
			<path d="M96-96v-456l264-120v84l192-84v120h312v456H96Zm72-72h624v-312H480v-82l-192 84v-82l-120 55v337Zm276-72h72v-168h-72v168Zm-156 0h72v-168h-72v168Zm312 0h72v-168h-72v168Zm264-312H672l48-312h96l48 312ZM168-168h624-624Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPrint = svgIcon({
	default: {
		element: (
			<path d="M648-624v-120H312v120h-72v-192h480v192h-72Zm-480 72h625-625Zm539.79 96q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM648-216v-144H312v144h336Zm72 72H240v-144H96v-240q0-40 28-68t68-28h576q40 0 68 28t28 68v240H720v144Zm73-216v-153.67Q793-530 781-541t-28-11H206q-16.15 0-27.07 11.04Q168-529.92 168-513.6V-360h72v-72h480v72h73Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPersonAdd = svgIcon({
	default: {
		element: (
			<path d="M708-432v-84h-84v-72h84v-84h72v84h84v72h-84v84h-72Zm-324-48q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM96-192v-92q0-25.78 12.5-47.39T143-366q55-32 116-49t125-17q64 0 125 17t116 49q22 13 34.5 34.61T672-284v92H96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPersonAddOutline = svgIcon({
	default: {
		element: (
			<path d="M708-432v-84h-84v-72h84v-84h72v84h84v72h-84v84h-72Zm-324-48q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM96-192v-92q0-25.78 12.5-47.39T143-366q55-32 116-49t125-17q64 0 125 17t116 49q22 13 34.5 34.61T672-284v92H96Zm72-72h432v-20q0-6.47-3.03-11.76-3.02-5.3-7.97-8.24-47-27-99-41.5T384-360q-54 0-106 14.5T179-304q-4.95 2.94-7.98 8.24Q168-290.47 168-284v20Zm216.21-288Q414-552 435-573.21t21-51Q456-654 434.79-675t-51-21Q354-696 333-674.79t-21 51Q312-594 333.21-573t51 21Zm-.21-73Zm0 361Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPersonRemove = svgIcon({
	default: {
		element: (
			<path d="M624-504v-72h240v72H624Zm-240 24q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM96-192v-92q0-26 12.5-47.5T143-366q55-32 116-49t125-17q64 0 125 17t116 49q22 13 34.5 34.5T672-284v92H96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconPersonRemoveOutline = svgIcon({
	default: {
		element: (
			<path d="M624-504v-72h240v72H624Zm-240 24q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM96-192v-92q0-25.78 12.5-47.39T143-366q55-32 116-49t125-17q64 0 125 17t116 49q22 13 34.5 34.61T672-284v92H96Zm72-72h432v-20q0-6.47-3.03-11.76-3.02-5.3-7.97-8.24-47-27-99-41.5T384-360q-54 0-106 14.5T179-304q-4.95 2.94-7.98 8.24Q168-290.47 168-284v20Zm216.21-288Q414-552 435-573.21t21-51Q456-654 434.79-675t-51-21Q354-696 333-674.79t-21 51Q312-594 333.21-573t51 21Zm-.21-73Zm0 361Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductAppAnalytics = svgIcon({
	default: {
		element: (
			<>
				<path d="M17 5C17 4.71732 16.9107 4.50055 16.7051 4.29492C16.4995 4.0893 16.2827 4 16 4H8C7.71732 4 7.50055 4.0893 7.29492 4.29492C7.0893 4.50055 7 4.71733 7 5V19C7 19.2827 7.0893 19.4995 7.29492 19.7051C7.50055 19.9107 7.71732 20 8 20H17.4121V22H8C7.18268 22 6.45857 21.6968 5.88086 21.1191C5.30315 20.5414 5 19.8173 5 19V5C5 4.18267 5.30315 3.45857 5.88086 2.88086C6.45857 2.30315 7.18268 2 8 2H16C16.8173 2 17.5414 2.30315 18.1191 2.88086C18.6968 3.45857 19 4.18268 19 5V8H17V5Z" />
				<path d="M12.7125 7.7125C12.5208 7.90417 12.2833 8 12 8C11.7167 8 11.4792 7.90417 11.2875 7.7125C11.0958 7.52083 11 7.28333 11 7C11 6.71667 11.0958 6.47917 11.2875 6.2875C11.4792 6.09583 11.7167 6 12 6C12.2833 6 12.5208 6.09583 12.7125 6.2875C12.9042 6.47917 13 6.71667 13 7C13 7.28333 12.9042 7.52083 12.7125 7.7125Z" />
				<path fillRule="evenodd" clipRule="evenodd" d="M11 14V18H9V14H11Z" />
				<path fillRule="evenodd" clipRule="evenodd" d="M15 10V18H13V10H15Z" />
				<path fillRule="evenodd" clipRule="evenodd" d="M19 12V18H17V12H19Z" />
			</>
		),
	},
});
export const IconProductAds = svgIcon({
	default: {
		element: (
			<path d="M96-456v-72h120v72H96Zm147 216-51-51 85-84 51 50-85 85Zm34-392-85-85 51-51 84 85-50 51Zm471 488L557-335l-53 143-120-384 384 120-143 53 191 191-68 68ZM432-696v-120h72v120h-72Zm203 63-51-50 85-85 51 51-85 84Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductBrand = svgIcon({
	default: {
		element: (
			<>
				<path d="M7.5 22C6.51667 22 5.6875 21.6625 5.0125 20.9875C4.3375 20.3125 4 19.4833 4 18.5V5.5C4 4.53333 4.3375 3.70833 5.0125 3.025C5.6875 2.34167 6.51667 2 7.5 2H20V17C19.5667 17 19.2083 17.1458 18.925 17.4375C18.6417 17.7292 18.5 18.0833 18.5 18.5C18.5 18.9333 18.6417 19.2917 18.925 19.575C19.2083 19.8583 19.5667 20 20 20V22H7.5ZM7.5 20H16.825C16.725 19.7667 16.6458 19.5292 16.5875 19.2875C16.5292 19.0458 16.5 18.7833 16.5 18.5C16.5 18.2333 16.525 17.975 16.575 17.725C16.625 17.475 16.7083 17.2333 16.825 17H7.5C7.06667 17 6.70833 17.1458 6.425 17.4375C6.14167 17.7292 6 18.0833 6 18.5C6 18.9333 6.14167 19.2917 6.425 19.575C6.70833 19.8583 7.06667 20 7.5 20ZM6 15.325C6.23333 15.2083 6.47083 15.125 6.7125 15.075C6.95417 15.025 7.21667 15 7.5 15H18V4H7.5C7.06667 4 6.70833 4.14583 6.425 4.4375C6.14167 4.72917 6 5.08333 6 5.5V15.325Z" />
				<path d="M8 10.15L10.825 12.975L15.4 8.4L14 7L10.825 10.175L9.4 8.75L8 10.15Z" />
			</>
		),
	},
});
export const IconProductCoreWins = svgIcon({
	default: {
		element: (
			<path d="M407.74-240Q378-240 357-261.15 336-282.3 336-312v-67q-57-37.3-88.5-95.65Q216-533 216-600q0-110.31 76.78-187.16 76.78-76.84 187-76.84T667-787.16q77 76.85 77 187.16 0 66.82-31.5 125.41T624-379v67q0 29.7-21.18 50.85Q581.65-240 551.91-240H407.74Zm.26-72h144v-106l33-21q41-26 64-69.18 23-43.18 23-91.82 0-79.68-56.23-135.84-56.22-56.16-136-56.16Q400-792 344-735.84 288-679.68 288-600q0 48.64 23 91.82Q334-465 375-439l33 21v106Zm0 216q-20.4 0-34.2-13.8Q360-123.6 360-144v-24h240v24q0 20.4-13.8 34.2Q572.4-96 552-96H408Zm72-504Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductContentQuality = svgIcon({
	default: {
		element: (
			<>
				<path d="M18.915 3L22.1914 9.47266L12 21.5508L9.73535 18.8672L11.2646 17.5771L12 18.4482L19.8076 9.19434L17.6855 5H6.31445L4.19141 9.19434L5.11426 10.2881L3.58594 11.5781L1.80859 9.47266L5.08496 3H18.915Z" />
				<path d="M12.175 12.425L6.525 18.075L3 14.55L4.425 13.125L6.525 15.225L10.75 11L12.175 12.425Z" />
			</>
		),
	},
});
export const IconProductDashboard = svgIcon({
	default: {
		element: (
			<path d="M528-624v-192h288v192H528ZM144-432v-384h288v384H144Zm384 288v-384h288v384H528Zm-384 0v-192h288v192H144Zm72-360h144v-240H216v240Zm384 288h144v-240H600v240Zm0-479h144v-49H600v49ZM216-216h144v-48H216v48Zm144-288Zm240-191Zm0 239ZM360-264Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductDataPrivacy = svgIcon({
	default: {
		element: (
			<path d="M480-96q-135-33-223.5-152.84Q168-368.69 168-515v-229l312-120 312 120v229q0 146.31-88.5 266.16Q615-129 480-96Zm0-75q104-32.25 172-129t68-215v-180l-240-92-240 92v180q0 118.25 68 215t172 129Zm0-308Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductDCI = svgIcon({
	default: {
		element: (
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.0127 3.99743L12.0114 3.99885C12.1595 3.99906 12.3075 4.00337 12.4554 4.0118C13.1287 4.05017 13.799 4.17377 14.4499 4.38308C16.198 4.94522 17.6995 6.09142 18.7027 7.62939C19.7059 9.16735 20.1497 11.0035 19.9596 12.8299C19.7695 14.6562 18.9571 16.3617 17.6587 17.6601C16.3603 18.9585 14.6548 19.7709 12.8285 19.961C11.0021 20.1511 9.16593 19.7073 7.62796 18.7041C6.09 17.7009 4.9438 16.1994 4.38166 14.4513C3.93884 13.0743 3.87966 11.6103 4.19954 10.2142C4.28572 9.83802 4.39943 9.46677 4.54058 9.10346L4.90224 8.17253L3.04038 7.4492L2.67872 8.38013C2.50236 8.83408 2.36027 9.29799 2.25256 9.76809C1.85285 11.5127 1.92677 13.3421 2.48013 15.0628C3.18259 17.2472 4.61487 19.1235 6.53671 20.3771C8.45856 21.6307 10.753 22.1852 13.0353 21.9477C15.3175 21.7101 17.4486 20.695 19.0711 19.0725C20.6935 17.45 21.7087 15.3189 21.9463 13.0367C22.1838 10.7545 21.6293 8.45998 20.3757 6.53814C19.1221 4.61629 17.2458 3.18401 15.0614 2.48156C14.2481 2.22002 13.4105 2.06556 12.569 2.01761C12.3842 2.00708 12.1992 2.00168 12.0143 2.00142L11.0156 2L11.0127 3.99743Z"
			/>
		),
	},
});
export const IconProductDyanamicContent = svgIcon({
	default: {
		element: (
			<>
				<path d="M4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V9H19V5H4V17H5.8L7.775 19H4Z" />
				<path d="M19.931 22L15.4524 17.5214L14.1429 21.4762L11 11L21.4762 14.1429L17.5214 15.4524L22 19.931L19.931 22Z" />
			</>
		),
	},
});
export const IconProductMarketingAnalytics = svgIcon({
	default: {
		element: (
			<>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.0088 15.4714L15.0088 22L13 22L13 15.4714L15.0088 15.4714Z"
				/>
				<path fillRule="evenodd" clipRule="evenodd" d="M20 11L20 22L18 22L18 11L20 11Z" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21.4072 3.79496L14.8467 10.3265C14.8341 10.339 14.8211 10.3512 14.8078 10.3631C14.6695 10.4861 14.5058 10.5832 14.3263 10.6493C14.1468 10.7154 13.9548 10.7493 13.761 10.7493C13.5673 10.7493 13.3752 10.7154 13.1957 10.6493C13.0163 10.5832 12.8526 10.4861 12.7144 10.3632C12.7144 10.3632 12.7145 10.3633 12.7144 10.3632L9.92907 7.89179L4.41335 12.7859L3 11.5066L8.8837 6.28596C9.16264 6.03853 9.53892 5.90103 9.92907 5.90103C10.3192 5.90103 10.6954 6.03844 10.9743 6.28586L13.7387 8.7387L19.9142 2.59052L21.4072 3.79496Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.00882 17.4802L5.00882 22L3 22L3 17.4802L5.00882 17.4802Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.0088 13.4625L10.0088 22L8 22L8 13.4625L10.0088 13.4625Z"
				/>
			</>
		),
	},
});
export const IconProductPerformance = svgIcon({
	default: {
		element: (
			<>
				<path d="M16.4424 10.9043L12 15.3467L10.6533 14L15.0957 9.55762L16.4424 10.9043Z" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 4C13.7522 4 15.4748 4.45264 16.9941 5.31445C18.5134 6.17625 19.7767 7.41752 20.6562 8.91406C21.5359 10.4109 22.0001 12.111 22 13.8418C21.9999 15.5724 21.5359 17.2719 20.6562 18.7686L20.1738 19.5898L19.9205 20H4.07319L3.82617 19.5898L3.34375 18.7686C2.46407 17.2719 2.00014 15.5724 2 13.8418C1.99993 12.111 2.46412 10.4109 3.34375 8.91406C4.22328 7.41752 5.48656 6.17625 7.00586 5.31445C8.52522 4.45264 10.2478 4 12 4ZM12 5.9043C10.5758 5.9043 9.17774 6.27323 7.94629 6.97168C6.71489 7.67015 5.69395 8.67405 4.98535 9.87988C4.27699 11.0855 3.90424 12.4521 3.9043 13.8418C3.90444 15.2313 4.27701 16.5973 4.98535 17.8027L5.10156 18H18.8984L19.0146 17.8027C19.723 16.5973 20.0956 15.2313 20.0957 13.8418C20.0958 12.4521 19.723 11.0855 19.0146 9.87988C18.306 8.67405 17.2851 7.67015 16.0537 6.97168C14.8223 6.27323 13.4242 5.9043 12 5.9043Z"
				/>
			</>
		),
	},
});
export const IconProductPolicy = svgIcon({
	default: {
		element: (
			<path d="M192-144v-72h432v72H192Zm204-195L192-542l85-85 203 204-84 84Zm237-237L430-779l84-85 204 204-85 84Zm180 384L327-678l51-51 486 486-51 51Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductSeoAdvanced = svgIcon({
	default: {
		element: (
			<>
				<path d="M18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11ZM20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11Z" />
				<path d="M21.4144 20.5859L20.0002 22.0002L15 17L16.4142 15.5858L21.4144 20.5859Z" />
				<path d="M8 14H6V11H8V14Z" />
				<path d="M12 14H10V9.5H12V14Z" />
				<path d="M16 14H14V8H16V14Z" />
			</>
		),
	},
});
export const IconProductSeoAudit = svgIcon({
	default: {
		element: (
			<>
				<path d="M12 22V20H18V9H13V4H6V9H4V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H12Z" />
				<path d="M2 15.6L5.6 19.2L7 17.775L4.825 15.6L7 13.425L5.6 12L2 15.6Z" />
				<path d="M9 17.775L10.4 19.2L14 15.6L10.4 12L9 13.425L11.175 15.6L9 17.775Z" />
			</>
		),
	},
});
export const IconProductSocialPerformance = svgIcon({
	default: {
		element: (
			<>
				<path d="M4 12.1719L4.17188 12H15V4H4V12.1719ZM17 12.5C17 12.9125 16.8533 13.2658 16.5596 13.5596L16.4463 13.6631C16.1763 13.8878 15.8608 14 15.5 14H5L2 17V3.5C2 3.0875 2.14668 2.73418 2.44043 2.44043C2.73418 2.14668 3.0875 2 3.5 2H15.5C15.9125 2 16.2658 2.14668 16.5596 2.44043C16.8533 2.73418 17 3.0875 17 3.5V12.5Z" />
				<path fillRule="evenodd" clipRule="evenodd" d="M13 18.0001V22.0001H11V18.0001H13Z" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.5003 16.0002V22.0002H15.5002V16.0002H17.5003Z"
				/>
				<path fillRule="evenodd" clipRule="evenodd" d="M22 14.0001V22.0002H20V14.0001H22Z" />
			</>
		),
	},
});
export const IconProductTechSupport = svgIcon({
	default: {
		element: (
			<>
				<path d="M2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z" />
				<path d="M7 10L10 13L11.1667 11.8125L9.35417 10L11.1667 8.1875L10 7L7 10Z" />
				<path d="M12.8333 11.8125L14 13L17 10L14 7L12.8333 8.1875L14.6458 10L12.8333 11.8125Z" />
			</>
		),
	},
});

export const IconProductUsability = svgIcon({
	default: {
		element: (
			<path d="M200-200v-560 179-19 400Zm80-240h221q2-22 10-42t20-38H280v80Zm0 160h157q17-20 39-32.5t46-20.5q-4-6-7-13t-5-14H280v80Zm0-320h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v258q-14-26-34-46t-46-33v-179H200v560h202q-1 6-1.5 12t-.5 12v56H200Zm480-200q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM480-120v-56q0-24 12.5-44.5T528-250q36-15 74.5-22.5T680-280q39 0 77.5 7.5T832-250q23 9 35.5 29.5T880-176v56H480Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconProductVpnConnect = svgIcon({
	default: {
		element: (
			<path d="M11 23C9.63333 23 8.34167 22.7375 7.125 22.2125C5.90833 21.6875 4.84583 20.9708 3.9375 20.0625C3.02917 19.1542 2.3125 18.0917 1.7875 16.875C1.2625 15.6583 1 14.3667 1 13C1 11.6167 1.2625 10.3208 1.7875 9.1125C2.3125 7.90417 3.02917 6.84583 3.9375 5.9375C4.84583 5.02917 5.90833 4.3125 7.125 3.7875C8.34167 3.2625 9.63333 3 11 3C11.5333 3 12.0458 3.0375 12.5375 3.1125C13.0292 3.1875 13.5167 3.3 14 3.45V6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8H10V10C10 10.2833 9.90417 10.5208 9.7125 10.7125C9.52083 10.9042 9.28333 11 9 11H7V13H13C13.2833 13 13.5208 13.0958 13.7125 13.2875C13.9042 13.4792 14 13.7167 14 14V17H15C15.45 17 15.8458 17.1333 16.1875 17.4C16.5292 17.6667 16.7667 18 16.9 18.4C17.55 17.6667 18.0625 16.8458 18.4375 15.9375C18.8125 15.0292 19 14.05 19 13C19 12.8167 18.9917 12.65 18.975 12.5C18.9583 12.35 18.9333 12.1833 18.9 12H20.95C20.9833 12.1833 21 12.35 21 12.5V13C21 14.3667 20.7375 15.6583 20.2125 16.875C19.6875 18.0917 18.9708 19.1542 18.0625 20.0625C17.1542 20.9708 16.0958 21.6875 14.8875 22.2125C13.6792 22.7375 12.3833 23 11 23ZM10 20.95V19C9.45 19 8.97917 18.8042 8.5875 18.4125C8.19583 18.0208 8 17.55 8 17V16L3.2 11.2C3.15 11.5 3.10417 11.8 3.0625 12.1C3.02083 12.4 3 12.7 3 13C3 15.0667 3.67083 16.8458 5.0125 18.3375C6.35417 19.8292 8.01667 20.7 10 20.95ZM17 10C16.7167 10 16.4792 9.90417 16.2875 9.7125C16.0958 9.52083 16 9.28333 16 9V6C16 5.71667 16.0958 5.47917 16.2875 5.2875C16.4792 5.09583 16.7167 5 17 5V4C17 3.45 17.1958 2.97917 17.5875 2.5875C17.9792 2.19583 18.45 2 19 2C19.55 2 20.0208 2.19583 20.4125 2.5875C20.8042 2.97917 21 3.45 21 4V5C21.2833 5 21.5208 5.09583 21.7125 5.2875C21.9042 5.47917 22 5.71667 22 6V9C22 9.28333 21.9042 9.52083 21.7125 9.7125C21.5208 9.90417 21.2833 10 21 10H17ZM18 5H20V4C20 3.71667 19.9042 3.47917 19.7125 3.2875C19.5208 3.09583 19.2833 3 19 3C18.7167 3 18.4792 3.09583 18.2875 3.2875C18.0958 3.47917 18 3.71667 18 4V5Z" />
		),
	},
});
export const IconProductSettings = svgIcon({
	default: {
		element: (
			<path d="M9.24995 22L8.84995 18.8C8.63328 18.7167 8.42912 18.6167 8.23745 18.5C8.04578 18.3833 7.85828 18.2583 7.67495 18.125L4.69995 19.375L1.94995 14.625L4.52495 12.675C4.50828 12.5583 4.49995 12.4458 4.49995 12.3375V11.6625C4.49995 11.5542 4.50828 11.4417 4.52495 11.325L1.94995 9.375L4.69995 4.625L7.67495 5.875C7.85828 5.74167 8.04995 5.61667 8.24995 5.5C8.44995 5.38333 8.64995 5.28333 8.84995 5.2L9.24995 2H14.75L15.15 5.2C15.3666 5.28333 15.5708 5.38333 15.7625 5.5C15.9541 5.61667 16.1416 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4916 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1416 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.24995ZM11 20H12.975L13.325 17.35C13.8416 17.2167 14.3208 17.0208 14.7625 16.7625C15.2041 16.5042 15.6083 16.1917 15.975 15.825L18.45 16.85L19.425 15.15L17.275 13.525C17.3583 13.2917 17.4166 13.0458 17.45 12.7875C17.4833 12.5292 17.5 12.2667 17.5 12C17.5 11.7333 17.4833 11.4708 17.45 11.2125C17.4166 10.9542 17.3583 10.7083 17.275 10.475L19.425 8.85L18.45 7.15L15.975 8.2C15.6083 7.81667 15.2041 7.49583 14.7625 7.2375C14.3208 6.97917 13.8416 6.78333 13.325 6.65L13 4H11.025L10.675 6.65C10.1583 6.78333 9.67912 6.97917 9.23745 7.2375C8.79578 7.49583 8.39162 7.80833 8.02495 8.175L5.54995 7.15L4.57495 8.85L6.72495 10.45C6.64162 10.7 6.58328 10.95 6.54995 11.2C6.51662 11.45 6.49995 11.7167 6.49995 12C6.49995 12.2667 6.51662 12.525 6.54995 12.775C6.58328 13.025 6.64162 13.275 6.72495 13.525L4.57495 15.15L5.54995 16.85L8.02495 15.8C8.39162 16.1833 8.79578 16.5042 9.23745 16.7625C9.67912 17.0208 10.1583 17.2167 10.675 17.35L11 20ZM12.05 15.5C13.0166 15.5 13.8416 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8416 8.84167 13.0166 8.5 12.05 8.5C11.0666 8.5 10.2375 8.84167 9.56245 9.525C8.88745 10.2083 8.54995 11.0333 8.54995 12C8.54995 12.9667 8.88745 13.7917 9.56245 14.475C10.2375 15.1583 11.0666 15.5 12.05 15.5Z" />
		),
	},
});
export const IconInProgress = svgIcon({
	default: {
		element: (
			<path d="M480-240q100 0 170-70t70-170q0-100-70-170t-170-70v240L310-310q33 32 76.5 51t93.5 19Zm.28 144Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconQuestionAnswer = svgIcon({
	default: {
		element: (
			<path d="M864-96 720-240H360q-29.7 0-50.85-21.15Q288-282.3 288-312v-48h384q29.7 0 50.85-21.15Q744-402.3 744-432v-240h48q29.7 0 50.85 21.15Q864-629.7 864-600v504ZM168-462l42-42h390v-288H168v330ZM96-288v-504q0-29.7 21.15-50.85Q138.3-864 168-864h432q29.7 0 50.85 21.15Q672-821.7 672-792v288q0 29.7-21.15 50.85Q629.7-432 600-432H240L96-288Zm72-216v-288 288Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconQuickCreation = svgIcon({
	default: {
		element: (
			<path d="m437-249 183-231H471l26-221-173 269h146l-33 183ZM336-96l48-264H192l324-504h72l-36 312h216L408-96h-72Zm136-379Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconReading = svgIcon({
	default: {
		element: (
			<path d="M14 9.9V8.2C14.55 7.96667 15.1125 7.79167 15.6875 7.675C16.2625 7.55833 16.8667 7.5 17.5 7.5C17.9333 7.5 18.3583 7.53333 18.775 7.6C19.1917 7.66667 19.6 7.75 20 7.85V9.45C19.6 9.3 19.1958 9.1875 18.7875 9.1125C18.3792 9.0375 17.95 9 17.5 9C16.8667 9 16.2583 9.07917 15.675 9.2375C15.0917 9.39583 14.5333 9.61667 14 9.9ZM14 15.4V13.7C14.55 13.4667 15.1125 13.2917 15.6875 13.175C16.2625 13.0583 16.8667 13 17.5 13C17.9333 13 18.3583 13.0333 18.775 13.1C19.1917 13.1667 19.6 13.25 20 13.35V14.95C19.6 14.8 19.1958 14.6875 18.7875 14.6125C18.3792 14.5375 17.95 14.5 17.5 14.5C16.8667 14.5 16.2583 14.575 15.675 14.725C15.0917 14.875 14.5333 15.1 14 15.4ZM14 12.65V10.95C14.55 10.7167 15.1125 10.5417 15.6875 10.425C16.2625 10.3083 16.8667 10.25 17.5 10.25C17.9333 10.25 18.3583 10.2833 18.775 10.35C19.1917 10.4167 19.6 10.5 20 10.6V12.2C19.6 12.05 19.1958 11.9375 18.7875 11.8625C18.3792 11.7875 17.95 11.75 17.5 11.75C16.8667 11.75 16.2583 11.8292 15.675 11.9875C15.0917 12.1458 14.5333 12.3667 14 12.65ZM6.5 16C7.28333 16 8.04583 16.0875 8.7875 16.2625C9.52917 16.4375 10.2667 16.7 11 17.05V7.2C10.3167 6.8 9.59167 6.5 8.825 6.3C8.05833 6.1 7.28333 6 6.5 6C5.9 6 5.30417 6.05833 4.7125 6.175C4.12083 6.29167 3.55 6.46667 3 6.7V16.6C3.58333 16.4 4.1625 16.25 4.7375 16.15C5.3125 16.05 5.9 16 6.5 16ZM13 17.05C13.7333 16.7 14.4708 16.4375 15.2125 16.2625C15.9542 16.0875 16.7167 16 17.5 16C18.1 16 18.6875 16.05 19.2625 16.15C19.8375 16.25 20.4167 16.4 21 16.6V6.7C20.45 6.46667 19.8792 6.29167 19.2875 6.175C18.6958 6.05833 18.1 6 17.5 6C16.7167 6 15.9417 6.1 15.175 6.3C14.4083 6.5 13.6833 6.8 13 7.2V17.05ZM12 20C11.2 19.3667 10.3333 18.875 9.4 18.525C8.46667 18.175 7.5 18 6.5 18C5.8 18 5.1125 18.0917 4.4375 18.275C3.7625 18.4583 3.11667 18.7167 2.5 19.05C2.15 19.2333 1.8125 19.225 1.4875 19.025C1.1625 18.825 1 18.5333 1 18.15V6.1C1 5.91667 1.04583 5.74167 1.1375 5.575C1.22917 5.40833 1.36667 5.28333 1.55 5.2C2.31667 4.8 3.11667 4.5 3.95 4.3C4.78333 4.1 5.63333 4 6.5 4C7.46667 4 8.4125 4.125 9.3375 4.375C10.2625 4.625 11.15 5 12 5.5C12.85 5 13.7375 4.625 14.6625 4.375C15.5875 4.125 16.5333 4 17.5 4C18.3667 4 19.2167 4.1 20.05 4.3C20.8833 4.5 21.6833 4.8 22.45 5.2C22.6333 5.28333 22.7708 5.40833 22.8625 5.575C22.9542 5.74167 23 5.91667 23 6.1V18.15C23 18.5333 22.8375 18.825 22.5125 19.025C22.1875 19.225 21.85 19.2333 21.5 19.05C20.8833 18.7167 20.2375 18.4583 19.5625 18.275C18.8875 18.0917 18.2 18 17.5 18C16.5 18 15.5333 18.175 14.6 18.525C13.6667 18.875 12.8 19.3667 12 20Z" />
		),
	},
});
export const IconRedGreen = svgIcon({
	default: {
		element: (
			<g fill="none">
				<path
					fill="#479982"
					d="M21,10.4142136 L21,20 C21,20.5522847 20.5522847,21 20,21 L10.4142136,21 C9.86192881,21 9.41421356,20.5522847 9.41421356,20 C9.41421356,19.7347835 9.5195704,19.4804296 9.70710678,19.2928932 L19.2928932,9.70710678 C19.6834175,9.31658249 20.3165825,9.31658249 20.7071068,9.70710678 C20.8946432,9.89464316 21,10.1489971 21,10.4142136 Z"
				/>
				<rect
					width="3"
					height="21"
					x="10.495"
					y="1.495"
					fill="#479982"
					rx="1.5"
					transform="rotate(45 11.995 11.995)"
				/>
				<path
					fill="#DA4140"
					d="M4,3 L13.5857864,3 C14.1380712,3 14.5857864,3.44771525 14.5857864,4 C14.5857864,4.26521649 14.4804296,4.5195704 14.2928932,4.70710678 L4.70710678,14.2928932 C4.31658249,14.6834175 3.68341751,14.6834175 3.29289322,14.2928932 C3.10535684,14.1053568 3,13.8510029 3,13.5857864 L3,4 C3,3.44771525 3.44771525,3 4,3 Z"
				/>
			</g>
		),
	},
});
export const IconRedo = svgIcon({
	default: {
		element: (
			<path d="M384-192q-80 0-136-56t-56-136q0-80 56-136t136-56h246l-93-93 51-51 180 180-180 180-51-51 93-93H384q-50 0-85 35t-35 85q0 50 35 85t85 35h288v72H384Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconReduceSpend = svgIcon({
	default: {
		element: (
			<>
				<path d="M7.46154 18H9.48077V16.6607C10.4423 16.5 11.2692 16.1518 11.9615 15.6161C12.6538 15.0804 13 14.2857 13 13.2321C13 12.4821 12.7692 11.7946 12.3077 11.1696C11.8462 10.5446 10.9231 10 9.53846 9.53571C8.38462 9.17857 7.58654 8.86607 7.14423 8.59821C6.70192 8.33036 6.48077 7.96429 6.48077 7.5C6.48077 7.03572 6.65865 6.66964 7.01442 6.40179C7.37019 6.13393 7.88462 6 8.55769 6C9.17308 6 9.65385 6.13839 10 6.41518C10.3462 6.69196 10.5962 7.03571 10.75 7.44643L12.5962 6.75C12.3846 6.125 11.9952 5.58036 11.4279 5.11607C10.8606 4.65179 10.2308 4.39286 9.53846 4.33929V3H7.51923V4.33929C6.55769 4.53571 5.80769 4.92857 5.26923 5.51786C4.73077 6.10714 4.46154 6.76786 4.46154 7.5C4.46154 8.33929 4.72596 9.01786 5.25481 9.53571C5.78365 10.0536 6.61538 10.5 7.75 10.875C8.96154 11.2857 9.80288 11.6518 10.274 11.9732C10.7452 12.2946 10.9808 12.7143 10.9808 13.2321C10.9808 13.8214 10.7548 14.2545 10.3029 14.5312C9.85096 14.808 9.30769 14.9464 8.67308 14.9464C8.03846 14.9464 7.47596 14.7634 6.98558 14.3973C6.49519 14.0312 6.13462 13.4821 5.90385 12.75L4 13.4464C4.26923 14.3036 4.6875 14.9955 5.25481 15.5223C5.82212 16.0491 6.55769 16.4107 7.46154 16.6071V18Z" />
				<path d="M15.5 12V17.2L14.4 16.1L13 17.5L16.5 21L20 17.5L18.575 16.1L17.5 17.175V12H15.5Z" />
			</>
		),
	},
});
export const IconReferrer = svgIcon({
	default: {
		element: <path d="m243-192-51-51 429-429H384v-72h360v360h-72v-237L243-192Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconReject = svgIcon({
	default: {
		element: (
			<path d="M240-816h456v480L408-48l-32-22q-17-12-26-30.5t-5-38.5l1-5 38-192H120q-30 0-51-21t-21-51v-57q0-8 1.5-14.5T54-493l119-279q8-20 26.5-32t40.5-12Zm384 72H240L120-465v57h352l-49 243 201-201v-378Zm0 378v-378 378Zm72 30v-72h144v-336H696v-72h216v480H696Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconRejectFilled = svgIcon({
	default: {
		element: (
			<path d="M240-840h400v520L360-40l-50-50q-7-7-11.5-19t-4.5-23v-14l44-174H120q-32 0-56-24t-24-56v-80q0-7 1.5-15t4.5-15l120-282q9-20 30-34t44-14Zm480 520v-520h160v520H720Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconRejected = svgIcon({
	default: {
		element: (
			<path d="m339-288 141-141 141 141 51-51-141-141 141-141-51-51-141 141-141-141-51 51 141 141-141 141 51 51ZM480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconRemove = svgIcon({
	default: {
		element: (
			<path d="M288-444h384v-72H288v72ZM480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconRenew = svgIcon({
	default: {
		element: (
			<path d="M216-192v-72h74q-45-40-71.5-95.5T192-480q0-101 61-177.5T408-758v75q-63 23-103.5 77.5T264-480q0 48 19.5 89t52.5 70v-63h72v192H216Zm336-10v-75q63-23 103.5-77.5T696-480q0-48-19.5-89T624-639v63h-72v-192h192v72h-74q45 40 71.5 95.5T768-480q0 101-61 177.5T552-202Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconRepeat = svgIcon({
	default: {
		element: (
			<path d="M288-96 144-240l144-144 51 51-57 57h414v-156h72v228H282l57 57-51 51Zm-96-432v-228h486l-57-57 51-51 144 144-144 144-51-51 57-57H264v156h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconReplaceAd = svgIcon({
	default: {
		element: (
			<path d="M8 22C7.45 22 6.97917 21.8042 6.5875 21.4125C6.19583 21.0208 6 20.55 6 20V12C6 11.45 6.19583 10.9792 6.5875 10.5875C6.97917 10.1958 7.45 10 8 10H16C16.55 10 17.0208 10.1958 17.4125 10.5875C17.8042 10.9792 18 11.45 18 12V20C18 20.55 17.8042 21.0208 17.4125 21.4125C17.0208 21.8042 16.55 22 16 22H8ZM8 20H16V14H8V20ZM3.5 8C4.13333 6.18333 5.22917 4.72917 6.7875 3.6375C8.34583 2.54583 10.0833 2 12 2C13.3667 2 14.6625 2.29167 15.8875 2.875C17.1125 3.45833 18.15 4.28333 19 5.35V2H21V8H15V6H16.9C16.25 5.35 15.5 4.85417 14.65 4.5125C13.8 4.17083 12.9167 4 12 4C10.65 4 9.40417 4.35833 8.2625 5.075C7.12083 5.79167 6.25833 6.76667 5.675 8H3.5Z" />
		),
	},
});
export const IconReply = svgIcon({
	default: {
		element: (
			<path d="M744-210v-144q0-50-35-85t-85-35H282l123 123-51 51-210-210 210-210 51 51-123 123h342q80 0 136 56t56 136v144h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconReplyAll = svgIcon({
	default: {
		element: (
			<path d="M306-300 96-510l210-210 51 51-159 159 159 159-51 51Zm438 90v-144q0-50-35-85t-85-35H426l123 123-51 51-210-210 210-210 51 51-123 123h198q80 0 136 56t56 136v144h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconResolvedIssue = svgIcon({
	default: {
		element: (
			<path d="m429-336 238-237-51-51-187 186-85-84-51 51 136 135Zm51 240q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSave = svgIcon({
	default: {
		element: (
			<path d="M480-336 288-528l51-51 105 105v-342h72v342l105-105 51 51-192 192ZM263.72-192Q234-192 213-213.15T192-264v-72h72v72h432v-72h72v72q0 29.7-21.16 50.85Q725.68-192 695.96-192H263.72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSchedule = svgIcon({
	default: {
		element: (
			<path d="m614-310 51-51-149-149v-210h-72v240l170 170ZM480-96q-79.38 0-149.19-30T208.5-208.5Q156-261 126-330.96t-30-149.5Q96-560 126-630q30-70 82.5-122t122.46-82q69.96-30 149.5-30t149.55 30.24q70 30.24 121.79 82.08 51.78 51.84 81.99 121.92Q864-559.68 864-480q0 79.38-30 149.19T752-208.5Q700-156 629.87-126T480-96Zm0-384Zm.48 312q129.47 0 220.5-91.5Q792-351 792-480.48q0-129.47-91.02-220.5Q609.95-792 480.48-792 351-792 259.5-700.98 168-609.95 168-480.48 168-351 259.5-259.5T480.48-168Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconScrollMap = svgIcon({
	default: {
		element: (
			<>
				<path d="M17 15V9C17 7.59692 16.5276 6.45534 15.5361 5.46387C14.5447 4.4724 13.4031 4 12 4C10.5969 4 9.45534 4.4724 8.46387 5.46387C7.4724 6.45534 7 7.59692 7 9V15C7 16.4031 7.4724 17.5447 8.46387 18.5361C9.45534 19.5276 10.5969 20 12 20V22C10.1875 22 8.62402 21.3994 7.30957 20.1982L7.0498 19.9502C5.68314 18.5835 5 16.9333 5 15V9C5 7.06667 5.68314 5.41647 7.0498 4.0498C8.41647 2.68314 10.0667 2 12 2C13.9333 2 15.5835 2.68314 16.9502 4.0498C18.3169 5.41647 19 7.06667 19 9V15C19 16.9333 18.3169 18.5835 16.9502 19.9502L16.6904 20.1982C15.376 21.3994 13.8125 22 12 22V20C13.4031 20 14.5447 19.5276 15.5361 18.5361C16.5276 17.5447 17 16.4031 17 15Z" />
				<path d="M9 9L12 6L15 9H13V11H15L12 14L9 11H11V9H9Z" />
			</>
		),
	},
});
export const IconSearch = svgIcon({
	default: {
		element: (
			<path d="M765-144 526-383q-30 22-65.79 34.5-35.79 12.5-76.18 12.5Q284-336 214-406t-70-170q0-100 70-170t170-70q100 0 170 70t70 170.03q0 40.39-12.5 76.18Q599-464 577-434l239 239-51 51ZM384-408q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSegmentationMap = svgIcon({
	default: {
		element: (
			<path d="M6 3C4.89543 3 4 3.89543 4 5C4 6.10457 4.89543 7 6 7C7.10457 7 8 6.10457 8 5C8 3.89543 7.10457 3 6 3ZM18 3C16.8954 3 16 3.89543 16 5C16 6.10457 16.8954 7 18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3ZM12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM6 11C4.89543 11 4 11.8954 4 13C4 14.1046 4.89543 15 6 15C7.10457 15 8 14.1046 8 13C8 11.8954 7.10457 11 6 11ZM18 11C16.8954 11 16 11.8954 16 13C16 14.1046 16.8954 15 18 15C19.1046 15 20 14.1046 20 13C20 11.8954 19.1046 11 18 11ZM6 17C4.665 17 2 17.7208 2 19.0508V21H10V19.0508C10 17.7208 7.335 17 6 17ZM18 17C16.665 17 14 17.7208 14 19.0508V21H22V19.0508C22 17.7208 19.335 17 18 17Z" />
		),
	},
});
export const IconSend = svgIcon({
	default: {
		element: (
			<path d="M144-192v-576l720 288-720 288Zm72-107 454-181-454-181v109l216 72-216 72v109Zm0 0v-362 362Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSensorActive = svgIcon({
	default: {
		element: (
			<path d="M168-96q-29.7 0-50.85-21.15Q96-138.3 96-168v-168h72v168h168v72H168ZM96-624v-168q0-29.7 21.15-50.85Q138.3-864 168-864h168v72H168v168H96Zm348 405q-88-12-150.5-74.5T219-444h73.04q10.96 58 52.46 99.5t99.5 52.46V-219ZM219-516q12-88 74.36-150.32Q355.73-728.63 444-741v73.04Q386-657 344.5-615.5T292.04-516H219Zm260.79 108Q450-408 429-429.03q-21-21.02-21-50.55Q408-510 429.03-531q21.02-21 50.55-21Q510-552 531-531.24t21 51.45Q552-450 531.24-429t-51.45 21ZM516-219v-73.04q58-10.96 99.5-52.46t52.46-99.5H741q-12.37 88.27-74.68 150.64Q604-231 516-219Zm151.96-297Q657-574 615.5-615.5T516-667.96V-741q88 12 150.32 74.36Q728.63-604.27 741-516h-73.04ZM624-96v-72h168v-168h72v168q0 29.7-21.15 50.85Q821.7-96 792-96H624Zm168-528v-168H624v-72h168q29.7 0 50.85 21.15Q864-821.7 864-792v168h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSettings = svgIcon({
	default: {
		element: (
			<path d="m403-96-22-114q-23-9-44.5-21T296-259l-110 37-77-133 87-76q-2-12-3-24t-1-25q0-13 1-25t3-24l-87-76 77-133 110 37q19-16 40.5-28t44.5-21l22-114h154l22 114q23 9 44.5 21t40.5 28l110-37 77 133-87 76q2 12 3 24t1 25q0 13-1 25t-3 24l87 76-77 133-110-37q-19 16-40.5 28T579-210L557-96H403Zm59-72h36l19-99q38-7 71-26t57-48l96 32 18-30-76-67q6-17 9.5-35.5T696-480q0-20-3.5-38.5T683-554l76-67-18-30-96 32q-24-29-57-48t-71-26l-19-99h-36l-19 99q-38 7-71 26t-57 48l-96-32-18 30 76 67q-6 17-9.5 35.5T264-480q0 20 3.5 38.5T277-406l-76 67 18 30 96-32q24 29 57 48t71 26l19 99Zm18-168q60 0 102-42t42-102q0-60-42-102t-102-42q-60 0-102 42t-42 102q0 60 42 102t102 42Zm0-144Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconShare = svgIcon({
	default: {
		element: (
			<path d="M648-96q-50 0-85-35t-35-85q0-9 4-29L295-390q-16 14-36.05 22-20.04 8-42.95 8-50 0-85-35t-35-85q0-50 35-85t85-35q23 0 43 8t36 22l237-145q-2-7-3-13.81-1-6.81-1-15.19 0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-23 0-43-8t-36-22L332-509q2 7 3 13.81 1 6.81 1 15.19 0 8.38-1 15.19-1 6.81-3 13.81l237 145q16-14 36.05-22 20.04-8 42.95-8 50 0 85 35t35 85q0 50-35 85t-85 35Zm0-72q20.4 0 34.2-13.8Q696-195.6 696-216q0-20.4-13.8-34.2Q668.4-264 648-264q-20.4 0-34.2 13.8Q600-236.4 600-216q0 20.4 13.8 34.2Q627.6-168 648-168ZM216-432q20.4 0 34.2-13.8Q264-459.6 264-480q0-20.4-13.8-34.2Q236.4-528 216-528q-20.4 0-34.2 13.8Q168-500.4 168-480q0 20.4 13.8 34.2Q195.6-432 216-432Zm432-264q20.4 0 34.2-13.8Q696-723.6 696-744q0-20.4-13.8-34.2Q668.4-792 648-792q-20.4 0-34.2 13.8Q600-764.4 600-744q0 20.4 13.8 34.2Q627.6-696 648-696Zm0 480ZM216-480Zm432-264Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconShow = svgIcon({
	default: {
		element: (
			<path
				d="M480-312q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm0-72q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 192q-142.6 0-259.8-78.5Q103-349 48-480q55-131 172.2-209.5Q337.4-768 480-768q142.6 0 259.8 78.5Q857-611 912-480q-55 131-172.2 209.5Q622.6-192 480-192Zm0-288Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z"
				transform="translate(1 4)"
			/>
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSidecar = svgIcon({
	default: {
		element: (
			<path d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM13.3333 15.8333H15.8333V4.16667H13.3333V15.8333ZM11.6667 15.8333V4.16667H4.16667V15.8333H11.6667Z" />
		),
		viewBox: "0 0 20 20",
	},
});
export const IconSlowBroadband = svgIcon({
	default: {
		element: (
			<path d="M480-120 0-600q96-98 220-149t260-51q137 0 261 51t219 149L480-120ZM299-415q38-28 84-43.5t97-15.5q51 0 97 15.5t84 43.5l183-183q-78-59-170.5-90.5T480-720q-101 0-193.5 31.5T116-598l183 183Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSite = svgIcon({
	default: {
		element: (
			<path d="M480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM432-172v-68q-20 0-34-14.1T384-288v-48L175-545q-4 19-5.5 35t-1.5 30q0 115 74.5 203T432-172Zm288-109q36-42 54-92.96 18-50.95 18-106.04 0-94.61-52-172.8Q688-731 600-768v24q0 29.7-21.15 50.85Q557.7-672 528-672h-96v48q0 20.4-13.8 34.2Q404.4-576 384-576h-48v96h240q20.4 0 34.2 13.8Q624-452.4 624-432v96h41q23 0 39 16t16 39Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSiteImprove = svgIcon({
	default: {
		element: (
			<>
				<path
					d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
					fill="#9E007E"
				/>
				<path
					d="M31.3413 25.256L28.672 24.472C27.4587 24.0987 26.5067 23.7627 25.7973 23.464C25.088 23.1654 24.584 22.8294 24.2853 22.4934C23.9867 22.1574 23.8373 21.728 23.8373 21.2054C23.8373 20.5707 24.0427 20.0294 24.4347 19.5814C24.8267 19.1147 25.3867 18.76 26.1147 18.5174C26.824 18.2747 27.664 18.144 28.6347 18.144C29.6053 18.144 30.576 18.2747 31.5467 18.5174C32.5173 18.76 33.3947 19.1147 34.216 19.544C35.0373 19.9734 35.7093 20.496 36.2693 21.0747L39.816 15.8294C38.6027 14.6534 36.9973 13.7387 35.0187 13.0667C33.0213 12.3947 30.8747 12.04 28.56 12.04C26.88 12.04 25.3307 12.2827 23.912 12.7494C22.4933 13.216 21.2613 13.888 20.1973 14.7467C19.152 15.6054 18.3307 16.6134 17.752 17.7707C17.1733 18.928 16.8747 20.1974 16.8747 21.56C16.8747 23.688 17.5653 25.5174 18.9467 27.0294C20.328 28.5414 22.6053 29.736 25.76 30.6134L28.392 31.36C30.24 31.864 31.5093 32.368 32.1813 32.9094C32.8533 33.4507 33.208 34.104 33.208 34.9067C33.208 35.8774 32.7413 36.6054 31.7893 37.1094C30.856 37.6134 29.624 37.856 28.1307 37.856C27.0667 37.856 25.9653 37.7254 24.8453 37.4454C23.7067 37.184 22.6613 36.792 21.6533 36.288C20.664 35.784 19.8427 35.2054 19.208 34.5147L15.792 39.9467C17.304 41.2534 19.1707 42.2427 21.3547 42.9147C23.5387 43.6054 25.7973 43.9414 28.112 43.9414C30.6133 43.9414 32.76 43.5307 34.5707 42.6907C36.3813 41.8507 37.7813 40.712 38.7893 39.2187C39.7787 37.744 40.2827 36.0267 40.2827 34.0854C40.2827 31.864 39.5733 30.072 38.1733 28.672C36.736 27.328 34.4773 26.1707 31.3413 25.256Z"
					fill="white"
				/>
			</>
		),
		viewBox: "0 0 56 56",
	},
});

export const IconSiteImproveAIStarOutlined = svgIcon({
	default: {
		element: (
			<path
				d="M10 2.09668C10.7483 3.8547 11.8272 5.45797 13.1846 6.81543C14.542 8.17288 16.1453 9.25164 17.9033 10C16.1454 10.7483 14.542 11.8272 13.1846 13.1846C11.8273 14.5418 10.7484 16.1447 10 17.9023C9.25162 16.1447 8.17267 14.5418 6.81543 13.1846C5.45799 11.8272 3.85464 10.7483 2.09668 10C3.85488 9.25194 5.45892 8.17393 6.81641 6.81641C8.17389 5.45888 9.25197 3.85493 10 2.09668Z"
				stroke="black"
				strokeWidth="2"
				fill="none"
			/>
		),
		viewBox: "0 0 20 20",
	},
});

export const IconSiteImproveAIStarFilled = svgIcon({
	default: {
		element: (
			<path d="M9.55512 0.420679L9.59511 0.297584C9.7182 -0.0991947 10.2781 -0.0991947 10.4049 0.297584L10.4449 0.420679C11.1188 2.56663 12.3013 4.51792 13.8917 6.1084C15.4822 7.69888 17.4334 8.88143 19.5793 9.55534L19.7024 9.59533C20.0992 9.71843 20.0992 10.2783 19.7024 10.4051L19.5793 10.4451C17.4335 11.119 15.4823 12.3014 13.8919 13.8918C12.3014 15.4822 11.1189 17.4333 10.4449 19.5792L10.4049 19.7029C10.2818 20.099 9.72195 20.099 9.59511 19.7029L9.55512 19.5792C8.88113 17.4333 7.69857 15.4822 6.10814 13.8918C4.5177 12.3014 2.5665 11.119 0.420669 10.4451L0.297577 10.4051C-0.0991924 10.2814 -0.0991924 9.72155 0.297577 9.59533L0.420669 9.55534C2.56684 8.88195 4.51836 7.69958 6.10888 6.10902C7.69939 4.51847 8.88174 2.5669 9.55512 0.420679Z" />
		),
		viewBox: "0 0 20 20",
	},
});

export const IconSiteImproveAIStarPlum = svgIcon({
	default: {
		element: (
			<path
				d="M15.291 0.671991L15.355 0.474657C15.5524 -0.160009 16.4484 -0.160009 16.651 0.474657L16.715 0.671991C18.907 7.64266 24.363 13.104 31.3337 15.2907L31.531 15.3547C32.1657 15.552 32.1657 16.448 31.531 16.6507L31.3337 16.7147C24.363 18.9067 18.9017 24.3627 16.715 31.3333L16.651 31.5307C16.4537 32.1653 15.5577 32.1653 15.355 31.5307L15.291 31.3333C13.099 24.3627 7.64302 18.9013 0.672357 16.7147L0.475023 16.6507C-0.159643 16.4533 -0.159643 15.5573 0.475023 15.3547L0.672357 15.2907C7.64302 13.104 13.1044 7.64266 15.291 0.671991Z"
				fill="#9E007E"
			/>
		),
		viewBox: AI_STAR_VIEWBOX,
	},
});
export const IconSpellcheck = svgIcon({
	default: {
		element: (
			<path d="M544-144 375-314l51-51 118 119 221-221 51 51-272 272ZM144-384l180-480h86l180 480h-83l-42-123H271l-44 123h-83Zm152-192h143l-70-199h-4l-69 199Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconLogoBulb = svgIcon({
	default: {
		element: (
			<>
				<path
					d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
					fill="#9E007E"
				/>
				<path
					d="M48.67 21.26L48.79 20.89C49.16 19.7 50.84 19.7 51.22 20.89L51.34 21.26C55.45 34.33 65.68 44.57 78.75 48.67L79.12 48.79C80.31 49.16 80.31 50.84 79.12 51.22L78.75 51.34C65.68 55.45 55.44 65.68 51.34 78.75L51.22 79.12C50.85 80.31 49.17 80.31 48.79 79.12L48.67 78.75C44.56 65.68 34.33 55.44 21.26 51.34L20.89 51.22C19.7 50.85 19.7 49.17 20.89 48.79L21.26 48.67C34.33 44.56 44.57 34.33 48.67 21.26Z"
					fill="white"
				/>
			</>
		),
		viewBox: "0 0 100 100",
	},
});
export const IconSlowConnection = svgIcon({
	default: {
		element: <path d="m80-80 800-800v800H80Zm320-80h400v-526L400-286v126Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconScreenResolution = svgIcon({
	default: {
		element: (
			<>
				<path d="M1 21V19H23V21H1ZM4 18C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19583 17.0208 2 16.55 2 16V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H4ZM4 16H20V5H4V16Z" />
				<path d="M19 15H15V13.5H17.5V11H19V15Z" />
				<path d="M6.5 10H5V6H9V7.5H6.5V10Z" />
			</>
		),
	},
});
export const IconSeoLowValue = svgIcon({
	default: {
		element: (
			<>
				<path d="M11 14H7C5.61667 14 4.4375 13.5125 3.4625 12.5375C2.4875 11.5625 2 10.3833 2 9C2 7.61667 2.4875 6.4375 3.4625 5.4625C4.4375 4.4875 5.61667 4 7 4H11V6H7C6.16667 6 5.45833 6.29167 4.875 6.875C4.29167 7.45833 4 8.16667 4 9C4 9.83333 4.29167 10.5417 4.875 11.125C5.45833 11.7083 6.16667 12 7 12H11V14ZM8 10V8H16V10H8Z" />
				<path d="M17 22C15.6167 22 14.4375 21.5125 13.4625 20.5375C12.4875 19.5625 12 18.3833 12 17C12 15.6167 12.4875 14.4375 13.4625 13.4625C14.4375 12.4875 15.6167 12 17 12C18.3833 12 19.5625 12.4875 20.5375 13.4625C21.5125 14.4375 22 15.6167 22 17C22 18.3833 21.5125 19.5625 20.5375 20.5375C19.5625 21.5125 18.3833 22 17 22ZM17 20C17.1333 20 17.25 19.95 17.35 19.85C17.45 19.75 17.5 19.6333 17.5 19.5C17.5 19.3667 17.45 19.25 17.35 19.15C17.25 19.05 17.1333 19 17 19C16.8667 19 16.75 19.05 16.65 19.15C16.55 19.25 16.5 19.3667 16.5 19.5C16.5 19.6333 16.55 19.75 16.65 19.85C16.75 19.95 16.8667 20 17 20ZM16.5 18H17.5V14H16.5V18Z" />
				<path d="M20.5375 5.4625C21.5125 6.4375 22 7.61667 22 9C22 10.1439 21.7168 11.0809 21.0501 11.9456L19.4312 10.9324C20.0145 10.3491 20 9.83333 20 9C20 8.16667 19.7083 7.45833 19.125 6.875C18.5417 6.29167 17.8333 6 17 6H13V4H17C18.3833 4 19.5625 4.4875 20.5375 5.4625Z" />
			</>
		),
	},
});
export const IconSeoLostLink = svgIcon({
	default: {
		element: (
			<>
				<path d="M11 14H7C5.61667 14 4.4375 13.5125 3.4625 12.5375C2.4875 11.5625 2 10.3833 2 9C2 7.61667 2.4875 6.4375 3.4625 5.4625C4.4375 4.4875 5.61667 4 7 4H11V6H7C6.16667 6 5.45833 6.29167 4.875 6.875C4.29167 7.45833 4 8.16667 4 9C4 9.83333 4.29167 10.5417 4.875 11.125C5.45833 11.7083 6.16667 12 7 12H11V14ZM8 10V8H16V10H8Z" />
				<path d="M20.5375 5.4625C21.5125 6.4375 22 7.61667 22 9C22 10.1439 21.7168 11.0809 21.0501 11.9456L19.4312 10.9324C20.0145 10.3491 20 9.83333 20 9C20 8.16667 19.7083 7.45833 19.125 6.875C18.5417 6.29167 17.8333 6 17 6H13V4H17C18.3833 4 19.5625 4.4875 20.5375 5.4625Z" />
				<path d="M15.225 19.475L16.975 17.725L18.725 19.475L19.475 18.725L17.75 17L19.5 15.25L18.75 14.5L17 16.25L15.25 14.5L14.5 15.25L16.25 17L14.5 18.75L15.225 19.475ZM17 22C15.6167 22 14.4375 21.5125 13.4625 20.5375C12.4875 19.5625 12 18.3833 12 17C12 15.6167 12.4875 14.4375 13.4625 13.4625C14.4375 12.4875 15.6167 12 17 12C18.3833 12 19.5625 12.4875 20.5375 13.4625C21.5125 14.4375 22 15.6167 22 17C22 18.3833 21.5125 19.5625 20.5375 20.5375C19.5625 21.5125 18.3833 22 17 22Z" />
			</>
		),
	},
});
export const IconSmartphone = svgIcon({
	default: {
		element: (
			<path d="M288-48q-29.7 0-50.85-21.15Q216-90.3 216-120v-720q0-33 19.5-52.5T288-912h384q29.7 0 50.85 21.15Q744-869.7 744-840v144q20 0 34 14t14 34v96q0 20-14 34t-34 14v384q0 29.7-21.15 50.85Q701.7-48 672-48H288Zm0-72h384v-720H288v720Zm0 0v-720 720Zm191.79-600q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSortable = svgIcon({
	default: {
		element: (
			<>
				<path d="m288-384 192-192 192 192H288Z" transform="translate(0, -175)" />
				<path d="M480-384 288-576h384L480-384Z" transform="translate(0, 175)" />
			</>
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSortableAsc = svgIcon({
	default: {
		element: <path d="m288-384 192-192 192 192H288Z" transform="translate(0, -175)" />,

		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSortableDesc = svgIcon({
	default: {
		element: <path d="M480-384 288-576h384L480-384Z" transform="translate(0, 175)" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSparkle = svgIcon({
	default: {
		element: (
			<path d="M12 3C12.3521 3 12.6644 3.22534 12.7758 3.5593L14.6918 9.30735L20.4407 11.2242C20.7747 11.3356 21 11.6479 21 12C21 12.3521 20.7747 12.6644 20.4407 12.7758L14.6918 14.6918L12.7758 20.4407C12.6644 20.7747 12.3521 21 12 21C11.6479 21 11.3356 20.7747 11.2242 20.4407L9.30735 14.6918L3.5593 12.7758C3.22534 12.6644 3 12.3521 3 12C3 11.6479 3.22534 11.3356 3.5593 11.2242L9.30735 9.30735L11.2242 3.5593L11.2745 3.43945C11.4138 3.17247 11.6918 3 12 3ZM10.7304 10.2134C10.6489 10.4575 10.4575 10.6489 10.2134 10.7304L6.40456 12L10.2134 13.2696L10.3021 13.3048C10.5036 13.3993 10.6591 13.5728 10.7304 13.7866L12 17.5954L13.2696 13.7866L13.3048 13.6979C13.3993 13.4964 13.5728 13.3409 13.7866 13.2696L17.5954 12L13.7866 10.7304C13.5728 10.6591 13.3993 10.5036 13.3048 10.3021L13.2696 10.2134L12 6.40456L10.7304 10.2134Z" />
		),
	},
});
export const IconSpeed = svgIcon({
	default: {
		element: (
			<path d="M429-358q23 22 57 20.5t50-25.5l208-309-309.16 208.26Q410-447 408-413.5t21 55.5Zm52-410q60 0 108 15.5t87 38.5l-69 45q-28-13-58.5-20t-67.5-7q-130.09 0-221.55 93.5Q168-509 168-384q0 38 5.5 62.5T191-264h577q13-33 18.5-60.5T792-384q0-42-11.5-84T747-545l43-65q35 48 54.5 106T864-386q0 51-8.5 89T828-227q-10 17-25.5 26t-34.5 9H192q-19 0-34.5-9T132-227q-19-32-27.5-70T96-386q0-79.72 30.5-149.36Q157-605 209-656.5T331.44-738q70.44-30 149.56-30Zm-1 279Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconStar = svgIcon({
	default: {
		element: (
			<path d="m243-144 63-266L96-589l276-24 108-251 108 252 276 23-210 179 63 266-237-141-237 141Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconStart = svgIcon({
	default: {
		element: <path d="M336-216v-528l408 264-408 264Zm73-265Zm-1 133 204-132-204-132v264Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconStop = svgIcon({
	default: {
		element: <path d="M240-240h480v-480H240v480Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSubLevel = svgIcon({
	default: {
		element: (
			<path d="M624-144v-108H444v-384H336v108H96v-288h240v108h288v-108h240v288H624v-108H516v312h108v-108h240v288H624ZM168-744v144-144Zm528 384v144-144Zm0-384v144-144Zm0 144h96v-144h-96v144Zm0 384h96v-144h-96v144ZM168-600h96v-144h-96v144Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSuccess = svgIcon({
	default: {
		element: (
			<path d="m429-336 238-237-51-51-187 186-85-84-51 51 136 135Zm51 240q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSuccessOutline = svgIcon({
	default: {
		element: (
			<path d="m429-336 238-237-51-51-187 186-85-84-51 51 136 135Zm51 240q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSupport = svgIcon({
	default: {
		element: (
			<path d="m616-310 34-34q8-8 8-17t-8-17L520-508q4-10.67 6-21.33 2-10.67 2-21.67 0-50.39-35-86.2-35-35.8-86-35.8-13.96 0-27.91 3.71-13.96 3.7-27.09 10.29l85 85-51 51-85-85q-6.59 13.13-10.29 27.09Q287-566.96 287-553q0 49.98 35.4 85.49Q357.81-432 407.64-432q11.36 0 22.36-1.5t22-6.5l130 130q8 8 17 8t17-8ZM480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSwapHorizontal = svgIcon({
	default: {
		element: (
			<path d="M288-168 96-360l192-192 51 51-105 105h294v72H234l105 105-51 51Zm384-240-51-51 105-105H432v-72h294L621-741l51-51 192 192-192 192Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconSwapVertical = svgIcon({
	default: {
		element: (
			<path d="M324-432v-294L219-621l-51-51 192-192 192 192-51 51-105-105v294h-72ZM600-96 408-288l51-51 105 105v-294h72v294l105-105 51 51L600-96Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTable = svgIcon({
	default: {
		element: (
			<path d="M216-144q-33 0-52.5-19.5T144-216v-528q0-33 19.5-52.5T216-816h528q33 0 52.5 19.5T816-744v528q0 33-19.5 52.5T744-144H216Zm228-228H216v156h228v-156Zm72 0v156h228v-156H516Zm-72-72v-156H216v156h228Zm72 0h228v-156H516v156ZM216-672h528v-72H216v72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTablet = svgIcon({
	default: {
		element: (
			<path d="M120-192q-29.7 0-50.85-21.16Q48-234.32 48-264.04v-432.24Q48-726 69.15-747T120-768h720q29.7 0 50.85 21.16Q912-725.68 912-695.96v432.24Q912-234 890.85-213T840-192H120Zm48-504h-48v432h48v-432Zm72 432h480v-432H240v432Zm552-432v432h48v-432h-48Zm0 0h48-48Zm-624 0h-48 48Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTarget = svgIcon({
	default: {
		element: (
			<path d="M444-48v-98q-119-12-202.5-95.5T146-444H48v-72h98q12-119 95.5-203T444-814v-98h72v98q119 11 202.5 95T814-516h98v72h-98q-12 119-95.5 202.5T516-146v98h-72Zm36-168q110 0 187-77t77-187q0-110-77-187t-187-77q-110 0-187 77t-77 187q0 110 77 187t187 77Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTextColor = svgIcon({
	default: {
		element: (
			<path d="M80 0v-160h800V0H80Zm140-280 210-560h100l210 560h-96l-50-144H368l-52 144h-96Zm176-224h168l-82-232h-4l-82 232Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTitle = svgIcon({
	default: {
		element: <path d="M432-192v-480H240v-96h480v96H528v480h-96Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconToDo = svgIcon({
	default: {
		element: (
			<path d="M480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTornado = svgIcon({
	default: {
		element: (
			<path d="M48-816h864L480-96 48-816Zm127 72 72 120h466l72-120H175Zm115 192 72 120h236l72-120H290Zm116 192 74 124 74-124H406Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTrend = svgIcon({
	default: {
		element: <path d="M444-768v438L243-531l-51 51 288 288 288-288-51-51-201 201v-438h-72Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTrendingDown = svgIcon({
	default: {
		element: (
			<path d="M624-209v-72h117L529-492 377-340 96-621l51-51 230 230 152-152 263 262v-117h72v240H624Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTrendingUp = svgIcon({
	default: {
		element: (
			<path d="m147-209-51-51 281-281 152 152 212-211H624v-72h240v240h-72v-117L529-287 377-439 147-209Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTrendStable = svgIcon({
	default: {
		element: <path d="M630-444H192v-72h438L429-717l51-51 288 288-288 288-51-51 201-201Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTrendUp = svgIcon({
	default: {
		element: <path d="M444-192v-438L243-429l-51-51 288-288 288 288-51 51-201-201v438h-72Z" />,
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconTune = svgIcon({
	default: {
		element: (
			<path d="M11 21V15H13V17H21V19H13V21H11ZM3 19V17H9V19H3ZM7 15V13H3V11H7V9H9V15H7ZM11 13V11H21V13H11ZM15 9V3H17V5H21V7H17V9H15ZM3 7V5H13V7H3Z" />
		),
	},
});
export const IconTv = svgIcon({
	default: {
		element: (
			<path d="M336-144v-96H168q-29.7 0-50.85-21.16Q96-282.32 96-312.04v-432.24Q96-774 117.15-795T168-816h624q29.7 0 50.85 21.16Q864-773.68 864-743.96v432.24Q864-282 842.85-261T792-240H624v96H336ZM168-312h624v-432H168v432Zm0 0v-432 432Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUndo = svgIcon({
	default: {
		element: (
			<path d="M288-192v-72h288q50 0 85-35t35-85q0-50-35-85t-85-35H330l93 93-51 51-180-180 180-180 51 51-93 93h246q80 0 136 56t56 136q0 80-56 136t-136 56H288Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUnlink = svgIcon({
	default: {
		element: (
			<path d="m754-308-56-55q41.78-11.3 67.89-43.65Q792-439 792-480q0-50-35-85t-85-35H528v-72h144q79.68 0 135.84 56.22 56.16 56.23 56.16 136Q864-425 834.5-379T754-308ZM618-444l-72-72h78v72h-6ZM768-90 90-768l51-51 678 678-51 51ZM432-288H288q-79.68 0-135.84-56.16T96-480q0-63.93 38-113.97Q172-644 242-673l70 73h-23q-51 0-86 35t-35 85q0 50 35 85t85 35h144v72Zm-96-156v-72h56l71 72H336Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUnlock = svgIcon({
	default: {
		element: (
			<path d="M264-624h336v-96q0-50-35-85t-85-35q-50 0-85 35t-35 85h-72q0-80 56.23-136 56.22-56 136-56Q560-912 616-855.84q56 56.16 56 135.84v96h24q29.7 0 50.85 21.15Q768-581.7 768-552v384q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72Q234-96 213-117.15T192-168v-384q0-29.7 21.15-50.85Q234.3-624 264-624Zm0 456h432v-384H264v384Zm216.21-120Q510-288 531-309.21t21-51Q552-390 530.79-411t-51-21Q450-432 429-410.79t-21 51Q408-330 429.21-309t51 21ZM264-168v-384 384Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUnpin = svgIcon({
	default: {
		element: (
			<path d="m624-480 96 96v72H516v228l-36 36-36-36v-228H240v-72l96-96v-264h-48v-72h384v72h-48v264Zm-282 96h276l-66-66v-294H408v294l-66 66Zm138 0Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUpload = svgIcon({
	default: {
		element: (
			<path d="M444-336v-342L339-573l-51-51 192-192 192 192-51 51-105-105v342h-72ZM263.72-192Q234-192 213-213.15T192-264v-72h72v72h432v-72h72v72q0 29.7-21.16 50.85Q725.68-192 695.96-192H263.72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUsability = svgIcon({
	default: {
		element: (
			<path d="M360-108v-474q-74-29-121-95t-47-151h72q0 79.68 56 135.84T456-636h102q21 0 41.5 8.5T635-604l160 160-51 51-144-144v429h-72v-240h-96v240h-72Zm119.75-588q-34.75 0-59.25-24.75t-24.5-59.5q0-34.75 24.75-59.25t59.5-24.5q34.75 0 59.25 24.75t24.5 59.5q0 34.75-24.75 59.25t-59.5 24.5Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUser = svgIcon({
	default: {
		element: (
			<path d="M480-480q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42ZM192-192v-96q0-23 12.5-43.5T239-366q55-32 116.29-49 61.29-17 124.5-17t124.71 17Q666-398 721-366q22 13 34.5 34t12.5 44v96H192Zm72-72h432v-24q0-5.18-3.03-9.41-3.02-4.24-7.97-6.59-46-28-98-42t-107-14q-55 0-107 14t-98 42q-5 4-8 7.72-3 3.73-3 8.28v24Zm216.21-288Q510-552 531-573.21t21-51Q552-654 530.79-675t-51-21Q450-696 429-674.79t-21 51Q408-594 429.21-573t51 21Zm-.21-72Zm0 360Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUsers = svgIcon({
	default: {
		element: (
			<path d="M96-192v-92q0-25.78 12.5-47.39T143-366q54-32 114.5-49T384-432q66 0 126.5 17T625-366q22 13 34.5 34.61T672-284v92H96Zm648 0v-92q0-42-19.5-78T672-421q39 8 75.5 21.5T817-366q22 13 34.5 34.67Q864-309.65 864-284v92H744ZM384-480q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm336-144q0 60-42 102t-102 42q-8 0-15-.5t-15-2.5q25-29 39.5-64.5T600-624q0-41-14.5-76.5T546-765q8-2 15-2.5t15-.5q60 0 102 42t42 102ZM168-264h432v-20q0-6.47-3.03-11.76-3.02-5.3-7.97-8.24-47-27-99-41.5T384-360q-54 0-106 14t-99 42q-4.95 2.83-7.98 7.91-3.02 5.09-3.02 12V-264Zm216.21-288Q414-552 435-573.21t21-51Q456-654 434.79-675t-51-21Q354-696 333-674.79t-21 51Q312-594 333.21-573t51 21ZM384-264Zm0-360Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUnstar = svgIcon({
	default: {
		element: (
			<path d="m352-293 128-76 129 76-34-144 111-95-147-13-59-137-59 137-147 13 112 95-34 144ZM243-144l63-266L96-589l276-24 108-251 108 252 276 23-210 179 63 266-237-141-237 141Zm237-333Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconUpdate = svgIcon({
	default: {
		element: (
			<path d="M480-120q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q82 0 155.5 35T760-706v-94h80v240H600v-80h110q-41-56-101-88t-129-32q-117 0-198.5 81.5T200-480q0 117 81.5 198.5T480-200q105 0 183.5-68T756-440h82q-15 137-117.5 228.5T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconVideo = svgIcon({
	default: {
		element: (
			<path d="M216-192q-29 0-50.5-21.5T144-264v-432q0-29.7 21.5-50.85Q187-768 216-768h432q29.7 0 50.85 21.15Q720-725.7 720-696v168l144-144v384L720-432v168q0 29-21.15 50.5T648-192H216Zm0-72h432v-432H216v432Zm0 0v-432 432Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconVisibility = svgIcon({
	default: {
		element: (
			<path d="M12 16C13.25 16 14.3125 15.5625 15.1875 14.6875C16.0625 13.8125 16.5 12.75 16.5 11.5C16.5 10.25 16.0625 9.1875 15.1875 8.3125C14.3125 7.4375 13.25 7 12 7C10.75 7 9.6875 7.4375 8.8125 8.3125C7.9375 9.1875 7.5 10.25 7.5 11.5C7.5 12.75 7.9375 13.8125 8.8125 14.6875C9.6875 15.5625 10.75 16 12 16ZM12 14.2C11.25 14.2 10.6125 13.9375 10.0875 13.4125C9.5625 12.8875 9.3 12.25 9.3 11.5C9.3 10.75 9.5625 10.1125 10.0875 9.5875C10.6125 9.0625 11.25 8.8 12 8.8C12.75 8.8 13.3875 9.0625 13.9125 9.5875C14.4375 10.1125 14.7 10.75 14.7 11.5C14.7 12.25 14.4375 12.8875 13.9125 13.4125C13.3875 13.9375 12.75 14.2 12 14.2ZM12 19C9.56667 19 7.35 18.3208 5.35 16.9625C3.35 15.6042 1.9 13.7833 1 11.5C1.9 9.21667 3.35 7.39583 5.35 6.0375C7.35 4.67917 9.56667 4 12 4C14.4333 4 16.65 4.67917 18.65 6.0375C20.65 7.39583 22.1 9.21667 23 11.5C22.1 13.7833 20.65 15.6042 18.65 16.9625C16.65 18.3208 14.4333 19 12 19ZM12 17C13.8833 17 15.6125 16.5042 17.1875 15.5125C18.7625 14.5208 19.9667 13.1833 20.8 11.5C19.9667 9.81667 18.7625 8.47917 17.1875 7.4875C15.6125 6.49583 13.8833 6 12 6C10.1167 6 8.3875 6.49583 6.8125 7.4875C5.2375 8.47917 4.03333 9.81667 3.2 11.5C4.03333 13.1833 5.2375 14.5208 6.8125 15.5125C8.3875 16.5042 10.1167 17 12 17Z" />
		),
	},
});
export const IconVisibilityIncrease = svgIcon({
	default: {
		element: (
			<>
				<path d="M19.5 4L16 7.5L17.425 8.9L18.5 7.825V20H20.5V7.8L21.6 8.9L23 7.5L19.5 4Z" />
				<path d="M9 15C7.48333 15 6.08333 14.6 4.8 13.8C3.51667 13 2.58333 11.9 2 10.5C2.58333 9.1 3.51667 8 4.8 7.2C6.08333 6.4 7.48333 6 9 6C10.5167 6 11.9167 6.4 13.2 7.2C14.4833 8 15.4167 9.1 16 10.5C15.4167 11.9 14.4833 13 13.2 13.8C11.9167 14.6 10.5167 15 9 15ZM9 13C9.95 13 10.8458 12.7833 11.6875 12.35C12.5292 11.9167 13.2167 11.3 13.75 10.5C13.2167 9.7 12.5292 9.08333 11.6875 8.65C10.8458 8.21667 9.95 8 9 8C8.05 8 7.15417 8.21667 6.3125 8.65C5.47083 9.08333 4.78333 9.7 4.25 10.5C4.78333 11.3 5.47083 11.9167 6.3125 12.35C7.15417 12.7833 8.05 13 9 13ZM9 12C8.58333 12 8.22917 11.8542 7.9375 11.5625C7.64583 11.2708 7.5 10.9167 7.5 10.5C7.5 10.0833 7.64583 9.72917 7.9375 9.4375C8.22917 9.14583 8.58333 9 9 9C9.41667 9 9.77083 9.14583 10.0625 9.4375C10.3542 9.72917 10.5 10.0833 10.5 10.5C10.5 10.9167 10.3542 11.2708 10.0625 11.5625C9.77083 11.8542 9.41667 12 9 12Z" />
			</>
		),
	},
});
export const IconVisibilityDecrease = svgIcon({
	default: {
		element: (
			<>
				<path d="M19.5 20L16 16.5L17.425 15.1L18.5 16.175V4H20.5V16.2L21.6 15.1L23 16.5L19.5 20Z" />
				<path d="M9 15C7.48333 15 6.08333 14.6 4.8 13.8C3.51667 13 2.58333 11.9 2 10.5C2.58333 9.1 3.51667 8 4.8 7.2C6.08333 6.4 7.48333 6 9 6C10.5167 6 11.9167 6.4 13.2 7.2C14.4833 8 15.4167 9.1 16 10.5C15.4167 11.9 14.4833 13 13.2 13.8C11.9167 14.6 10.5167 15 9 15ZM9 13C9.95 13 10.8458 12.7833 11.6875 12.35C12.5292 11.9167 13.2167 11.3 13.75 10.5C13.2167 9.7 12.5292 9.08333 11.6875 8.65C10.8458 8.21667 9.95 8 9 8C8.05 8 7.15417 8.21667 6.3125 8.65C5.47083 9.08333 4.78333 9.7 4.25 10.5C4.78333 11.3 5.47083 11.9167 6.3125 12.35C7.15417 12.7833 8.05 13 9 13ZM9 12C8.58333 12 8.22917 11.8542 7.9375 11.5625C7.64583 11.2708 7.5 10.9167 7.5 10.5C7.5 10.0833 7.64583 9.72917 7.9375 9.4375C8.22917 9.14583 8.58333 9 9 9C9.41667 9 9.77083 9.14583 10.0625 9.4375C10.3542 9.72917 10.5 10.0833 10.5 10.5C10.5 10.9167 10.3542 11.2708 10.0625 11.5625C9.77083 11.8542 9.41667 12 9 12Z" />
			</>
		),
	},
});
export const IconVision = svgIcon({
	default: {
		element: (
			<path d="M254-337q-43 0-76.5-26.5T136-432l-23-112-40 3-7-71q71-6 121-9t89-3q32 0 71.5 1.5T418-608q15 7 29.5 13.5T479-588q16 0 30.5-7t28.5-13q32-14 76-15t78-1q43 0 96 2.5t107 7.5l-7 72-38-3-25 113q-8 42-41 68.5T708-337h-62q-42 0-74-25.5T530-428l-22-87h-55l-22 87q-10 40-42 65.5T315-337h-61Zm-48-109q4 17 17 27.5t30 10.5h61q17 0 30-10t17-26l25-100q-25-5-55-6t-55-1q-20 0-45.5.5T185-548l21 102Zm393 2q4 16 17 26t30 10h61q17 0 30-10.5t17-27.5l20-103q-19-1-41-1h-41q-27 0-59.5 1t-58.5 5l25 100Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconWatch = svgIcon({
	default: {
		element: (
			<path d="M441-792h78-78Zm0 624h78-78Zm-57 72-48-192q-44-33-70-82.5T240-480q0-60 26.5-109.5T338-672l46-192h192l46 192q45 33 71.5 82.5T720-480q0 60-26 109.5T624-288L576-96H384Zm96-216q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm-59-400q14-4 29-6t30-2q15 0 29.5 2t28.5 6l-19-80h-78l-20 80Zm20 544h78l21-80q-14 4-29 6t-31 2q-16 0-30.5-2t-28.5-6l20 80Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconWarning = svgIcon({
	default: {
		element: (
			<path d="m48-144 432-720 432 720H48Zm431.79-120q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-384h72v-192h-72v192Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconWarningOutline = svgIcon({
	default: {
		element: (
			<path d="m48-144 432-720 432 720H48Zm127-72h610L480-724 175-216Zm304.79-48q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5ZM444-384h72v-192h-72v192Zm36-86Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconWidget = svgIcon({
	default: {
		element: (
			<path d="M636-432 432-636l204-204 203 204-203 204Zm-492-96v-288h288v288H144Zm384 384v-288h288v288H528Zm-384 0v-288h288v288H144Zm72-456h144v-144H216v144Zm420 66 101-102-101-102-102 102 102 102Zm-36 318h144v-144H600v144Zm-384 0h144v-144H216v144Zm144-384Zm174-36ZM360-360Zm240 0Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconYellowBlue = svgIcon({
	default: {
		element: (
			<g fill="none">
				<path
					fill="#0E1B8F"
					d="M21,10.4142136 L21,20 C21,20.5522847 20.5522847,21 20,21 L10.4142136,21 C9.86192881,21 9.41421356,20.5522847 9.41421356,20 C9.41421356,19.7347835 9.5195704,19.4804296 9.70710678,19.2928932 L19.2928932,9.70710678 C19.6834175,9.31658249 20.3165825,9.31658249 20.7071068,9.70710678 C20.8946432,9.89464316 21,10.1489971 21,10.4142136 Z"
				/>
				<rect
					width="3"
					height="21"
					x="10.495"
					y="1.495"
					fill="#B8860B"
					rx="1.5"
					transform="rotate(45 11.995 11.995)"
				/>
			</g>
		),
	},
});
export const IconZoomIn = svgIcon({
	default: {
		element: (
			<path d="M765-144 526-384q-30 23-65.79 35.5-35.79 12.5-76.18 12.5Q284-336 214-406t-70-170q0-100 70-170t170-70q100 0 170 70t70 170.03q0 40.39-12.5 76.18Q599-464 577-434l239 239-51 51ZM384-408q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm-36-60v-72h-72v-72h72v-72h72v72h72v72h-72v72h-72Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconZoomOut = svgIcon({
	default: {
		element: (
			<path d="M765-144 526-384q-30 23-65.79 35.5-35.79 12.5-76.18 12.5Q284-336 214-406t-70-170q0-100 70-170t170-70q100 0 170 70t70 170.03q0 40.39-12.5 76.18Q599-464 577-434l239 239-51 51ZM384-408q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm-96-132v-72h192v72H288Z" />
		),
		viewBox: GOOGLE_MATERIAL_VIEWBOX,
	},
});
export const IconActionLog = svgIcon({
	default: {
		element: (
			<path d="M8.7125 16.7125C8.90417 16.5208 9 16.2833 9 16C9 15.7167 8.90417 15.4792 8.7125 15.2875C8.52083 15.0958 8.28333 15 8 15C7.71667 15 7.47917 15.0958 7.2875 15.2875C7.09583 15.4792 7 15.7167 7 16C7 16.2833 7.09583 16.5208 7.2875 16.7125C7.47917 16.9042 7.71667 17 8 17C8.28333 17 8.52083 16.9042 8.7125 16.7125ZM8.7125 12.7125C8.90417 12.5208 9 12.2833 9 12C9 11.7167 8.90417 11.4792 8.7125 11.2875C8.52083 11.0958 8.28333 11 8 11C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13C8.28333 13 8.52083 12.9042 8.7125 12.7125ZM8.7125 8.7125C8.90417 8.52083 9 8.28333 9 8C9 7.71667 8.90417 7.47917 8.7125 7.2875C8.52083 7.09583 8.28333 7 8 7C7.71667 7 7.47917 7.09583 7.2875 7.2875C7.09583 7.47917 7 7.71667 7 8C7 8.28333 7.09583 8.52083 7.2875 8.7125C7.47917 8.90417 7.71667 9 8 9C8.28333 9 8.52083 8.90417 8.7125 8.7125ZM11 17H17V15H11V17ZM11 13H17V11H11V13ZM11 9H17V7H11V9ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z" />
		),
	},
});
export const IconActivityPlan = svgIcon({
	default: {
		element: (
			<path d="M16.1667 20L15 18.8211L16.3125 17.4737L15 16.1474L16.1667 14.9474L17.5 16.2947L18.8125 14.9474L20 16.1474L18.6667 17.4737L20 18.8211L18.8125 20L17.5 18.6737L16.1667 20ZM7.5 18.3158C7.73611 18.3158 7.93403 18.2351 8.09375 18.0737C8.25347 17.9123 8.33333 17.7123 8.33333 17.4737C8.33333 17.2351 8.25347 17.0351 8.09375 16.8737C7.93403 16.7123 7.73611 16.6316 7.5 16.6316C7.26389 16.6316 7.06597 16.7123 6.90625 16.8737C6.74653 17.0351 6.66667 17.2351 6.66667 17.4737C6.66667 17.7123 6.74653 17.9123 6.90625 18.0737C7.06597 18.2351 7.26389 18.3158 7.5 18.3158ZM7.5 20C6.80556 20 6.21528 19.7544 5.72917 19.2632C5.24306 18.7719 5 18.1754 5 17.4737C5 16.7719 5.24306 16.1754 5.72917 15.6842C6.21528 15.193 6.80556 14.9474 7.5 14.9474C8.01389 14.9474 8.48264 15.0912 8.90625 15.3789C9.32986 15.6667 9.63889 16.0561 9.83333 16.5474C10.375 16.393 10.816 16.0912 11.1562 15.6421C11.4965 15.193 11.6667 14.6807 11.6667 14.1053V10.7368C11.6667 9.57193 12.0729 8.57895 12.8854 7.75789C13.6979 6.93684 14.6806 6.52632 15.8333 6.52632H16.7917L15.4792 5.2L16.6667 4L20 7.36842L16.6667 10.7368L15.4792 9.5579L16.7917 8.21053H15.8333C15.1389 8.21053 14.5486 8.45614 14.0625 8.94737C13.5764 9.4386 13.3333 10.0351 13.3333 10.7368V14.1053C13.3333 15.1298 13.0069 16.0316 12.3542 16.8105C11.7014 17.5895 10.875 18.0702 9.875 18.2526C9.70833 18.7719 9.40625 19.193 8.96875 19.5158C8.53125 19.8386 8.04167 20 7.5 20ZM6.16667 9.89474L5 8.71579L6.3125 7.36842L5 6.04211L6.16667 4.84211L7.5 6.18947L8.8125 4.84211L10 6.04211L8.66667 7.36842L10 8.71579L8.8125 9.89474L7.5 8.56842L6.16667 9.89474Z" />
		),
	},
});
export const IconAdsBudgetAnalysis = svgIcon({
	default: {
		element: (
			<path d="M8.00016 0.0195312C7.32633 0.0195312 6.65295 0.235 6.11995 0.666667H4.01579L4.77881 4.81901C3.53412 5.94475 1.3335 8.3508 1.3335 11.3333C1.3335 12.668 1.73919 13.7284 2.54053 14.4844L2.73324 14.6667H13.2671L13.4598 14.4844C14.2605 13.7277 14.6668 12.668 14.6668 11.3333C14.6668 8.35368 12.4675 5.9472 11.2228 4.82031L11.9858 0.666667H9.88037C9.34737 0.235 8.674 0.0195312 8.00016 0.0195312ZM8.00016 1.34896C8.42383 1.34896 8.84695 1.50223 9.16162 1.8099L9.35693 2H10.3843L10.0171 4H5.98324L5.61605 2H6.64339L6.8387 1.8099C7.15337 1.50223 7.5765 1.34896 8.00016 1.34896ZM6.22803 5.33333H9.7736C10.4936 5.90733 13.3335 8.35933 13.3335 11.3333C13.3335 12.1887 13.131 12.846 12.7163 13.3333H8.34912V12.7253C8.55512 12.6993 9.71761 12.5084 9.71761 11.0924C9.71761 9.14245 7.61408 9.51568 7.61475 8.31901C7.61475 7.63368 7.94708 7.61198 8.07308 7.61198C8.23441 7.61198 8.57699 7.74279 8.57699 8.57813H9.72672C9.72672 6.97946 8.63363 6.73134 8.43896 6.69401V5.80859H7.82568V6.67839C7.61968 6.70439 6.46501 6.92114 6.46501 8.3138C6.46501 10.3458 8.56917 9.74426 8.56917 11.1003C8.56917 11.7789 8.12986 11.7956 8.04053 11.7956C7.95919 11.7956 7.42334 11.8381 7.42334 10.7995H6.2736C6.2736 12.5588 7.54975 12.6993 7.73975 12.7253V13.3333H3.28271C2.86871 12.846 2.66683 12.1887 2.66683 11.3333C2.66683 8.368 5.50803 5.90867 6.22803 5.33333Z" />
		),
		viewBox: "0 0 16 16",
	},
});
export const IconAdsLandingPageOptimization = svgIcon({
	default: {
		element: (
			<path d="M3.99984 1.33331C3.27033 1.33331 2.6665 1.93714 2.6665 2.66665V13.3333C2.6665 14.0628 3.27033 14.6666 3.99984 14.6666H8.6665V13.3333H3.99984V2.66665H8.6665V5.99998H11.9998V7.33331H13.3332V5.33331L9.33317 1.33331H3.99984ZM11.9998 8.66665L10.867 11.2005L7.99984 11.4661L10.1326 13.2669L9.53369 16L11.9998 14.5338L14.5337 16L13.7993 13.2669L15.9998 11.4661L13.1326 11.2005L11.9998 8.66665Z" />
		),
		viewBox: "0 0 16 16",
	},
});
export const IconAdsQualityAnalysis = svgIcon({
	default: {
		element: (
			<path d="M3.33333 2C2.60462 2 2 2.60462 2 3.33333V12.6667C2 13.3954 2.60462 14 3.33333 14H12.6667C13.3954 14 14 13.3954 14 12.6667V3.33333C14 2.60462 13.3954 2 12.6667 2H3.33333ZM3.33333 3.33333H12.6667V12.6667H3.33333V3.33333ZM8 4.18229L6.97005 6.61589L4.33333 6.84115L6.33333 8.57161L5.73307 11.151L8 9.78385L10.2669 11.151L9.66797 8.56771L11.6667 6.83594L9.02995 6.61068L8 4.18229Z" />
		),
		viewBox: "0 0 16 16",
	},
});
export const IconAutomation = svgIcon({
	default: {
		element: (
			<path d="M7.39989 17.25C6.69989 17.8333 5.97072 18.1 5.21239 18.05C4.45406 18 3.79156 17.7417 3.22489 17.275C2.65822 16.8083 2.27072 16.1958 2.06239 15.4375C1.85405 14.6792 1.99155 13.9 2.47489 13.1L4.34989 10C3.93322 9.63333 3.60406 9.19167 3.36239 8.675C3.12072 8.15833 2.99989 7.6 2.99989 7C2.99989 5.9 3.39155 4.95833 4.17489 4.175C4.95822 3.39167 5.89989 3 6.99989 3C8.09989 3 9.04155 3.39167 9.82489 4.175C10.6082 4.95833 10.9999 5.9 10.9999 7C10.9999 8.1 10.6082 9.04167 9.82489 9.825C9.04155 10.6083 8.09989 11 6.99989 11C6.84989 11 6.69989 10.9917 6.54989 10.975C6.39989 10.9583 6.25822 10.9333 6.12489 10.9L4.19989 14.15C4.01656 14.45 3.95822 14.7458 4.02489 15.0375C4.09156 15.3292 4.23322 15.5667 4.44989 15.75C4.66656 15.9333 4.92489 16.0375 5.22489 16.0625C5.52489 16.0875 5.81656 15.9833 6.09989 15.75L16.5999 6.725C17.2999 6.14167 18.0332 5.87917 18.7999 5.9375C19.5666 5.99583 20.2332 6.25833 20.7999 6.725C21.3666 7.19167 21.7499 7.80417 21.9499 8.5625C22.1499 9.32083 22.0082 10.1 21.5249 10.9L19.6499 14C20.0666 14.3667 20.3957 14.8083 20.6374 15.325C20.8791 15.8417 20.9999 16.4 20.9999 17C20.9999 18.1 20.6082 19.0417 19.8249 19.825C19.0416 20.6083 18.0999 21 16.9999 21C15.8999 21 14.9582 20.6083 14.1749 19.825C13.3916 19.0417 12.9999 18.1 12.9999 17C12.9999 15.9 13.3916 14.9583 14.1749 14.175C14.9582 13.3917 15.8999 13 16.9999 13C17.1499 13 17.2957 13.0083 17.4374 13.025C17.5791 13.0417 17.7166 13.0667 17.8499 13.1L19.7999 9.85C19.9832 9.55 20.0416 9.25417 19.9749 8.9625C19.9082 8.67083 19.7666 8.43333 19.5499 8.25C19.3332 8.06667 19.0749 7.9625 18.7749 7.9375C18.4749 7.9125 18.1832 8.01667 17.8999 8.25L7.39989 17.25ZM8.41239 8.4125C8.80406 8.02083 8.99989 7.55 8.99989 7C8.99989 6.45 8.80406 5.97917 8.41239 5.5875C8.02072 5.19583 7.54989 5 6.99989 5C6.44989 5 5.97906 5.19583 5.58739 5.5875C5.19572 5.97917 4.99989 6.45 4.99989 7C4.99989 7.55 5.19572 8.02083 5.58739 8.4125C5.97906 8.80417 6.44989 9 6.99989 9C7.54989 9 8.02072 8.80417 8.41239 8.4125ZM18.4124 18.4125C18.8041 18.0208 18.9999 17.55 18.9999 17C18.9999 16.45 18.8041 15.9792 18.4124 15.5875C18.0207 15.1958 17.5499 15 16.9999 15C16.4499 15 15.9791 15.1958 15.5874 15.5875C15.1957 15.9792 14.9999 16.45 14.9999 17C14.9999 17.55 15.1957 18.0208 15.5874 18.4125C15.9791 18.8042 16.4499 19 16.9999 19C17.5499 19 18.0207 18.8042 18.4124 18.4125Z" />
		),
	},
});
export const IconProductBehaviorTracking = svgIcon({
	default: {
		element: (
			<path d="M4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V16H4V20H8V22H4ZM2 8V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H8V4H4V8H2ZM11 18.9C9.46667 18.6667 8.15833 18.0083 7.075 16.925C5.99167 15.8417 5.33333 14.5333 5.1 13H7.1C7.3 13.9833 7.75417 14.8292 8.4625 15.5375C9.17083 16.2458 10.0167 16.7 11 16.9V18.9ZM5.1 11C5.33333 9.46667 5.99167 8.15417 7.075 7.0625C8.15833 5.97083 9.46667 5.31667 11 5.1V7.1C10.0167 7.3 9.17083 7.75417 8.4625 8.4625C7.75417 9.17083 7.3 10.0167 7.1 11H5.1ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.4333 10.1958 10.9583 10.5875 10.575C10.9792 10.1917 11.45 10 12 10C12.5667 10 13.0417 10.1917 13.425 10.575C13.8083 10.9583 14 11.4333 14 12C14 12.55 13.8083 13.0208 13.425 13.4125C13.0417 13.8042 12.5667 14 12 14ZM13 18.9V16.9C13.9833 16.7 14.8292 16.2458 15.5375 15.5375C16.2458 14.8292 16.7 13.9833 16.9 13H18.9C18.6833 14.5333 18.0292 15.8417 16.9375 16.925C15.8458 18.0083 14.5333 18.6667 13 18.9ZM16.9 11C16.7 10.0167 16.2458 9.17083 15.5375 8.4625C14.8292 7.75417 13.9833 7.3 13 7.1V5.1C14.5333 5.33333 15.8458 5.99167 16.9375 7.075C18.0292 8.15833 18.6833 9.46667 18.9 11H16.9ZM16 22V20H20V16H22V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H16ZM20 8V4H16V2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V8H20Z" />
		),
	},
});
export const IconProductBehaviourMaps = svgIcon({
	default: {
		element: (
			<path d="M12.9 21.95C12.75 21.9833 12.6 22 12.45 22H12C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12V12.45C22 12.6 21.9833 12.75 21.95 12.9L20 12.3V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H12.3L12.9 21.95ZM20.525 22.5L16.25 18.225L15 22L12 12L22 15L18.225 16.25L22.5 20.525L20.525 22.5Z" />
		),
	},
});
export const IconCookie = svgIcon({
	default: {
		element: (
			<path d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.75 2.24167 9.52501 2.725 8.32501C3.20833 7.12501 3.88333 6.05417 4.75 5.11251C5.61667 4.17084 6.65833 3.41251 7.875 2.83751C9.09167 2.26251 10.425 1.97501 11.875 1.97501C12.225 1.97501 12.5833 1.99167 12.95 2.02501C13.3167 2.05834 13.6917 2.11667 14.075 2.20001C13.925 2.95001 13.975 3.65834 14.225 4.32501C14.475 4.99167 14.85 5.54584 15.35 5.98751C15.85 6.42917 16.4458 6.73334 17.1375 6.90001C17.8292 7.06667 18.5417 7.02501 19.275 6.77501C18.8417 7.75834 18.9042 8.70001 19.4625 9.60001C20.0208 10.5 20.85 10.9667 21.95 11C21.9667 11.1833 21.9792 11.3542 21.9875 11.5125C21.9958 11.6708 22 11.8417 22 12.025C22 13.3917 21.7375 14.6792 21.2125 15.8875C20.6875 17.0958 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM10.5 10C10.9167 10 11.2708 9.85417 11.5625 9.56251C11.8542 9.27084 12 8.91667 12 8.50001C12 8.08334 11.8542 7.72917 11.5625 7.43751C11.2708 7.14584 10.9167 7.00001 10.5 7.00001C10.0833 7.00001 9.72917 7.14584 9.4375 7.43751C9.14583 7.72917 9 8.08334 9 8.50001C9 8.91667 9.14583 9.27084 9.4375 9.56251C9.72917 9.85417 10.0833 10 10.5 10ZM8.5 15C8.91667 15 9.27083 14.8542 9.5625 14.5625C9.85417 14.2708 10 13.9167 10 13.5C10 13.0833 9.85417 12.7292 9.5625 12.4375C9.27083 12.1458 8.91667 12 8.5 12C8.08333 12 7.72917 12.1458 7.4375 12.4375C7.14583 12.7292 7 13.0833 7 13.5C7 13.9167 7.14583 14.2708 7.4375 14.5625C7.72917 14.8542 8.08333 15 8.5 15ZM15 16C15.2833 16 15.5208 15.9042 15.7125 15.7125C15.9042 15.5208 16 15.2833 16 15C16 14.7167 15.9042 14.4792 15.7125 14.2875C15.5208 14.0958 15.2833 14 15 14C14.7167 14 14.4792 14.0958 14.2875 14.2875C14.0958 14.4792 14 14.7167 14 15C14 15.2833 14.0958 15.5208 14.2875 15.7125C14.4792 15.9042 14.7167 16 15 16ZM12 20C14.0333 20 15.8375 19.3 17.4125 17.9C18.9875 16.5 19.85 14.7167 20 12.55C19.1667 12.1833 18.5125 11.6833 18.0375 11.05C17.5625 10.4167 17.2417 9.70834 17.075 8.92501C15.7917 8.74167 14.6917 8.19167 13.775 7.27501C12.8583 6.35834 12.2917 5.25834 12.075 3.97501C10.7417 3.94167 9.57083 4.18334 8.5625 4.70001C7.55417 5.21667 6.7125 5.87917 6.0375 6.68751C5.3625 7.49584 4.85417 8.37501 4.5125 9.32501C4.17083 10.275 4 11.1667 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z" />
		),
	},
});
export const IconCreditCard = svgIcon({
	default: {
		element: (
			<path d="M22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6ZM4 8H20V6H4V8ZM4 12V18H20V12H4Z" />
		),
	},
});
export const IconEvent = svgIcon({
	default: {
		element: (
			<path d="M8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22C10.6167 22 9.31667 21.7375 8.1 21.2125ZM17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675ZM7.75 16.25C6.58333 15.0833 6 13.6667 6 12C6 10.3333 6.58333 8.91667 7.75 7.75C8.91667 6.58333 10.3333 6 12 6C13.6667 6 15.0833 6.58333 16.25 7.75C17.4167 8.91667 18 10.3333 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18C10.3333 18 8.91667 17.4167 7.75 16.25ZM14.825 14.825C15.6083 14.0417 16 13.1 16 12C16 10.9 15.6083 9.95833 14.825 9.175C14.0417 8.39167 13.1 8 12 8C10.9 8 9.95833 8.39167 9.175 9.175C8.39167 9.95833 8 10.9 8 12C8 13.1 8.39167 14.0417 9.175 14.825C9.95833 15.6083 10.9 16 12 16C13.1 16 14.0417 15.6083 14.825 14.825ZM10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14C11.45 14 10.9792 13.8042 10.5875 13.4125Z" />
		),
	},
});
export const IconExit = svgIcon({
	default: {
		element: (
			<path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H12V21H5ZM16 17L14.625 15.55L17.175 13H9V11H17.175L14.625 8.45L16 7L21 12L16 17Z" />
		),
	},
});
export const IconExplore = svgIcon({
	default: {
		element: (
			<path d="M7.5 16.5L14.5 14.5L16.5 7.5L9.5 9.5L7.5 16.5ZM12 13.5C11.5833 13.5 11.2292 13.3542 10.9375 13.0625C10.6458 12.7708 10.5 12.4167 10.5 12C10.5 11.5833 10.6458 11.2292 10.9375 10.9375C11.2292 10.6458 11.5833 10.5 12 10.5C12.4167 10.5 12.7708 10.6458 13.0625 10.9375C13.3542 11.2292 13.5 11.5833 13.5 12C13.5 12.4167 13.3542 12.7708 13.0625 13.0625C12.7708 13.3542 12.4167 13.5 12 13.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z" />
		),
	},
});
export const IconFacebook = svgIcon({
	default: {
		element: (
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.66667 14.6666H6V9.33331H4V6.66665H6V4.66665C6 3.78259 6.35119 2.93475 6.97631 2.30962C7.60143 1.6845 8.44928 1.33331 9.33333 1.33331H11.3333V3.99998H9.33333C9.15652 3.99998 8.98695 4.07022 8.86193 4.19524C8.7369 4.32027 8.66667 4.48984 8.66667 4.66665V6.66665H11.3333L10.6667 9.33331H8.66667V14.6666Z"
			/>
		),
		viewBox: "0 0 16 16",
	},
});
export const IconFingerprint = svgIcon({
	default: {
		element: (
			<path d="M12.025 4.47499C13.7917 4.47499 15.4584 4.85416 17.025 5.61249C18.5917 6.37083 19.9 7.46666 20.95 8.89999C21.0667 9.04999 21.1042 9.18333 21.0625 9.29999C21.0209 9.41666 20.95 9.51666 20.85 9.59999C20.75 9.68333 20.6334 9.72083 20.5 9.71249C20.3667 9.70416 20.25 9.63333 20.15 9.49999C19.2334 8.19999 18.0542 7.20416 16.6125 6.51249C15.1709 5.82083 13.6417 5.47499 12.025 5.47499C10.4084 5.47499 8.8917 5.82083 7.47503 6.51249C6.05836 7.20416 4.88336 8.19999 3.95003 9.49999C3.85003 9.64999 3.73336 9.73333 3.60003 9.74999C3.4667 9.76666 3.35003 9.73333 3.25003 9.64999C3.13336 9.56666 3.06253 9.46249 3.03753 9.33749C3.01253 9.21249 3.05003 9.08333 3.15003 8.94999C4.18336 7.53333 5.4792 6.43333 7.03753 5.64999C8.59586 4.86666 10.2584 4.47499 12.025 4.47499ZM12.025 6.82499C14.275 6.82499 16.2084 7.57499 17.825 9.07499C19.4417 10.575 20.25 12.4333 20.25 14.65C20.25 15.4833 19.9542 16.1792 19.3625 16.7375C18.7709 17.2958 18.05 17.575 17.2 17.575C16.35 17.575 15.6209 17.2958 15.0125 16.7375C14.4042 16.1792 14.1 15.4833 14.1 14.65C14.1 14.1 13.8959 13.6375 13.4875 13.2625C13.0792 12.8875 12.5917 12.7 12.025 12.7C11.4584 12.7 10.9709 12.8875 10.5625 13.2625C10.1542 13.6375 9.95003 14.1 9.95003 14.65C9.95003 16.2667 10.4292 17.6167 11.3875 18.7C12.3459 19.7833 13.5834 20.5417 15.1 20.975C15.25 21.025 15.35 21.1083 15.4 21.225C15.45 21.3417 15.4584 21.4667 15.425 21.6C15.3917 21.7167 15.325 21.8167 15.225 21.9C15.125 21.9833 15 22.0083 14.85 21.975C13.1167 21.5417 11.7 20.6792 10.6 19.3875C9.50003 18.0958 8.95003 16.5167 8.95003 14.65C8.95003 13.8167 9.25003 13.1167 9.85003 12.55C10.45 11.9833 11.175 11.7 12.025 11.7C12.875 11.7 13.6 11.9833 14.2 12.55C14.8 13.1167 15.1 13.8167 15.1 14.65C15.1 15.2 15.3084 15.6625 15.725 16.0375C16.1417 16.4125 16.6334 16.6 17.2 16.6C17.7667 16.6 18.25 16.4125 18.65 16.0375C19.05 15.6625 19.25 15.2 19.25 14.65C19.25 12.7167 18.5417 11.0917 17.125 9.77499C15.7084 8.45833 14.0167 7.79999 12.05 7.79999C10.0834 7.79999 8.3917 8.45833 6.97503 9.77499C5.55836 11.0917 4.85003 12.7083 4.85003 14.625C4.85003 15.025 4.88753 15.525 4.96253 16.125C5.03753 16.725 5.2167 17.425 5.50003 18.225C5.55003 18.375 5.54586 18.5083 5.48753 18.625C5.4292 18.7417 5.33336 18.825 5.20003 18.875C5.0667 18.925 4.93753 18.9208 4.81253 18.8625C4.68753 18.8042 4.60003 18.7083 4.55003 18.575C4.30003 17.925 4.12086 17.2792 4.01253 16.6375C3.9042 15.9958 3.85003 15.3333 3.85003 14.65C3.85003 12.4333 4.6542 10.575 6.26253 9.07499C7.87086 7.57499 9.7917 6.82499 12.025 6.82499ZM12.025 2.02499C13.0917 2.02499 14.1334 2.15416 15.15 2.41249C16.1667 2.67083 17.15 3.04166 18.1 3.52499C18.25 3.60833 18.3375 3.70833 18.3625 3.82499C18.3875 3.94166 18.375 4.05833 18.325 4.17499C18.275 4.29166 18.1917 4.38333 18.075 4.44999C17.9584 4.51666 17.8167 4.50833 17.65 4.42499C16.7667 3.97499 15.8542 3.62916 14.9125 3.38749C13.9709 3.14583 13.0084 3.02499 12.025 3.02499C11.0584 3.02499 10.1084 3.13749 9.17503 3.36249C8.2417 3.58749 7.35003 3.94166 6.50003 4.42499C6.3667 4.50833 6.23336 4.52916 6.10003 4.48749C5.9667 4.44583 5.8667 4.35833 5.80003 4.22499C5.73336 4.09166 5.7167 3.97083 5.75003 3.86249C5.78336 3.75416 5.8667 3.65833 6.00003 3.57499C6.93336 3.07499 7.90836 2.69166 8.92503 2.42499C9.9417 2.15833 10.975 2.02499 12.025 2.02499ZM12.025 9.24999C13.575 9.24999 14.9084 9.77083 16.025 10.8125C17.1417 11.8542 17.7 13.1333 17.7 14.65C17.7 14.8 17.6542 14.9208 17.5625 15.0125C17.4709 15.1042 17.35 15.15 17.2 15.15C17.0667 15.15 16.95 15.1042 16.85 15.0125C16.75 14.9208 16.7 14.8 16.7 14.65C16.7 13.4 16.2375 12.3542 15.3125 11.5125C14.3875 10.6708 13.2917 10.25 12.025 10.25C10.7584 10.25 9.67086 10.6708 8.76253 11.5125C7.8542 12.3542 7.40003 13.4 7.40003 14.65C7.40003 16 7.63336 17.1458 8.10003 18.0875C8.5667 19.0292 9.25003 19.975 10.15 20.925C10.25 21.025 10.3 21.1417 10.3 21.275C10.3 21.4083 10.25 21.525 10.15 21.625C10.05 21.725 9.93336 21.775 9.80003 21.775C9.6667 21.775 9.55003 21.725 9.45003 21.625C8.4667 20.5917 7.71253 19.5375 7.18753 18.4625C6.66253 17.3875 6.40003 16.1167 6.40003 14.65C6.40003 13.1333 6.95003 11.8542 8.05003 10.8125C9.15003 9.77083 10.475 9.24999 12.025 9.24999ZM12 14.15C12.15 14.15 12.2709 14.2 12.3625 14.3C12.4542 14.4 12.5 14.5167 12.5 14.65C12.5 15.9 12.95 16.925 13.85 17.725C14.75 18.525 15.8 18.925 17 18.925C17.1 18.925 17.2417 18.9167 17.425 18.9C17.6084 18.8833 17.8 18.8583 18 18.825C18.15 18.7917 18.2792 18.8125 18.3875 18.8875C18.4959 18.9625 18.5667 19.075 18.6 19.225C18.6334 19.3583 18.6084 19.475 18.525 19.575C18.4417 19.675 18.3334 19.7417 18.2 19.775C17.9 19.8583 17.6375 19.9042 17.4125 19.9125C17.1875 19.9208 17.05 19.925 17 19.925C15.5167 19.925 14.2292 19.425 13.1375 18.425C12.0459 17.425 11.5 16.1667 11.5 14.65C11.5 14.5167 11.5459 14.4 11.6375 14.3C11.7292 14.2 11.85 14.15 12 14.15Z" />
		),
	},
});
export const IconFolder = svgIcon({
	default: {
		element: (
			<path d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H10L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V8H11.175L9.175 6H4V18Z" />
		),
	},
});
export const IconInternalSearch = svgIcon({
	default: {
		element: (
			<path d="M18 13.25L20 15.25V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H4C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H9.5C9.36667 4.3 9.26667 4.62083 9.2 4.9625C9.13333 5.30417 9.08333 5.65 9.05 6H4V20H18V13.25ZM19.3 8.9L22.5 12.1L21.1 13.5L17.9 10.3C17.55 10.5 17.175 10.6667 16.775 10.8C16.375 10.9333 15.95 11 15.5 11C14.25 11 13.1875 10.5625 12.3125 9.6875C11.4375 8.8125 11 7.75 11 6.5C11 5.25 11.4375 4.1875 12.3125 3.3125C13.1875 2.4375 14.25 2 15.5 2C16.75 2 17.8125 2.4375 18.6875 3.3125C19.5625 4.1875 20 5.25 20 6.5C20 6.95 19.9333 7.375 19.8 7.775C19.6667 8.175 19.5 8.55 19.3 8.9ZM17.275 8.275C17.7583 7.79167 18 7.2 18 6.5C18 5.8 17.7583 5.20833 17.275 4.725C16.7917 4.24167 16.2 4 15.5 4C14.8 4 14.2083 4.24167 13.725 4.725C13.2417 5.20833 13 5.8 13 6.5C13 7.2 13.2417 7.79167 13.725 8.275C14.2083 8.75833 14.8 9 15.5 9C16.2 9 16.7917 8.75833 17.275 8.275ZM4 13.25V20V6V13V12.7V13.25Z" />
		),
	},
});
export const IconKey = svgIcon({
	default: {
		element: (
			<path d="M7 18C5.33333 18 3.91667 17.4167 2.75 16.25C1.58333 15.0833 1 13.6667 1 12C1 10.3333 1.58333 8.91667 2.75 7.75C3.91667 6.58333 5.33333 6 7 6C8.1 6 9.10833 6.275 10.025 6.825C10.9417 7.375 11.6667 8.1 12.2 9H23V15H21V18H15V15H12.2C11.6667 15.9 10.9417 16.625 10.025 17.175C9.10833 17.725 8.1 18 7 18ZM7 16C8.1 16 8.98333 15.6625 9.65 14.9875C10.3167 14.3125 10.7167 13.65 10.85 13H17V16H19V13H21V11H10.85C10.7167 10.35 10.3167 9.6875 9.65 9.0125C8.98333 8.3375 8.1 8 7 8C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM7 14C7.55 14 8.02083 13.8042 8.4125 13.4125C8.80417 13.0208 9 12.55 9 12C9 11.45 8.80417 10.9792 8.4125 10.5875C8.02083 10.1958 7.55 10 7 10C6.45 10 5.97917 10.1958 5.5875 10.5875C5.19583 10.9792 5 11.45 5 12C5 12.55 5.19583 13.0208 5.5875 13.4125C5.97917 13.8042 6.45 14 7 14Z" />
		),
	},
});
export const IconLabel = svgIcon({
	default: {
		element: (
			<path d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H15C15.3167 4 15.6167 4.07083 15.9 4.2125C16.1833 4.35417 16.4167 4.55 16.6 4.8L22 12L16.6 19.2C16.4167 19.45 16.1833 19.6458 15.9 19.7875C15.6167 19.9292 15.3167 20 15 20H4ZM4 18H15L19.5 12L15 6H4V18Z" />
		),
	},
});
export const IconLinkedIn = svgIcon({
	default: {
		element: (
			<>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.64464 6.51893V6.49011C8.63875 6.49978 8.6306 6.50944 8.62549 6.51893H8.64464Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.0995 14.0444H1.17404V5.24297H4.0995V14.0444ZM2.63677 4.04169H2.61744C1.63609 4.04169 1 3.3656 1 2.52054C1 1.65693 1.65468 1 2.65592 1C3.65738 1 4.2728 1.65693 4.29195 2.52054C4.29195 3.3656 3.65738 4.04169 2.63677 4.04169ZM14.6509 14.0444H11.7247V9.3356C11.7247 8.15291 11.3019 7.3456 10.2428 7.3456C9.43398 7.3456 8.95333 7.88917 8.74159 8.4157C8.66463 8.60378 8.64452 8.86523 8.64452 9.12897V14.0444H5.71772C5.71772 14.0444 5.75694 6.0687 5.71772 5.24301H8.64452V6.49019C9.03337 5.89184 9.72732 5.03638 11.2818 5.03638C13.2075 5.03638 14.6509 6.294 14.6509 8.99723V14.0444Z"
				/>
			</>
		),
		viewBox: "0 0 16 16",
	},
});
export const IconScan = svgIcon({
	default: {
		element: (
			<path d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V17H6V20H18V17H20V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM4 11V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V11H18V9H13V4H6V11H4ZM1 15V13H23V15H1Z" />
		),
	},
});
export const IconSitesProgress = svgIcon({
	default: {
		element: (
			<path d="M3.5 21.5L2 20L9.5 12.5L13.5 16.5L20.6 8.5L22 9.9L13.5 19.5L9.5 15.5L3.5 21.5ZM3.5 15.5L2 14L9.5 6.5L13.5 10.5L20.6 2.5L22 3.9L13.5 13.5L9.5 9.5L3.5 15.5Z" />
		),
	},
});
export const IconTopicIntelligence = svgIcon({
	default: {
		element: (
			<path d="M9.75 22L8.05 19H4.75L2.5 15L4.2 12L2.5 9L4.75 5H8.05L9.75 2H14.25L15.95 5H19.25L21.5 9L19.8 12L21.5 15L19.25 19H15.95L14.25 22H9.75ZM15.95 11H18.1L19.2 9L18.1 7H15.95L14.825 9L15.95 11ZM10.95 14H13.05L14.175 12L13.05 10H10.95L9.825 12L10.95 14ZM10.95 8H13.05L14.2 5.975L13.075 4H10.925L9.8 5.975L10.95 8ZM5.925 11H8.05L9.175 9L8.05 7H5.925L4.8 9L5.925 11ZM5.925 17H8.05L9.175 15L8.05 13H5.9L4.8 15L5.925 17ZM10.925 20H13.075L14.2 18.025L13.05 16H10.95L9.8 18.025L10.925 20ZM15.95 17H18.075L19.2 15L18.075 13H15.95L14.825 15L15.95 17Z" />
		),
	},
});
export const IconUpgradeCrown = svgIcon({
	default: {
		element: (
			<path d="M5 20V18H19V20H5ZM5 16.5L3.725 8.475C3.69167 8.475 3.65417 8.47917 3.6125 8.4875C3.57083 8.49583 3.53333 8.5 3.5 8.5C3.08333 8.5 2.72917 8.35417 2.4375 8.0625C2.14583 7.77083 2 7.41667 2 7C2 6.58333 2.14583 6.22917 2.4375 5.9375C2.72917 5.64583 3.08333 5.5 3.5 5.5C3.91667 5.5 4.27083 5.64583 4.5625 5.9375C4.85417 6.22917 5 6.58333 5 7C5 7.11667 4.9875 7.225 4.9625 7.325C4.9375 7.425 4.90833 7.51667 4.875 7.6L8 9L11.125 4.725C10.9417 4.59167 10.7917 4.41667 10.675 4.2C10.5583 3.98333 10.5 3.75 10.5 3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5C13.5 3.75 13.4417 3.98333 13.325 4.2C13.2083 4.41667 13.0583 4.59167 12.875 4.725L16 9L19.125 7.6C19.0917 7.51667 19.0625 7.425 19.0375 7.325C19.0125 7.225 19 7.11667 19 7C19 6.58333 19.1458 6.22917 19.4375 5.9375C19.7292 5.64583 20.0833 5.5 20.5 5.5C20.9167 5.5 21.2708 5.64583 21.5625 5.9375C21.8542 6.22917 22 6.58333 22 7C22 7.41667 21.8542 7.77083 21.5625 8.0625C21.2708 8.35417 20.9167 8.5 20.5 8.5C20.4667 8.5 20.4292 8.49583 20.3875 8.4875C20.3458 8.47917 20.3083 8.475 20.275 8.475L19 16.5H5ZM6.7 14.5H17.3L17.95 10.325L15.325 11.475L12 6.9L8.675 11.475L6.05 10.325L6.7 14.5Z" />
		),
	},
});
